// industryMarkdown/utils/injectStyles.ts
var isInjected = false;
function injectHighlightStyles() {
  if (isInjected || typeof document === "undefined") {
    return;
  }
  const existingStyle = document.getElementById("themed-markdown-highlight-css");
  if (existingStyle) {
    isInjected = true;
    return;
  }
  const css = `
pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em
}
code.hljs {
  padding: 3px 5px
}

.hljs {
  color: #abb2bf;
  background: #282c34
}
.hljs-comment,
.hljs-quote {
  color: #5c6370;
  font-style: italic
}
.hljs-doctag,
.hljs-keyword,
.hljs-formula {
  color: #c678dd
}
.hljs-section,
.hljs-name,
.hljs-selector-tag,
.hljs-deletion,
.hljs-subst {
  color: #e06c75
}
.hljs-literal {
  color: #56b6c2
}
.hljs-string,
.hljs-regexp,
.hljs-addition,
.hljs-attribute,
.hljs-meta .hljs-string {
  color: #98c379
}
.hljs-attr,
.hljs-variable,
.hljs-template-variable,
.hljs-type,
.hljs-selector-class,
.hljs-selector-attr,
.hljs-selector-pseudo,
.hljs-number {
  color: #d19a66
}
.hljs-symbol,
.hljs-bullet,
.hljs-link,
.hljs-meta,
.hljs-selector-id,
.hljs-title {
  color: #61aeee
}
.hljs-built_in,
.hljs-title.class_,
.hljs-class .hljs-title {
  color: #e6c07b
}
.hljs-emphasis {
  font-style: italic
}
.hljs-strong {
  font-weight: bold
}
.hljs-link {
  text-decoration: underline
}`;
  const styleElement = document.createElement("style");
  styleElement.id = "themed-markdown-highlight-css";
  styleElement.textContent = css;
  document.head.appendChild(styleElement);
  isInjected = true;
}
injectHighlightStyles();

// node_modules/@principal-ade/industry-theme/dist/esm/index.js
import React, { createContext, useContext, useState, useEffect } from "react";
import React2 from "react";
var landingPageTheme = {
  space: [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 64, 80, 100, 128],
  fonts: {
    body: 'Inter, "Geist Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    heading: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    monospace: '"SF Mono", Monaco, Inconsolata, "Fira Code", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.2,
    tight: 1.05,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px", "1400px"],
  sizes: [16, 32, 64, 128, 200, 240, 256, 300, 512, 740, 768, 820, 900, 1024, 1200, 1400, 1536],
  radii: [0, 2, 4, 6, 7, 8, 9, 10, 12, 14, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0 4px 12px rgba(0, 194, 255, 0.4)",
    "0 6px 24px rgba(0, 194, 255, 0.1)",
    "0 8px 32px rgba(0, 0, 0, 0.4)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50, 1000],
  colors: {
    text: "#ffffff",
    background: "#000000",
    primary: "#00C2FF",
    secondary: "#0098CC",
    accent: "#0066FF",
    highlight: "#001d26",
    muted: "#1a1a1a",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    info: "#2196f3",
    border: "#002733",
    backgroundSecondary: "#0a1628",
    backgroundTertiary: "#0f1c2e",
    backgroundLight: "#00080a",
    backgroundHover: "#00131a",
    surface: "#000000",
    textSecondary: "#d1d5db",
    textTertiary: "#9ca3af",
    textMuted: "#6b7280",
    highlightBg: "#403b0f",
    highlightBorder: "#80761e",
    textOnPrimary: "#000000"
  },
  buttons: {
    primary: {
      color: "#000000",
      bg: "#00C2FF",
      borderWidth: 0,
      padding: "8px 20px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#00D9FF"
      }
    },
    secondary: {
      color: "#00C2FF",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "#003a4d",
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#00131a",
        borderColor: "#00C2FF"
      }
    },
    ghost: {
      color: "#00C2FF",
      bg: "transparent",
      borderWidth: 0,
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 500,
      cursor: "pointer",
      "&:hover": {
        color: "#00D9FF",
        bg: "#00131a"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "#ffffff"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body",
      color: "text"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 4
    },
    secondary: {
      bg: "#000a0d",
      border: "1px solid",
      borderColor: "#002733",
      borderRadius: 4
    }
  }
};
var landingPageLightTheme = {
  ...landingPageTheme,
  colors: {
    text: "#1a1a1a",
    background: "#ffffff",
    primary: "#0098CC",
    secondary: "#00C2FF",
    accent: "#0066FF",
    highlight: "#e6f5fa",
    muted: "#f0f0f0",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    info: "#2196f3",
    border: "#cceaf5",
    backgroundSecondary: "#f8f9fa",
    backgroundTertiary: "#e9ecef",
    backgroundLight: "#f7fcfd",
    backgroundHover: "#f2fafc",
    surface: "#ffffff",
    textSecondary: "#555555",
    textTertiary: "#888888",
    textMuted: "#aaaaaa",
    highlightBg: "#fff9c4",
    highlightBorder: "#fff389",
    textOnPrimary: "#ffffff"
  },
  buttons: {
    primary: {
      color: "#ffffff",
      bg: "#0098CC",
      borderWidth: 0,
      padding: "8px 20px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#007aa8"
      }
    },
    secondary: {
      color: "#0098CC",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "#b2e0f0",
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#f2fafc",
        borderColor: "#0098CC"
      }
    },
    ghost: {
      color: "#0098CC",
      bg: "transparent",
      borderWidth: 0,
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 500,
      cursor: "pointer",
      "&:hover": {
        color: "#007aa8",
        bg: "#f2fafc"
      }
    }
  }
};
var regalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Crimson Text", "Georgia", "Times New Roman", serif',
    monospace: '"Fira Code", "SF Mono", Monaco, Inconsolata, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.25,
    relaxed: 1.75
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#f1e8dc",
    background: "#1a1f2e",
    primary: "#d4a574",
    secondary: "#e0b584",
    accent: "#c9b8a3",
    highlight: "#363338",
    muted: "#8b7968",
    success: "#5c8a72",
    warning: "#d4a574",
    error: "#a85751",
    info: "#d4a574",
    border: "#3f3a3c",
    backgroundSecondary: "#212738",
    backgroundTertiary: "#2d3446",
    backgroundLight: "#292a34",
    backgroundHover: "#363338",
    surface: "#212738",
    textSecondary: "#c9b8a3",
    textTertiary: "#8b7968",
    textMuted: "#8b7968",
    highlightBg: "#534724",
    highlightBorder: "#8c701a",
    textOnPrimary: "#1a1f2e"
  },
  buttons: {
    primary: {
      color: "background",
      bg: "primary",
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "text",
      bg: "muted",
      "&:hover": {
        bg: "backgroundSecondary"
      }
    },
    ghost: {
      color: "primary",
      bg: "transparent",
      "&:hover": {
        bg: "muted"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "background",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 2
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 2
    }
  }
};
var terminalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace',
    heading: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace',
    monospace: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.3,
    tight: 1.4,
    relaxed: 1.8
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    "0 2px 4px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px 0 rgba(0, 0, 0, 0.07)",
    "0 8px 12px 0 rgba(0, 0, 0, 0.08)",
    "0 16px 24px 0 rgba(0, 0, 0, 0.10)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#e4e4e4",
    background: "#0a0a0a",
    primary: "#66b3ff",
    secondary: "#80c4ff",
    accent: "#66ff99",
    highlight: "#18283d",
    muted: "#1a1a1a",
    success: "#66ff99",
    warning: "#ffcc66",
    error: "#ff6666",
    info: "#66b3ff",
    border: "#1a1a1a",
    backgroundSecondary: "#0f0f0f",
    backgroundTertiary: "#141414",
    backgroundLight: "#0d0d0d",
    backgroundHover: "#0d1520",
    surface: "#0f0f0f",
    textSecondary: "#b3b3b3",
    textTertiary: "#808080",
    textMuted: "#666666",
    highlightBg: "#40391e",
    highlightBorder: "#7f7530",
    textOnPrimary: "#ffffff"
  },
  modes: {
    light: {
      text: "#1a1a1a",
      background: "#ffffff",
      primary: "#0066cc",
      secondary: "#0052a3",
      accent: "#00cc88",
      highlight: "#e6f2ff",
      muted: "#f5f5f5",
      success: "#00cc88",
      warning: "#ffaa00",
      error: "#ff3333",
      info: "#0066cc",
      border: "#e6e6e6",
      backgroundSecondary: "#fafafa",
      backgroundTertiary: "#f5f5f5",
      backgroundLight: "#fafafa",
      backgroundHover: "#f5f9fd",
      surface: "#ffffff",
      textSecondary: "#666666",
      textTertiary: "#999999",
      textMuted: "#b3b3b3",
      highlightBg: "#fff9c4",
      highlightBorder: "#fff389"
    }
  },
  buttons: {
    primary: {
      color: "white",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "highlight"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 1
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 1
    }
  }
};
var matrixTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    heading: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    monospace: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.3,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 0 5px rgba(0, 216, 53, 0.15)",
    "0 0 10px rgba(0, 216, 53, 0.2)",
    "0 0 15px rgba(0, 216, 53, 0.25)",
    "0 0 20px rgba(0, 216, 53, 0.3)",
    "0 0 30px rgba(0, 216, 53, 0.4)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#a8a8a8",
    background: "#000000",
    primary: "#00d835",
    secondary: "#00a828",
    accent: "#00d835",
    highlight: "#002008",
    muted: "#0a0a0a",
    success: "#00d835",
    warning: "#d4a000",
    error: "#d63333",
    info: "#00a8d6",
    border: "#002b0b",
    backgroundSecondary: "#0a0a0a",
    backgroundTertiary: "#111111",
    backgroundLight: "#000602",
    backgroundHover: "#001104",
    surface: "#050505",
    textSecondary: "#808080",
    textTertiary: "#606060",
    textMuted: "#484848",
    highlightBg: "#00360d",
    highlightBorder: "#006c1b",
    textOnPrimary: "#000000"
  },
  buttons: {
    primary: {
      color: "black",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "highlight"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    }
  }
};
var matrixMinimalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    heading: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    monospace: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.3,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 2px rgba(0, 0, 0, 0.05)",
    "0 2px 4px rgba(0, 0, 0, 0.1)",
    "0 4px 8px rgba(0, 0, 0, 0.15)",
    "0 8px 16px rgba(0, 0, 0, 0.2)",
    "0 0 20px rgba(0, 216, 53, 0.1)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#a8a8a8",
    background: "#000000",
    primary: "#b8b8b8",
    secondary: "#909090",
    accent: "#00d835",
    highlight: "#001605",
    muted: "#0a0a0a",
    success: "#00d835",
    warning: "#d4a000",
    error: "#d63333",
    info: "#00a8d6",
    border: "#121212",
    backgroundSecondary: "#0a0a0a",
    backgroundTertiary: "#111111",
    backgroundLight: "#040404",
    backgroundHover: "#000b03",
    surface: "#050505",
    textSecondary: "#808080",
    textTertiary: "#606060",
    textMuted: "#484848",
    highlightBg: "#002b0b",
    highlightBorder: "#005615",
    textOnPrimary: "#000000"
  },
  buttons: {
    primary: {
      color: "black",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "backgroundHover"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    }
  }
};
var slateTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    monospace: '"Fira Code", "SF Mono", Monaco, Inconsolata, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.3,
    tight: 1.25,
    relaxed: 1.75
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.2)",
    "0 10px 15px -3px rgba(0, 0, 0, 0.2)",
    "0 20px 25px -5px rgba(0, 0, 0, 0.25)",
    "0 25px 50px -12px rgba(0, 0, 0, 0.3)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#9ca3af",
    background: "#1a1c1e",
    primary: "#d1d5db",
    secondary: "#6b7280",
    accent: "#f59e0b",
    highlight: "#353838",
    muted: "#2d3134",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    info: "#3b82f6",
    border: "#2d3034",
    backgroundSecondary: "#22252a",
    backgroundTertiary: "#2d3134",
    backgroundLight: "#202325",
    backgroundHover: "#27292c",
    surface: "#1f2124",
    textSecondary: "#e5e7eb",
    textTertiary: "#6b7280",
    textMuted: "#4b5563",
    highlightBg: "#513c19",
    highlightBorder: "#875d14",
    textOnPrimary: "#1a1c1e"
  },
  buttons: {
    primary: {
      color: "#1a1c1e",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "#9ca3af"
      }
    },
    secondary: {
      color: "#e5e7eb",
      bg: "secondary",
      borderWidth: 0,
      "&:hover": {
        bg: "#4b5563"
      }
    },
    ghost: {
      color: "textSecondary",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "textSecondary"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textTertiary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 3
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 3
    }
  }
};
function getMode(theme, mode) {
  if (!mode || !theme.modes || !theme.modes[mode]) {
    return theme.colors;
  }
  return {
    ...theme.colors,
    ...theme.modes[mode]
  };
}
var ThemeContext;
var getThemeContext = () => {
  if (typeof window !== "undefined") {
    const globalWindow = window;
    if (!globalWindow.__principlemd_theme_context__) {
      globalWindow.__principlemd_theme_context__ = createContext(undefined);
    }
    return globalWindow.__principlemd_theme_context__;
  } else {
    if (!ThemeContext) {
      ThemeContext = createContext(undefined);
    }
    return ThemeContext;
  }
};
var ThemeContextSingleton = getThemeContext();
var useTheme = () => {
  const context = useContext(ThemeContextSingleton);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
var ThemeProvider = ({
  children,
  theme: customTheme = theme,
  initialMode
}) => {
  const [mode, setMode] = useState(initialMode);
  const activeTheme = React.useMemo(() => {
    if (!mode || !customTheme.modes || !customTheme.modes[mode]) {
      return customTheme;
    }
    return {
      ...customTheme,
      colors: getMode(customTheme, mode)
    };
  }, [customTheme, mode]);
  useEffect(() => {
    if (!initialMode) {
      const savedMode = localStorage.getItem("principlemd-theme-mode");
      if (savedMode) {
        setMode(savedMode);
      }
    }
  }, [initialMode]);
  useEffect(() => {
    if (mode) {
      localStorage.setItem("principlemd-theme-mode", mode);
    } else {
      localStorage.removeItem("principlemd-theme-mode");
    }
  }, [mode]);
  const value = {
    theme: activeTheme,
    mode,
    setMode
  };
  return /* @__PURE__ */ React.createElement(ThemeContextSingleton.Provider, {
    value
  }, children);
};
var withTheme = (Component) => {
  return (props) => {
    const { theme: theme2 } = useTheme();
    return /* @__PURE__ */ React.createElement(Component, {
      ...props,
      theme: theme2
    });
  };
};
var theme = terminalTheme;
function scaleThemeFonts(theme2, scale) {
  const currentScale = theme2.fontScale || 1;
  const effectiveScale = scale / currentScale;
  return {
    ...theme2,
    fontSizes: theme2.fontSizes.map((size) => Math.round(size * effectiveScale)),
    fontScale: scale
  };
}
function increaseFontScale(theme2) {
  const currentScale = theme2.fontScale || 1;
  const newScale = Math.min(currentScale * 1.1, 2);
  return scaleThemeFonts(theme2, newScale);
}
function decreaseFontScale(theme2) {
  const currentScale = theme2.fontScale || 1;
  const newScale = Math.max(currentScale * 0.9, 0.5);
  return scaleThemeFonts(theme2, newScale);
}
function resetFontScale(theme2) {
  return scaleThemeFonts(theme2, 1);
}

// industryMarkdown/components/IndustryMarkdownSlide.tsx
import { defaultSchema } from "hast-util-sanitize";
import React13, { useRef as useRef7, useEffect as useEffect7, useLayoutEffect, useState as useState9, useMemo as useMemo2, useCallback } from "react";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import rehypeSlug from "rehype-slug";
import remarkGfm from "remark-gfm";

// industryMarkdown/utils/highlightSearchMatches.ts
function highlightSearchMatches(content, searchQuery) {
  if (!searchQuery || !searchQuery.trim()) {
    return content;
  }
  const escapedQuery = searchQuery.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const codeBlockRegex = /(```[\s\S]*?```|`[^`]+`)/g;
  const segments = [];
  let lastIndex = 0;
  let match;
  const codeMatches = [];
  while ((match = codeBlockRegex.exec(content)) !== null) {
    codeMatches.push({
      start: match.index,
      end: match.index + match[0].length,
      text: match[0]
    });
  }
  if (codeMatches.length === 0) {
    segments.push({ text: content, isCode: false });
  } else {
    codeMatches.forEach((codeMatch) => {
      if (lastIndex < codeMatch.start) {
        segments.push({
          text: content.slice(lastIndex, codeMatch.start),
          isCode: false
        });
      }
      segments.push({
        text: codeMatch.text,
        isCode: true
      });
      lastIndex = codeMatch.end;
    });
    if (lastIndex < content.length) {
      segments.push({
        text: content.slice(lastIndex),
        isCode: false
      });
    }
  }
  const highlightedSegments = segments.map((segment) => {
    if (segment.isCode) {
      return segment.text;
    }
    const regex = new RegExp(`(${escapedQuery})`, "gi");
    return segment.text.replace(regex, "<mark>$1</mark>");
  });
  return highlightedSegments.join("");
}

// node_modules/@principal-ade/markdown-utils/dist/esm/index.js
var CHUNK_TYPES = {
  MARKDOWN: "markdown_chunk",
  MERMAID: "mermaid_chunk",
  SLIDE: "slide_chunk",
  CODE: "code_chunk"
};
var MarkdownSourceType;
((MarkdownSourceType2) => {
  MarkdownSourceType2["WORKSPACE_FILE"] = "workspace_file";
  MarkdownSourceType2["REMOTE_FILE"] = "remote_file";
  MarkdownSourceType2["GITHUB_FILE"] = "github_file";
  MarkdownSourceType2["DRAFT"] = "draft";
  MarkdownSourceType2["GITHUB_ISSUE"] = "github_issue";
  MarkdownSourceType2["GITHUB_PULL_REQUEST"] = "github_pull_request";
  MarkdownSourceType2["GITHUB_GIST"] = "github_gist";
})(MarkdownSourceType ||= {});
function hashMarkdownString(str) {
  let hash = 0;
  for (let i = 0;i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
}
function parseMarkdownChunks(markdownContent, idPrefix, customParsers) {
  try {
    if (typeof markdownContent !== "string") {
      throw new Error("Invalid markdown content provided");
    }
    if (!markdownContent || markdownContent.trim() === "") {
      return [];
    }
    const chunks = [];
    const mermaidRegex = /^```mermaid\n([\s\S]*?)\n^```$/gm;
    let lastIndex = 0;
    let match;
    let partCounter = 0;
    while ((match = mermaidRegex.exec(markdownContent)) !== null) {
      partCounter++;
      if (match.index > lastIndex) {
        const mdContent = markdownContent.substring(lastIndex, match.index);
        if (mdContent.trim()) {
          chunks.push({
            type: CHUNK_TYPES.MARKDOWN,
            content: mdContent,
            id: `${idPrefix}-md-${partCounter}-${hashMarkdownString(mdContent)}`
          });
        }
      }
      partCounter++;
      const mermaidContent = match[1].trim();
      chunks.push({
        type: CHUNK_TYPES.MERMAID,
        content: mermaidContent,
        id: `${idPrefix}-mermaid-${partCounter}-${hashMarkdownString(mermaidContent)}`
      });
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < markdownContent.length) {
      partCounter++;
      const remainingMdContent = markdownContent.substring(lastIndex);
      if (remainingMdContent.trim()) {
        chunks.push({
          type: CHUNK_TYPES.MARKDOWN,
          content: remainingMdContent,
          id: `${idPrefix}-md-${partCounter}-${hashMarkdownString(remainingMdContent)}`
        });
      }
    }
    if (chunks.length === 0 && markdownContent.trim()) {
      chunks.push({
        type: CHUNK_TYPES.MARKDOWN,
        content: markdownContent,
        id: `${idPrefix}-md-only-${hashMarkdownString(markdownContent)}`
      });
    }
    if (customParsers && customParsers.length > 0) {
      let processedChunks = chunks;
      for (const parser of customParsers) {
        const newChunks = [];
        for (const chunk of processedChunks) {
          if (chunk.type === CHUNK_TYPES.MARKDOWN) {
            const parsed = parser(chunk.content, chunk.id);
            if (parsed.length > 0) {
              newChunks.push(...parsed);
            } else {
              newChunks.push(chunk);
            }
          } else {
            newChunks.push(chunk);
          }
        }
        processedChunks = newChunks;
      }
      return processedChunks;
    }
    return chunks;
  } catch (error) {
    console.error("Error in parseMarkdownChunks:", error);
    return markdownContent ? [
      {
        type: CHUNK_TYPES.MARKDOWN,
        content: markdownContent,
        id: `${idPrefix}-md-error-fallback-${hashMarkdownString(markdownContent)}`
      }
    ] : [];
  }
}
function hashMarkdownString2(str) {
  let hash = 0;
  for (let i = 0;i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
}
function extractSlideTitle(content) {
  const lines = content.split(`
`).filter((line) => line.trim());
  for (const line of lines) {
    const headingMatch = line.match(/^#+\s+(.+)$/);
    if (headingMatch) {
      return headingMatch[1].trim();
    }
  }
  if (lines.length > 0) {
    const firstLine = lines[0];
    return firstLine.length > 50 ? firstLine.substring(0, 47) + "..." : firstLine;
  }
  return "Untitled Slide";
}
function parseMarkdownIntoPresentation(markdownContent, repositoryInfo, customParsers) {
  const hasMultipleHeaders = detectMultipleHeaders(markdownContent);
  if (!hasMultipleHeaders) {
    const id = `slide-0-${hashMarkdownString2(markdownContent)}`;
    const chunks = parseMarkdownChunks(markdownContent, id, customParsers);
    return {
      slides: [
        {
          id,
          title: extractSlideTitle(markdownContent),
          location: {
            startLine: 0,
            endLine: markdownContent.split(`
`).length - 1,
            content: markdownContent
          },
          chunks
        }
      ],
      originalContent: markdownContent,
      repositoryInfo
    };
  }
  const lines = markdownContent.split(`
`);
  const slides = [];
  let currentSlideLines = [];
  let currentSlideStartLine = 0;
  let inCodeBlock = false;
  let codeBlockDelimiter = "";
  for (let i = 0;i < lines.length; i++) {
    const line = lines[i];
    if (line.trim().startsWith("```") || line.trim().startsWith("~~~")) {
      if (!inCodeBlock) {
        inCodeBlock = true;
        codeBlockDelimiter = line.trim().substring(0, 3);
      } else if (line.trim().startsWith(codeBlockDelimiter)) {
        inCodeBlock = false;
        codeBlockDelimiter = "";
      }
    }
    const isDelimiter = !inCodeBlock && line.trim().startsWith("#") && !line.trim().startsWith("###");
    if (isDelimiter && currentSlideLines.length > 0) {
      const slideContent = currentSlideLines.join(`
`);
      const slideId = `slide-${slides.length}-${hashMarkdownString2(slideContent)}`;
      const chunks = parseMarkdownChunks(slideContent, slideId, customParsers);
      slides.push({
        id: slideId,
        title: extractSlideTitle(slideContent),
        location: {
          startLine: currentSlideStartLine,
          endLine: i - 1,
          content: slideContent
        },
        chunks
      });
      currentSlideLines = [line];
      currentSlideStartLine = i;
    } else {
      currentSlideLines.push(line);
    }
  }
  if (currentSlideLines.length > 0) {
    const slideContent = currentSlideLines.join(`
`);
    const slideId = `slide-${slides.length}-${hashMarkdownString2(slideContent)}`;
    const chunks = parseMarkdownChunks(slideContent, slideId, customParsers);
    slides.push({
      id: slideId,
      title: extractSlideTitle(slideContent),
      location: {
        startLine: currentSlideStartLine,
        endLine: lines.length - 1,
        content: slideContent
      },
      chunks
    });
  }
  return {
    slides,
    originalContent: markdownContent,
    repositoryInfo
  };
}
function detectMultipleHeaders(markdownContent) {
  const lines = markdownContent.split(`
`);
  let h1Count = 0;
  let h2Count = 0;
  let inCodeBlock = false;
  let codeBlockDelimiter = "";
  for (const line of lines) {
    if (line.trim().startsWith("```") || line.trim().startsWith("~~~")) {
      if (!inCodeBlock) {
        inCodeBlock = true;
        codeBlockDelimiter = line.trim().substring(0, 3);
      } else if (line.trim().startsWith(codeBlockDelimiter)) {
        inCodeBlock = false;
        codeBlockDelimiter = "";
      }
    }
    if (!inCodeBlock) {
      if (line.trim().startsWith("#") && !line.trim().startsWith("###")) {
        if (!line.trim().startsWith("##")) {
          h1Count++;
        } else {
          h2Count++;
        }
      }
    }
  }
  const totalHeaders = h1Count + h2Count;
  return totalHeaders > 1;
}
function parseBashCommands(codeString) {
  const lines = codeString.split(`
`);
  const commands = [];
  let currentCommand = "";
  let commandStartLine = 0;
  let currentDescription = "";
  let inBackslashContinuation = false;
  for (let i = 0;i < lines.length; i++) {
    const rawLine = lines[i];
    const line = rawLine.trim();
    if (!line) {
      if (currentCommand && !inBackslashContinuation) {
        commands.push({
          command: currentCommand.trim(),
          description: currentDescription || undefined,
          line: commandStartLine + 1
        });
        currentCommand = "";
        currentDescription = "";
      }
      continue;
    }
    if (line.startsWith("#")) {
      if (!currentCommand) {
        currentDescription = line.substring(1).trim();
      }
      continue;
    }
    const endsWithBackslash = rawLine.trimEnd().endsWith("\\");
    if (endsWithBackslash || inBackslashContinuation) {
      if (!currentCommand) {
        commandStartLine = i;
      }
      if (endsWithBackslash) {
        const content = rawLine.trimEnd().slice(0, -1).trim();
        currentCommand += (currentCommand ? " " : "") + content;
        inBackslashContinuation = true;
      } else {
        currentCommand += (currentCommand ? " " : "") + line;
        inBackslashContinuation = false;
      }
      continue;
    }
    const isPipeContinuation = line.startsWith("|") || line.startsWith("&&") || line.startsWith("||");
    const previousLineEndsWithOperator = currentCommand && (currentCommand.trim().endsWith("|") || currentCommand.trim().endsWith("&&") || currentCommand.trim().endsWith("||") || currentCommand.trim().endsWith(";"));
    if (currentCommand && (isPipeContinuation || previousLineEndsWithOperator)) {
      currentCommand += (currentCommand.endsWith(" ") ? "" : " ") + line;
      continue;
    }
    if (currentCommand) {
      commands.push({
        command: currentCommand.trim(),
        description: currentDescription || undefined,
        line: commandStartLine + 1
      });
      currentDescription = "";
    }
    commandStartLine = i;
    currentCommand = line;
  }
  if (currentCommand) {
    commands.push({
      command: currentCommand.trim(),
      description: currentDescription || undefined,
      line: commandStartLine + 1
    });
  }
  return commands.filter((cmd) => cmd.command.length > 0);
}
function getCommandDisplayName(command, maxLength = 50) {
  if (command.description) {
    return command.description.length <= maxLength ? command.description : command.description.substring(0, maxLength - 3) + "...";
  }
  const cmdText = command.command;
  if (cmdText.length <= maxLength) {
    return cmdText;
  }
  return cmdText.substring(0, maxLength - 3) + "...";
}
function isRelativeUrl(url) {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return false;
  }
  if (url.startsWith("//")) {
    return false;
  }
  if (url.startsWith("data:")) {
    return false;
  }
  if (url.startsWith("blob:")) {
    return false;
  }
  return true;
}
function transformImageUrl(src, repositoryInfo) {
  if (!repositoryInfo || !isRelativeUrl(src)) {
    return src;
  }
  const { owner, repo, branch = "main", basePath = "" } = repositoryInfo;
  let fullPath;
  if (src.startsWith("/")) {
    fullPath = src.substring(1);
  } else {
    let cleanPath = src;
    if (cleanPath.startsWith("./")) {
      cleanPath = cleanPath.substring(2);
    }
    if (cleanPath.startsWith("../")) {
      console.warn("Relative parent directory navigation in image URLs is not fully supported:", src);
      cleanPath = cleanPath.replace(/^(\.\.\/)+/, "");
    }
    if (basePath) {
      const cleanBasePath = basePath.replace(/^\/+|\/+$/g, "");
      fullPath = `${cleanBasePath}/${cleanPath}`;
    } else {
      fullPath = cleanPath;
    }
  }
  const rawUrl = `https://raw.githubusercontent.com/${owner}/${repo}/${branch}/${fullPath}`;
  return rawUrl;
}
class SkillParseError extends Error {
  cause;
  constructor(message, cause) {
    super(message);
    this.cause = cause;
    this.name = "SkillParseError";
  }
}

class SkillValidationError extends Error {
  field;
  constructor(message, field) {
    super(message);
    this.field = field;
    this.name = "SkillValidationError";
  }
}
function extractFrontmatter(content) {
  const trimmed = content.trim();
  if (!trimmed.startsWith("---")) {
    throw new SkillParseError("SKILL.md must start with YAML frontmatter (---)");
  }
  const afterFirstDelimiter = trimmed.slice(3);
  const closingIndex = afterFirstDelimiter.indexOf(`
---`);
  if (closingIndex === -1) {
    throw new SkillParseError("SKILL.md frontmatter is not properly closed with ---");
  }
  const frontmatter = afterFirstDelimiter.slice(0, closingIndex).trim();
  const body = afterFirstDelimiter.slice(closingIndex + 4).trim();
  return { frontmatter, body };
}
function parseYamlFrontmatter(yaml) {
  const result = {};
  const lines = yaml.split(`
`);
  let currentKey = null;
  let currentObject = null;
  let currentList = null;
  for (let i = 0;i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith("#")) {
      continue;
    }
    const lineIndent = line.search(/\S/);
    if (trimmed.startsWith("- ")) {
      const value = trimmed.slice(2).trim();
      if (currentList) {
        currentList.push(value);
      }
      continue;
    }
    const colonIndex = line.indexOf(":");
    if (colonIndex > 0) {
      const key = line.slice(0, colonIndex).trim();
      const value = line.slice(colonIndex + 1).trim();
      if (lineIndent === 0) {
        currentKey = key;
        currentList = null;
        currentObject = null;
        if (!value) {
          if (i + 1 < lines.length) {
            const nextLine = lines[i + 1];
            const nextTrimmed = nextLine.trim();
            if (nextTrimmed.startsWith("- ")) {
              currentList = [];
              result[key] = currentList;
            } else if (nextLine.search(/\S/) > 0 && nextLine.includes(":")) {
              currentObject = {};
              result[key] = currentObject;
            }
          }
        } else {
          const cleanValue = value.replace(/^["']|["']$/g, "");
          result[key] = cleanValue;
        }
      } else if (lineIndent > 0 && currentObject) {
        const cleanValue = value.replace(/^["']|["']$/g, "");
        currentObject[key] = cleanValue;
      }
    }
  }
  return result;
}
function validateSkillMetadata(metadata) {
  if (!metadata.name || typeof metadata.name !== "string" || !metadata.name.trim()) {
    throw new SkillValidationError('Required field "name" is missing or empty', "name");
  }
  if (!metadata.description || typeof metadata.description !== "string" || !metadata.description.trim()) {
    throw new SkillValidationError('Required field "description" is missing or empty', "description");
  }
  if (metadata.license !== undefined && typeof metadata.license !== "string") {
    throw new SkillValidationError('Field "license" must be a string', "license");
  }
  if (metadata.compatibility !== undefined && typeof metadata.compatibility !== "string") {
    throw new SkillValidationError('Field "compatibility" must be a string', "compatibility");
  }
  if (metadata["allowed-tools"] !== undefined) {
    if (typeof metadata["allowed-tools"] === "string") {
      const toolsString = metadata["allowed-tools"];
      metadata["allowed-tools"] = toolsString.trim() ? toolsString.trim().split(/\s+/) : [];
    } else {
      throw new SkillValidationError('Field "allowed-tools" must be a space-delimited string', "allowed-tools");
    }
  }
  if (metadata.metadata !== undefined && (typeof metadata.metadata !== "object" || Array.isArray(metadata.metadata))) {
    throw new SkillValidationError('Field "metadata" must be an object', "metadata");
  }
  const skillMetadata = {
    name: metadata.name,
    description: metadata.description
  };
  if (metadata.license !== undefined) {
    skillMetadata.license = metadata.license;
  }
  if (metadata.compatibility !== undefined) {
    skillMetadata.compatibility = metadata.compatibility;
  }
  if (metadata["allowed-tools"] !== undefined) {
    skillMetadata["allowed-tools"] = metadata["allowed-tools"];
  }
  if (metadata.metadata !== undefined) {
    skillMetadata.metadata = metadata.metadata;
  }
  return skillMetadata;
}
function parseSkillMarkdown(content) {
  try {
    const { frontmatter, body } = extractFrontmatter(content);
    let rawMetadata;
    try {
      rawMetadata = parseYamlFrontmatter(frontmatter);
    } catch (error) {
      throw new SkillParseError("Failed to parse YAML frontmatter", error);
    }
    const metadata = validateSkillMetadata(rawMetadata);
    return {
      metadata,
      body,
      raw: content
    };
  } catch (error) {
    if (error instanceof SkillParseError || error instanceof SkillValidationError) {
      throw error;
    }
    throw new SkillParseError("Failed to parse SKILL.md", error);
  }
}

// industryMarkdown/utils/markdownUtils.ts
var parseMarkdownChunks2 = parseMarkdownChunks;

// industryMarkdown/components/IndustryHtmlModal.tsx
import React3, { useState as useState2 } from "react";
var useIndustryHtmlModal = () => {
  const [htmlModalOpen, setHtmlModalOpen] = useState2(false);
  const [htmlModalContent, setHtmlModalContent] = useState2("");
  const openHtmlModal = (content) => {
    setHtmlModalContent(content);
    setHtmlModalOpen(true);
  };
  const closeHtmlModal = () => {
    setHtmlModalOpen(false);
  };
  return { htmlModalOpen, htmlModalContent, openHtmlModal, closeHtmlModal };
};
function IndustryHtmlModal({ isOpen, onClose, htmlContent, theme: theme2 }) {
  if (!isOpen)
    return null;
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 50,
    padding: theme2.space[6]
  };
  const modalStyle = {
    backgroundColor: theme2.colors.background,
    borderRadius: theme2.radii[3],
    maxWidth: "900px",
    maxHeight: "90vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme2.colors.border}`,
    boxShadow: theme2.shadows[4]
  };
  const headerStyle = {
    padding: theme2.space[4],
    borderBottom: `1px solid ${theme2.colors.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme2.colors.backgroundSecondary
  };
  const contentStyle = {
    padding: theme2.space[5],
    overflow: "auto",
    flex: 1,
    backgroundColor: theme2.colors.background,
    color: theme2.colors.text
  };
  const titleStyle = {
    margin: 0,
    color: theme2.colors.text,
    fontSize: theme2.fontSizes[3],
    fontWeight: theme2.fontWeights.semibold,
    fontFamily: theme2.fonts.heading
  };
  const closeButtonStyle = {
    background: "transparent",
    border: "none",
    fontSize: theme2.fontSizes[5],
    cursor: "pointer",
    color: theme2.colors.textSecondary,
    padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
    borderRadius: theme2.radii[1],
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px"
  };
  const handleCloseButtonHover = (e) => {
    e.currentTarget.style.backgroundColor = theme2.colors.backgroundTertiary;
    e.currentTarget.style.color = theme2.colors.text;
  };
  const handleCloseButtonLeave = (e) => {
    e.currentTarget.style.backgroundColor = "transparent";
    e.currentTarget.style.color = theme2.colors.textSecondary;
  };
  return /* @__PURE__ */ React3.createElement("div", {
    style: overlayStyle,
    onClick: onClose
  }, /* @__PURE__ */ React3.createElement("div", {
    style: modalStyle,
    onClick: (e) => e.stopPropagation()
  }, /* @__PURE__ */ React3.createElement("div", {
    style: headerStyle
  }, /* @__PURE__ */ React3.createElement("h3", {
    style: titleStyle
  }, "HTML Preview"), /* @__PURE__ */ React3.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      onClose();
    },
    style: closeButtonStyle,
    onMouseEnter: handleCloseButtonHover,
    onMouseLeave: handleCloseButtonLeave,
    title: "Close",
    "aria-label": "Close modal"
  }, "×")), /* @__PURE__ */ React3.createElement("div", {
    style: contentStyle
  }, /* @__PURE__ */ React3.createElement("div", {
    dangerouslySetInnerHTML: { __html: htmlContent }
  }))));
}

// industryMarkdown/components/IndustryLazyMermaidDiagram.tsx
import { MoveRight } from "lucide-react";
import React6, { useEffect as useEffect3, useRef as useRef2, useState as useState4 } from "react";

// industryMarkdown/components/IndustryMermaidDiagram.tsx
import { Expand, Copy, Check } from "lucide-react";
import React5, { useEffect as useEffect2, useRef, useState as useState3 } from "react";
var getMermaidSync = () => {
  if (typeof window !== "undefined") {
    const mermaid = window.mermaid;
    if (mermaid) {
      return mermaid;
    }
  }
  return null;
};
function IndustryMermaidDiagram({
  code,
  id,
  theme: themeOverride,
  onCopyError,
  onError,
  rootMargin = "200px",
  isModalMode = false,
  isFullSlide = false,
  onExpandClick
}) {
  const theme2 = themeOverride ?? theme;
  const [errorDetails, setErrorDetails] = useState3(null);
  const [isIntersecting, setIsIntersecting] = useState3(false);
  const [hasRendered, setHasRendered] = useState3(false);
  const [containerElement, setContainerElement] = useState3(null);
  const [copiedError, setCopiedError] = useState3(false);
  const observerRef = useRef(null);
  const containerRef = React5.useCallback((node) => {
    setContainerElement(node);
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (node && !hasRendered) {
      if (isModalMode || typeof IntersectionObserver === "undefined") {
        setIsIntersecting(true);
        setHasRendered(true);
        return;
      }
      observerRef.current = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
        if (entry.isIntersecting && !hasRendered) {
          setHasRendered(true);
        }
      }, {
        rootMargin,
        threshold: 0.01
      });
      observerRef.current.observe(node);
    }
  }, [rootMargin, hasRendered, isModalMode]);
  useEffect2(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);
  useEffect2(() => {
    if (!hasRendered)
      return;
    const renderDiagram = async () => {
      const mermaid = getMermaidSync();
      if (!mermaid || !containerElement)
        return;
      try {
        const diagramBackground = isModalMode ? "transparent" : theme2.colors.backgroundSecondary || theme2.colors.background;
        const nodeBackground = theme2.colors.backgroundTertiary || theme2.colors.backgroundSecondary || theme2.colors.primary + "22";
        mermaid.initialize({
          startOnLoad: false,
          theme: "base",
          themeVariables: {
            primaryColor: nodeBackground,
            primaryTextColor: theme2.colors.text,
            primaryBorderColor: theme2.colors.border,
            secondaryColor: theme2.colors.secondary + "44",
            tertiaryColor: theme2.colors.accent + "44",
            background: diagramBackground,
            mainBkg: nodeBackground,
            secondBkg: theme2.colors.backgroundSecondary || theme2.colors.muted,
            tertiaryBkg: theme2.colors.backgroundTertiary || theme2.colors.accent + "22",
            altBackground: theme2.colors.muted,
            clusterBkg: theme2.colors.muted || theme2.colors.backgroundTertiary || theme2.colors.backgroundSecondary,
            clusterBorder: theme2.colors.border,
            titleColor: theme2.colors.text,
            lineColor: theme2.colors.border,
            secondaryBorderColor: theme2.colors.border,
            tertiaryBorderColor: theme2.colors.accent,
            textColor: theme2.colors.text,
            labelTextColor: theme2.colors.text,
            nodeTextColor: theme2.colors.text,
            edgeLabelBackground: theme2.colors.background,
            errorBkgColor: theme2.colors.error + "33",
            errorTextColor: theme2.colors.error
          },
          securityLevel: "loose",
          logLevel: "error"
        });
        containerElement.innerHTML = "";
        const elementId = `mermaid-${id}-${Date.now()}`;
        const { svg, bindFunctions } = await mermaid.render(elementId, code);
        containerElement.innerHTML = svg;
        if (bindFunctions) {
          bindFunctions(containerElement);
        }
        const svgElement = containerElement.querySelector("svg");
        if (svgElement) {
          svgElement.style.maxWidth = "none";
          svgElement.style.maxHeight = "none";
          svgElement.style.width = "auto";
          svgElement.style.height = "auto";
          svgElement.style.display = "block";
          svgElement.style.margin = "0 auto";
          if (!svgElement.getAttribute("preserveAspectRatio")) {
            svgElement.setAttribute("preserveAspectRatio", "xMidYMid meet");
          }
          if (isFullSlide) {
            svgElement.style.width = "100%";
            svgElement.style.height = "100%";
            svgElement.style.maxWidth = "100%";
            svgElement.style.maxHeight = "100%";
            svgElement.style.objectFit = "contain";
          } else if (isModalMode) {
            svgElement.style.width = "auto";
            svgElement.style.height = "auto";
            svgElement.style.maxWidth = "none";
            svgElement.style.maxHeight = "none";
            svgElement.style.minWidth = "auto";
            svgElement.style.minHeight = "auto";
            const viewBox = svgElement.getAttribute("viewBox");
            if (viewBox) {
              const [, , width, height] = viewBox.split(" ").map(Number);
              if (width && height) {
                svgElement.setAttribute("width", width.toString());
                svgElement.setAttribute("height", height.toString());
              }
            }
          } else {
            svgElement.style.maxHeight = "360px";
            svgElement.style.width = "100%";
            svgElement.style.maxWidth = "100%";
          }
        } else {
          console.warn("No SVG element found after mermaid render");
        }
        setErrorDetails(null);
        if (onError)
          onError(false);
      } catch (err) {
        console.error("Mermaid rendering error:", err);
        const errorMessage = err instanceof Error ? err.message : "Failed to render diagram";
        setErrorDetails({ code, message: errorMessage });
        if (onError)
          onError(true);
        if (containerElement) {
          containerElement.innerHTML = "";
        }
      }
    };
    renderDiagram();
  }, [hasRendered, code, id, theme2, containerElement, onError, isModalMode, isFullSlide]);
  const handleCopyError = async () => {
    if (!errorDetails)
      return;
    const errorText = `Mermaid Rendering Error:
${errorDetails.message}

Failed Mermaid Code:
\`\`\`mermaid
${errorDetails.code}
\`\`\``;
    try {
      await navigator.clipboard.writeText(errorText);
      setCopiedError(true);
      setTimeout(() => setCopiedError(false), 2000);
      if (onCopyError) {
        onCopyError(errorDetails.code, errorDetails.message);
      }
    } catch (err) {
      console.error("Failed to copy error to clipboard:", err);
    }
  };
  const containerStyle = isFullSlide ? {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: 0,
    padding: theme2.space[4],
    margin: 0,
    overflow: "auto"
  } : isModalMode ? {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: 0,
    padding: 0,
    margin: 0,
    overflow: "visible"
  } : {
    position: "relative",
    maxHeight: "400px",
    display: "block",
    backgroundColor: hasRendered ? theme2.colors.backgroundSecondary : theme2.colors.backgroundSecondary,
    border: hasRendered ? `1px solid ${theme2.colors.border}` : `1px solid ${theme2.colors.border}`,
    borderRadius: theme2.radii[2],
    padding: hasRendered ? theme2.space[3] : theme2.space[4],
    margin: `${theme2.space[4]}px 0`,
    overflowX: hasRendered ? "auto" : "visible",
    overflowY: hasRendered ? "auto" : "visible"
  };
  const placeholderStyle = {
    textAlign: "center",
    color: theme2.colors.textSecondary,
    fontSize: theme2.fontSizes[2],
    fontFamily: theme2.fonts.body
  };
  if (isModalMode || isFullSlide) {
    return /* @__PURE__ */ React5.createElement("div", {
      ref: containerRef,
      style: containerStyle,
      className: "mermaid-container"
    }, !hasRendered && /* @__PURE__ */ React5.createElement("div", {
      style: placeholderStyle
    }, /* @__PURE__ */ React5.createElement("div", null, "\uD83D\uDCCA Mermaid Diagram"), /* @__PURE__ */ React5.createElement("div", {
      style: { fontSize: theme2.fontSizes[1], marginTop: theme2.space[2], opacity: 0.7 }
    }, "Loading...")), errorDetails && /* @__PURE__ */ React5.createElement("div", {
      style: {
        padding: theme2.space[4],
        background: `${theme2.colors.error}22`,
        border: `1px solid ${theme2.colors.error}`,
        borderRadius: theme2.radii[2],
        color: theme2.colors.text,
        fontFamily: theme2.fonts.monospace,
        fontSize: theme2.fontSizes[1],
        maxWidth: "600px",
        margin: "0 auto"
      }
    }, /* @__PURE__ */ React5.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: theme2.space[2]
      }
    }, /* @__PURE__ */ React5.createElement("div", {
      style: { fontWeight: theme2.fontWeights.bold }
    }, "Failed to render Mermaid diagram"), /* @__PURE__ */ React5.createElement("button", {
      onClick: handleCopyError,
      style: {
        padding: theme2.space[1],
        backgroundColor: copiedError ? theme2.colors.success : theme2.colors.backgroundSecondary,
        border: `1px solid ${copiedError ? theme2.colors.success : theme2.colors.border}`,
        borderRadius: theme2.radii[1],
        color: copiedError ? theme2.colors.background : theme2.colors.text,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: theme2.space[1],
        fontSize: theme2.fontSizes[0],
        fontFamily: theme2.fonts.body,
        transition: "all 0.2s ease"
      },
      title: "Copy error details"
    }, copiedError ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Check, {
      size: 14
    }), "Copied") : /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Copy, {
      size: 14
    }), "Copy Error"))), /* @__PURE__ */ React5.createElement("div", {
      style: {
        fontSize: theme2.fontSizes[0],
        opacity: 0.8,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word"
      }
    }, errorDetails.message)));
  }
  return /* @__PURE__ */ React5.createElement("div", {
    style: { position: "relative", width: "100%" }
  }, /* @__PURE__ */ React5.createElement("div", {
    style: { position: "relative", width: "100%" }
  }, hasRendered && !isModalMode && onExpandClick && !errorDetails && /* @__PURE__ */ React5.createElement("div", {
    style: {
      position: "absolute",
      top: theme2.space[2],
      right: theme2.space[2],
      zIndex: 10,
      display: "flex",
      gap: theme2.space[1]
    }
  }, /* @__PURE__ */ React5.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      onExpandClick();
    },
    style: {
      padding: theme2.space[1],
      backgroundColor: theme2.colors.backgroundSecondary,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: theme2.colors.text,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "28px",
      height: "28px"
    },
    title: "View fullscreen"
  }, /* @__PURE__ */ React5.createElement(Expand, {
    size: 14
  }))), /* @__PURE__ */ React5.createElement("div", {
    ref: containerRef,
    style: containerStyle,
    className: "mermaid-container"
  }, !hasRendered && /* @__PURE__ */ React5.createElement("div", {
    style: placeholderStyle
  }, /* @__PURE__ */ React5.createElement("div", null, "\uD83D\uDCCA Mermaid Diagram"), /* @__PURE__ */ React5.createElement("div", {
    style: { fontSize: theme2.fontSizes[1], marginTop: theme2.space[2], opacity: 0.7 }
  }, isIntersecting ? "Loading..." : "Scroll to view")), errorDetails && /* @__PURE__ */ React5.createElement("div", {
    style: {
      padding: theme2.space[4],
      background: `${theme2.colors.error}22`,
      border: `1px solid ${theme2.colors.error}`,
      borderRadius: theme2.radii[2],
      color: theme2.colors.text,
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[1]
    }
  }, /* @__PURE__ */ React5.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: theme2.space[2]
    }
  }, /* @__PURE__ */ React5.createElement("div", {
    style: { fontWeight: theme2.fontWeights.bold }
  }, "Failed to render Mermaid diagram"), /* @__PURE__ */ React5.createElement("button", {
    onClick: handleCopyError,
    style: {
      padding: theme2.space[1],
      backgroundColor: copiedError ? theme2.colors.success : theme2.colors.backgroundSecondary,
      border: `1px solid ${copiedError ? theme2.colors.success : theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: copiedError ? theme2.colors.background : theme2.colors.text,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: theme2.space[1],
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.body,
      transition: "all 0.2s ease"
    },
    title: "Copy error details"
  }, copiedError ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Check, {
    size: 14
  }), "Copied") : /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Copy, {
    size: 14
  }), "Copy Error"))), /* @__PURE__ */ React5.createElement("div", {
    style: {
      fontSize: theme2.fontSizes[0],
      opacity: 0.8,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word"
    }
  }, errorDetails.message)))));
}

// industryMarkdown/components/IndustryLazyMermaidDiagram.tsx
function IndustryLazyMermaidDiagram({
  code,
  id,
  onCopyError,
  rootMargin = "200px",
  onShowInPanel,
  theme: themeOverride,
  onExpandClick
}) {
  const theme2 = themeOverride ?? theme;
  const [isIntersecting, setIsIntersecting] = useState4(false);
  const [hasRendered, setHasRendered] = useState4(false);
  const [isMounted, setIsMounted] = useState4(false);
  const [hasError, setHasError] = useState4(false);
  const containerRef = useRef2(null);
  useEffect3(() => {
    setIsMounted(true);
  }, []);
  useEffect3(() => {
    if (!isMounted)
      return;
    if (typeof IntersectionObserver === "undefined") {
      setIsIntersecting(true);
      setHasRendered(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
      if (entry.isIntersecting && !hasRendered) {
        setHasRendered(true);
      }
    }, {
      rootMargin,
      threshold: 0.01
    });
    const currentElement = containerRef.current;
    if (currentElement && observer) {
      observer.observe(currentElement);
    }
    return () => {
      if (currentElement && observer) {
        observer.unobserve(currentElement);
      }
    };
  }, [rootMargin, hasRendered, isMounted]);
  const getPlaceholderStyle = () => {
    return {
      position: "relative",
      margin: `${theme2.space[4]}px 0`,
      padding: theme2.space[5],
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[2],
      backgroundColor: theme2.colors.backgroundSecondary,
      minHeight: "200px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };
  };
  const getTextStyle = () => {
    return {
      textAlign: "center",
      fontSize: theme2.fontSizes[2],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace
    };
  };
  const getSecondaryTextStyle = () => {
    return {
      fontSize: theme2.fontSizes[1],
      marginTop: theme2.space[2],
      color: theme2.colors.textTertiary
    };
  };
  if (!isMounted) {
    return /* @__PURE__ */ React6.createElement("div", {
      style: getPlaceholderStyle()
    }, /* @__PURE__ */ React6.createElement("div", {
      style: getTextStyle()
    }, /* @__PURE__ */ React6.createElement("div", null, "\uD83D\uDCCA Mermaid Diagram"), /* @__PURE__ */ React6.createElement("div", {
      style: getSecondaryTextStyle()
    }, "Loading...")));
  }
  return /* @__PURE__ */ React6.createElement("div", {
    ref: containerRef,
    style: { position: "relative", width: "100%" }
  }, hasRendered && onShowInPanel && !hasError && /* @__PURE__ */ React6.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      const titleMatch = code.match(/^(?:%%\s*(.+)|(\w+)\s)/m);
      const title = titleMatch?.[1] || titleMatch?.[2] || "Diagram from Markdown";
      onShowInPanel(code, title);
    },
    style: {
      position: "absolute",
      top: theme2.space[2],
      right: theme2.space[2],
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      backgroundColor: theme2.colors.background,
      color: theme2.colors.text,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      fontSize: theme2.fontSizes[1],
      fontWeight: theme2.fontWeights.medium,
      cursor: "pointer",
      zIndex: 10,
      fontFamily: theme2.fonts.body,
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: theme2.space[1]
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.background;
    },
    title: "Show in diagram panel"
  }, /* @__PURE__ */ React6.createElement(MoveRight, {
    size: 14
  })), hasRendered ? /* @__PURE__ */ React6.createElement(IndustryMermaidDiagram, {
    code,
    id,
    onCopyError,
    onError: setHasError,
    theme: theme2,
    onExpandClick
  }) : /* @__PURE__ */ React6.createElement("div", {
    style: getPlaceholderStyle()
  }, /* @__PURE__ */ React6.createElement("div", {
    style: getTextStyle()
  }, /* @__PURE__ */ React6.createElement("div", null, "\uD83D\uDCCA Mermaid Diagram"), /* @__PURE__ */ React6.createElement("div", {
    style: getSecondaryTextStyle()
  }, isIntersecting ? "Loading..." : "Scroll to view"))));
}

// industryMarkdown/components/IndustryMarkdownComponents.tsx
import { Copy as Copy2, Monitor, FileText, Check as Check2 } from "lucide-react";
import React9, { useMemo, useState as useState6, useRef as useRef4 } from "react";

// industryMarkdown/utils/componentUtils.tsx
import React7 from "react";
var extractTextFromChildren = (children) => {
  if (typeof children === "string") {
    return children;
  }
  if (Array.isArray(children)) {
    return children.map(extractTextFromChildren).join("");
  }
  if (React7.isValidElement(children)) {
    const props = children.props;
    if (props.children) {
      return extractTextFromChildren(props.children);
    }
  }
  return "";
};
var LinkWithLoadingIndicator = ({ href, children, onClick, className }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(href, e);
    }
  };
  return /* @__PURE__ */ React7.createElement("a", {
    href,
    onClick: handleClick,
    className,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children);
};
// industryMarkdown/components/IndustryBashCommandDropdown.tsx
import { Play, ChevronDown } from "lucide-react";
import React8, { useState as useState5, useRef as useRef3, useEffect as useEffect4 } from "react";
var IndustryBashCommandDropdown = ({
  commands,
  allCommands,
  onRunCommand,
  darkMode: _darkMode,
  slideIdPrefix: _slideIdPrefix,
  theme: themeOverride
}) => {
  const [isOpen, setIsOpen] = useState5(false);
  const [isRunning, setIsRunning] = useState5(false);
  const dropdownRef = useRef3(null);
  const theme2 = themeOverride ?? theme;
  useEffect4(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleRunCommand = async (command) => {
    setIsRunning(true);
    setIsOpen(false);
    try {
      await onRunCommand(command);
    } finally {
      setIsRunning(false);
    }
  };
  const buttonStyle = {
    padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
    backgroundColor: isRunning ? theme2.colors.muted : theme2.colors.primary,
    color: theme2.colors.background,
    border: "none",
    borderRadius: theme2.radii[1],
    fontSize: theme2.fontSizes[1],
    cursor: isRunning ? "not-allowed" : "pointer",
    display: "flex",
    alignItems: "center",
    gap: theme2.space[2],
    opacity: isRunning ? 0.6 : 1,
    minWidth: "70px",
    justifyContent: "center",
    fontFamily: theme2.fonts.body,
    fontWeight: theme2.fontWeights.medium,
    transition: "all 0.2s ease"
  };
  const dropdownStyle = {
    position: "absolute",
    top: "100%",
    right: "0",
    backgroundColor: theme2.colors.background,
    border: `1px solid ${theme2.colors.border}`,
    borderRadius: theme2.radii[2],
    boxShadow: theme2.shadows[2],
    zIndex: 10,
    minWidth: "200px",
    maxWidth: "350px",
    maxHeight: "300px",
    overflow: "auto",
    marginTop: theme2.space[1]
  };
  const dropdownItemStyle = (isHovered) => ({
    padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
    cursor: "pointer",
    backgroundColor: isHovered ? theme2.colors.backgroundSecondary : "transparent",
    fontSize: theme2.fontSizes[1],
    color: theme2.colors.text,
    fontFamily: theme2.fonts.monospace,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    transition: "background-color 0.2s ease"
  });
  const hasMultipleCommands = commands.length > 1;
  const singleCommand = commands.length === 1 ? commands[0].command : allCommands;
  return /* @__PURE__ */ React8.createElement("div", {
    ref: dropdownRef,
    style: { position: "relative", display: "inline-block" }
  }, hasMultipleCommands ? /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement("button", {
    onClick: () => setIsOpen(!isOpen),
    disabled: isRunning,
    style: buttonStyle,
    onMouseEnter: (e) => {
      if (!isRunning) {
        e.currentTarget.style.backgroundColor = theme2.colors.secondary;
      }
    },
    onMouseLeave: (e) => {
      if (!isRunning) {
        e.currentTarget.style.backgroundColor = theme2.colors.primary;
      }
    }
  }, isRunning ? /* @__PURE__ */ React8.createElement("span", {
    style: { fontSize: theme2.fontSizes[1] }
  }, "...") : /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(Play, {
    size: 14
  }), "Run", /* @__PURE__ */ React8.createElement(ChevronDown, {
    size: 14
  }))), isOpen && /* @__PURE__ */ React8.createElement("div", {
    style: dropdownStyle
  }, /* @__PURE__ */ React8.createElement("div", {
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      borderBottom: `1px solid ${theme2.colors.border}`,
      fontWeight: theme2.fontWeights.semibold,
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.body
    }
  }, "Select command to run"), /* @__PURE__ */ React8.createElement("div", {
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      backgroundColor: theme2.colors.muted,
      cursor: "pointer",
      fontSize: theme2.fontSizes[1],
      fontWeight: theme2.fontWeights.medium,
      color: theme2.colors.text,
      fontFamily: theme2.fonts.body,
      transition: "background-color 0.2s ease"
    },
    onClick: () => handleRunCommand(allCommands),
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.muted;
    }
  }, "\uD83D\uDE80 Run all (", commands.length, " commands)"), commands.map((cmd, index) => {
    const [isHovered, setIsHovered] = useState5(false);
    return /* @__PURE__ */ React8.createElement("div", {
      key: index,
      style: dropdownItemStyle(isHovered),
      onClick: () => handleRunCommand(cmd.command),
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      title: cmd.command
    }, getCommandDisplayName(cmd));
  }))) : /* @__PURE__ */ React8.createElement("button", {
    onClick: () => handleRunCommand(singleCommand),
    disabled: isRunning,
    style: buttonStyle,
    onMouseEnter: (e) => {
      if (!isRunning) {
        e.currentTarget.style.backgroundColor = theme2.colors.secondary;
      }
    },
    onMouseLeave: (e) => {
      if (!isRunning) {
        e.currentTarget.style.backgroundColor = theme2.colors.primary;
      }
    }
  }, isRunning ? /* @__PURE__ */ React8.createElement("span", {
    style: { fontSize: theme2.fontSizes[1] }
  }, "...") : /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(Play, {
    size: 14
  }), "Run")));
};

// industryMarkdown/components/IndustryMarkdownComponents.tsx
var failedImageCache = new Set;
var isVideoUrl = (url, alt) => {
  const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi", ".mkv", ".m4v"];
  const lowercaseUrl = url.toLowerCase();
  if (videoExtensions.some((ext) => lowercaseUrl.includes(ext))) {
    return true;
  }
  if (alt) {
    const altLower = alt.toLowerCase();
    if (altLower.includes("video") || altLower.includes("demo") || altLower.includes("recording")) {
      return true;
    }
  }
  return false;
};
var OptimizedMarkdownMedia = React9.memo(({
  src,
  alt,
  repositoryInfo,
  theme: theme2,
  ...props
}) => {
  const transformedSrc = useMemo(() => {
    return transformImageUrl(src, repositoryInfo);
  }, [src, repositoryInfo]);
  const [hasErrored, setHasErrored] = useState6(() => failedImageCache.has(transformedSrc));
  const retryCount = useRef4(0);
  const mediaStyle = useMemo(() => ({
    maxWidth: "100%",
    height: "auto",
    display: "block",
    margin: `${theme2.space[3]}px auto`,
    borderRadius: theme2.radii[1],
    boxShadow: theme2.shadows[2]
  }), [theme2]);
  const handleLoad = () => {
    failedImageCache.delete(transformedSrc);
    setHasErrored(false);
    retryCount.current = 0;
  };
  const handleError = (e) => {
    retryCount.current += 1;
    failedImageCache.add(transformedSrc);
    setHasErrored(true);
    e.stopPropagation();
  };
  if (isVideoUrl(transformedSrc, alt)) {
    if (hasErrored) {
      return /* @__PURE__ */ React9.createElement("span", {
        style: {
          ...mediaStyle,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme2.colors.backgroundSecondary,
          color: theme2.colors.textSecondary,
          border: `1px solid ${theme2.colors.border}`,
          padding: theme2.space[4],
          minHeight: "200px"
        }
      }, "⚠️ Video failed to load: ", alt || transformedSrc);
    }
    return /* @__PURE__ */ React9.createElement("video", {
      controls: true,
      style: mediaStyle,
      onLoadedData: handleLoad,
      onError: handleError,
      title: alt,
      ...props
    }, /* @__PURE__ */ React9.createElement("source", {
      src: transformedSrc
    }), /* @__PURE__ */ React9.createElement("source", {
      src: transformedSrc,
      type: "video/mp4"
    }), /* @__PURE__ */ React9.createElement("source", {
      src: transformedSrc,
      type: "video/webm"
    }), "Your browser does not support the video tag.");
  }
  const handleImageError = (e) => {
    retryCount.current += 1;
    failedImageCache.add(transformedSrc);
    setHasErrored(true);
    e.stopPropagation();
  };
  if (hasErrored) {
    return /* @__PURE__ */ React9.createElement("span", {
      style: {
        ...mediaStyle,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme2.colors.backgroundSecondary,
        color: theme2.colors.textSecondary,
        border: `1px solid ${theme2.colors.border}`,
        minHeight: "50px",
        minWidth: "100px",
        fontSize: theme2.fontSizes[0],
        textAlign: "center",
        padding: `${theme2.space[2]}px`
      },
      title: `Failed to load image: ${transformedSrc}`
    }, "\uD83D\uDDBC️ Image unavailable", " ", alt && /* @__PURE__ */ React9.createElement("span", {
      style: { fontSize: theme2.fontSizes[0], opacity: 0.7 }
    }, "(", alt, ")"));
  }
  return /* @__PURE__ */ React9.createElement("img", {
    src: transformedSrc,
    alt,
    style: mediaStyle,
    onLoad: handleLoad,
    onError: handleImageError,
    ...props
  });
});
var createIndustryMarkdownComponents = ({
  theme: theme2,
  slideIdPrefix,
  slideIndex,
  onLinkClick,
  onCheckboxChange,
  checkedItems,
  setCheckedItems,
  openHtmlModal,
  openPlaceholderModal,
  handleRunBashCommand,
  enableHtmlPopout,
  slideHeaderMarginTopOverride,
  index,
  repositoryInfo,
  editable = false
}) => {
  const getLuminance = (hex) => {
    const rgb = hex.replace("#", "").match(/.{2}/g);
    if (!rgb)
      return 1;
    const [r, g, b] = rgb.map((x) => parseInt(x, 16) / 255);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  };
  const darkMode = getLuminance(theme2.colors.background) < 0.5;
  const headerStyles = {};
  if (index === 0) {
    headerStyles.marginTop = slideHeaderMarginTopOverride ? `${slideHeaderMarginTopOverride}px` : 0;
  }
  return {
    h1: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h1", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[5],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.bold,
        marginTop: theme2.space[4],
        marginBottom: theme2.space[4],
        fontFamily: theme2.fonts.heading,
        paddingBottom: theme2.space[2],
        borderBottom: `1px solid ${theme2.colors.border}`,
        ...headerStyles
      },
      ...props
    }, children),
    h2: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h2", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[4],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.bold,
        marginTop: theme2.space[4],
        marginBottom: theme2.space[3],
        fontFamily: theme2.fonts.heading,
        paddingBottom: theme2.space[2],
        borderBottom: `1px solid ${theme2.colors.border}`,
        ...headerStyles
      },
      ...props
    }, children),
    h3: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h3", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[3],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.semibold,
        marginTop: theme2.space[4],
        marginBottom: theme2.space[3],
        fontFamily: theme2.fonts.heading
      },
      ...props
    }, children),
    h4: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h4", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[2],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.semibold,
        marginTop: theme2.space[3],
        marginBottom: theme2.space[2],
        fontFamily: theme2.fonts.heading
      },
      ...props
    }, children),
    h5: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h5", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.semibold,
        marginTop: theme2.space[3],
        marginBottom: theme2.space[1],
        fontFamily: theme2.fonts.heading
      },
      ...props
    }, children),
    h6: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h6", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.medium,
        marginTop: theme2.space[3],
        marginBottom: theme2.space[1],
        fontFamily: theme2.fonts.heading
      },
      ...props
    }, children),
    p: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("p", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[2],
        lineHeight: theme2.lineHeights.body,
        marginBottom: theme2.space[3],
        fontFamily: theme2.fonts.body
      },
      ...props
    }, children),
    ul: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("ul", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[2],
        lineHeight: theme2.lineHeights.body,
        marginBottom: theme2.space[3],
        paddingLeft: theme2.space[5],
        listStyleType: "disc",
        fontFamily: theme2.fonts.body
      },
      ...props
    }, children),
    ol: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("ol", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[2],
        lineHeight: theme2.lineHeights.body,
        marginBottom: theme2.space[3],
        paddingLeft: theme2.space[5],
        listStyleType: "decimal",
        fontFamily: theme2.fonts.body
      },
      ...props
    }, children),
    li: ({ children, ...props }) => {
      const isTaskListItem = Array.isArray(children) && children.length > 0 && React9.isValidElement(children[0]) && children[0]?.props?.type === "checkbox";
      if (isTaskListItem) {
        const checkbox = children[0];
        const remainingChildren = children.slice(1);
        const labelContent = [];
        const nestedListElements = [];
        React9.Children.forEach(remainingChildren, (child) => {
          if (React9.isValidElement(child) && (child.type === "ul" || child.type === "ol")) {
            nestedListElements.push(child);
          } else {
            labelContent.push(child);
          }
        });
        const checked = checkbox?.props?.checked || false;
        const lineNumber = props.sourcePosition?.start?.line || props.node?.position?.start?.line || 1;
        const id = `${slideIdPrefix}-checkbox-${lineNumber}`;
        const isChecked = checkedItems[id] ?? checked;
        const handleChange = (e) => {
          e.stopPropagation();
          const newChecked = e.target.checked;
          setCheckedItems((prev) => ({
            ...prev,
            [id]: newChecked
          }));
          onCheckboxChange?.(slideIndex, lineNumber, newChecked);
        };
        return /* @__PURE__ */ React9.createElement("li", {
          style: {
            listStyle: "none",
            marginLeft: `-${theme2.space[5]}px`,
            marginBottom: theme2.space[3],
            paddingTop: theme2.space[1],
            color: theme2.colors.text,
            fontSize: theme2.fontSizes[2]
          },
          ...props
        }, /* @__PURE__ */ React9.createElement("div", {
          style: { display: "flex", alignItems: "flex-start" }
        }, /* @__PURE__ */ React9.createElement("input", {
          type: "checkbox",
          checked: isChecked,
          onChange: handleChange,
          onClick: (e) => e.stopPropagation(),
          disabled: !editable,
          style: {
            marginRight: theme2.space[2],
            marginTop: theme2.space[1],
            width: "16px",
            height: "16px",
            cursor: editable ? "pointer" : "default"
          },
          id
        }), /* @__PURE__ */ React9.createElement("label", {
          htmlFor: id,
          style: {
            flex: 1,
            cursor: editable ? "pointer" : "default",
            color: isChecked ? theme2.colors.textMuted : "inherit",
            lineHeight: theme2.lineHeights.relaxed
          }
        }, labelContent.length > 0 ? labelContent : null)), nestedListElements.length > 0 ? nestedListElements : null);
      }
      return /* @__PURE__ */ React9.createElement("li", {
        style: {
          marginBottom: theme2.space[2],
          paddingTop: theme2.space[1],
          color: theme2.colors.text,
          lineHeight: theme2.lineHeights.relaxed
        },
        ...props
      }, children);
    },
    table: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("div", {
      style: {
        overflowX: "auto",
        marginBottom: theme2.space[4],
        borderRadius: theme2.radii[2],
        border: `1px solid ${theme2.colors.border}`
      }
    }, /* @__PURE__ */ React9.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body
      },
      ...props
    }, children)),
    thead: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("thead", {
      style: {
        backgroundColor: theme2.colors.backgroundSecondary
      },
      ...props
    }, children),
    th: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("th", {
      style: {
        padding: theme2.space[3],
        textAlign: "left",
        fontWeight: theme2.fontWeights.semibold,
        borderBottom: `2px solid ${theme2.colors.border}`,
        color: theme2.colors.text
      },
      ...props
    }, children),
    td: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("td", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        color: theme2.colors.text
      },
      ...props
    }, children),
    a: ({ children, href, ...props }) => /* @__PURE__ */ React9.createElement(LinkWithLoadingIndicator, {
      href: href || "",
      onClick: onLinkClick ? (h, e) => onLinkClick(h, e) : undefined,
      className: props.className
    }, children),
    img: ({ src, alt, ...props }) => /* @__PURE__ */ React9.createElement(OptimizedMarkdownMedia, {
      src: src || "",
      alt: alt || "",
      repositoryInfo,
      theme: theme2,
      ...props
    }),
    picture: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("picture", {
      ...props
    }, children),
    video: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("video", {
      controls: true,
      style: {
        maxWidth: "100%",
        height: "auto",
        display: "block",
        margin: `${theme2.space[3]}px auto`,
        borderRadius: theme2.radii[1],
        boxShadow: theme2.shadows[2]
      },
      ...props
    }, children),
    source: ({ srcset, srcSet, ...props }) => {
      const srcsetValue = srcset || srcSet;
      const transformedSrcset = useMemo(() => {
        if (!srcsetValue || !repositoryInfo)
          return srcsetValue;
        return srcsetValue.split(",").map((src) => {
          const trimmed = src.trim();
          const parts = trimmed.split(/\s+/);
          const url = parts[0];
          const descriptors = parts.slice(1).join(" ");
          const transformedUrl = transformImageUrl(url, repositoryInfo);
          return descriptors ? `${transformedUrl} ${descriptors}` : transformedUrl;
        }).join(", ");
      }, [srcsetValue, repositoryInfo]);
      return /* @__PURE__ */ React9.createElement("source", {
        srcSet: transformedSrcset,
        ...props
      });
    },
    code: ({ node, className, children, ...props }) => {
      const hasLanguageClass = className && (className.includes("language-") || className.includes("hljs"));
      const codeString = extractTextFromChildren(children);
      const matchLang = /language-(\w+)/.exec(className || "");
      const language = matchLang ? matchLang[1] : null;
      const [copied, setCopied] = useState6(false);
      let isInline;
      let isCodeBlock;
      const hasNewlines = codeString.includes(`
`);
      if (!className && !hasNewlines) {
        isInline = true;
        isCodeBlock = false;
      } else if (hasNewlines) {
        isInline = false;
        isCodeBlock = true;
      } else if (language === "text") {
        isInline = true;
        isCodeBlock = false;
      } else {
        isCodeBlock = hasLanguageClass || codeString.length > 50;
        const nodeWithParent = node;
        const isInsideParagraph = nodeWithParent?.parent?.tagName === "p" || nodeWithParent?.parent?.parent?.tagName === "p";
        isInline = !isCodeBlock || isInsideParagraph;
      }
      if (!isInline) {
        const language2 = matchLang ? matchLang[1] : "text";
        const isExecutable = (language2 === "bash" || language2 === "sh" || language2 === "shell") && handleRunBashCommand;
        const isHtml = (language2 === "html" || language2 === "htm") && enableHtmlPopout;
        const isPrompt = language2 === "prompt";
        const placeholderRegex = /\{\{([^}]+)\}\}/g;
        const placeholders = isPrompt ? [...codeString.matchAll(placeholderRegex)].map((match) => match[1].trim()) : [];
        const hasPlaceholders = placeholders.length > 0;
        const bashCommands = isExecutable ? parseBashCommands(codeString) : [];
        const containerStyle = isPrompt ? {
          position: "relative",
          backgroundColor: darkMode ? theme2.colors.backgroundTertiary : theme2.colors.highlight,
          border: `2px solid ${theme2.colors.accent}`,
          borderRadius: theme2.radii[2],
          overflow: "visible",
          boxShadow: theme2.shadows[2],
          marginTop: `${theme2.space[2]}px`,
          marginBottom: `${theme2.space[3]}px`
        } : {
          position: "relative",
          backgroundColor: theme2.colors.backgroundSecondary,
          borderRadius: theme2.radii[2],
          overflow: "hidden",
          border: `1px solid ${theme2.colors.border}`,
          marginTop: `${theme2.space[2]}px`,
          marginBottom: `${theme2.space[3]}px`
        };
        const headerStyle = isPrompt ? {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: `${theme2.space[3]}px ${theme2.space[4]}px`,
          backgroundColor: theme2.colors.muted,
          borderBottom: `2px solid ${theme2.colors.accent}`,
          fontSize: theme2.fontSizes[0],
          color: theme2.colors.accent
        } : {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
          backgroundColor: theme2.colors.backgroundTertiary,
          borderBottom: `1px solid ${theme2.colors.border}`,
          fontSize: theme2.fontSizes[0]
        };
        return /* @__PURE__ */ React9.createElement("div", {
          style: containerStyle
        }, /* @__PURE__ */ React9.createElement("div", {
          style: headerStyle
        }, /* @__PURE__ */ React9.createElement("span", {
          style: {
            fontFamily: theme2.fonts.monospace,
            fontWeight: isPrompt ? theme2.fontWeights.bold : theme2.fontWeights.body
          }
        }, isPrompt ? "\uD83D\uDCA1 Prompt" : language2), /* @__PURE__ */ React9.createElement("div", {
          style: { display: "flex", gap: `${theme2.space[2]}px` }
        }, /* @__PURE__ */ React9.createElement("button", {
          onClick: (e) => {
            e.stopPropagation();
            navigator.clipboard.writeText(codeString).then(() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            }).catch((err) => {
              console.error("Failed to copy:", err);
            });
          },
          style: {
            padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
            backgroundColor: copied ? theme2.colors.success + "22" : darkMode ? theme2.colors.backgroundTertiary : theme2.colors.backgroundSecondary,
            color: copied ? theme2.colors.success : theme2.colors.textSecondary,
            border: `1px solid ${copied ? theme2.colors.success : theme2.colors.border}`,
            borderRadius: theme2.radii[1],
            fontSize: theme2.fontSizes[0],
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: `${theme2.space[1]}px`,
            transition: "all 0.15s ease-in-out"
          },
          title: copied ? "Copied!" : "Copy code to clipboard"
        }, copied ? /* @__PURE__ */ React9.createElement(Check2, {
          size: 14
        }) : /* @__PURE__ */ React9.createElement(Copy2, {
          size: 14
        }), copied ? "Copied!" : "Copy"), isExecutable && /* @__PURE__ */ React9.createElement(IndustryBashCommandDropdown, {
          commands: bashCommands,
          allCommands: codeString.trim(),
          onRunCommand: async (command) => {
            try {
              await handleRunBashCommand(command, {
                id: `${slideIdPrefix}-code-${Date.now()}`,
                showInTerminal: true
              });
            } catch (error) {
              console.error("Error running bash command:", error);
            }
          },
          slideIdPrefix,
          theme: theme2
        }), isHtml && /* @__PURE__ */ React9.createElement("button", {
          onClick: (e) => {
            e.stopPropagation();
            openHtmlModal(codeString);
          },
          style: {
            padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
            backgroundColor: theme2.colors.primary,
            color: "white",
            border: "none",
            borderRadius: theme2.radii[1],
            fontSize: theme2.fontSizes[0],
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: `${theme2.space[1]}px`
          },
          title: "Render HTML in modal"
        }, /* @__PURE__ */ React9.createElement(Monitor, {
          size: 14
        }), "Render HTML"), isPrompt && openPlaceholderModal && hasPlaceholders && /* @__PURE__ */ React9.createElement("button", {
          onClick: (e) => {
            e.stopPropagation();
            openPlaceholderModal(placeholders, codeString);
          },
          style: {
            padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
            backgroundColor: theme2.colors.accent,
            color: "white",
            border: "none",
            borderRadius: theme2.radii[1],
            fontSize: theme2.fontSizes[0],
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: `${theme2.space[1]}px`
          },
          title: "Fill placeholders and copy"
        }, /* @__PURE__ */ React9.createElement(FileText, {
          size: 14
        }), "Fill & Copy (", placeholders.length, ")"))), isPrompt ? /* @__PURE__ */ React9.createElement("div", {
          style: {
            margin: 0,
            padding: theme2.space[1],
            backgroundColor: "transparent",
            fontSize: theme2.fontSizes[1],
            lineHeight: theme2.lineHeights.body,
            fontFamily: theme2.fonts.body,
            overflow: "auto",
            color: theme2.colors.text
          }
        }, codeString.split(/(\{\{[^}]+\}\})/).map((part, index2) => {
          if (part.match(/^\{\{[^}]+\}\}$/)) {
            return /* @__PURE__ */ React9.createElement("span", {
              key: index2,
              style: {
                backgroundColor: theme2.colors.highlight,
                color: theme2.colors.primary,
                padding: `${theme2.space[0]}px ${theme2.space[1]}px`,
                borderRadius: theme2.radii[1],
                fontWeight: theme2.fontWeights.semibold,
                fontFamily: theme2.fonts.monospace,
                fontSize: theme2.fontSizes[1]
              }
            }, part);
          }
          return part;
        })) : /* @__PURE__ */ React9.createElement("pre", {
          style: {
            margin: 0,
            padding: theme2.space[1],
            backgroundColor: "transparent",
            overflow: "auto",
            fontSize: theme2.fontSizes[1],
            lineHeight: 1.2,
            fontFamily: theme2.fonts.monospace
          }
        }, /* @__PURE__ */ React9.createElement("code", {
          className,
          style: {
            lineHeight: "inherit",
            fontSize: "inherit",
            fontFamily: "inherit",
            display: "block"
          },
          ...props
        }, children)));
      }
      const cleanClassName = className?.replace(/hljs(-\w+)?/g, "")?.replace(/language-\w+/g, "")?.replace(/\s+/g, " ")?.trim();
      return /* @__PURE__ */ React9.createElement("code", {
        style: {
          color: theme2.colors.accent,
          fontSize: "0.875em",
          fontFamily: theme2.fonts.monospace,
          backgroundColor: "transparent",
          padding: 0,
          "--text-color": theme2.colors.accent
        },
        className: cleanClassName ? `inline-code ${cleanClassName}` : "inline-code",
        ...props
      }, children);
    }
  };
};

// industryMarkdown/components/IndustryMermaidModal.tsx
import React11, { useEffect as useEffect6, useRef as useRef6 } from "react";
import { createPortal } from "react-dom";

// industryMarkdown/components/IndustryZoomableMermaidDiagram.tsx
import React10, { useEffect as useEffect5, useRef as useRef5, useState as useState7 } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
function IndustryZoomableMermaidDiagram({
  code,
  id,
  theme: themeOverride,
  fitStrategy = "contain",
  padding = 0.9
}) {
  const theme2 = themeOverride ?? theme;
  const [calculatedScale, setCalculatedScale] = useState7(1);
  const [hasInitialized, setHasInitialized] = useState7(false);
  const containerRef = useRef5(null);
  const diagramRef = useRef5(null);
  const [isCalculating, setIsCalculating] = useState7(true);
  const transformRef = useRef5(null);
  useEffect5(() => {
    if (!containerRef.current || !diagramRef.current)
      return;
    const calculateOptimalScale = () => {
      const container = containerRef.current;
      const diagram = diagramRef.current;
      if (!container || !diagram)
        return;
      const svg = diagram.querySelector("svg");
      if (!svg) {
        setTimeout(calculateOptimalScale, 100);
        return;
      }
      let svgWidth, svgHeight;
      const viewBox = svg.getAttribute("viewBox");
      if (viewBox) {
        const [, , width, height] = viewBox.split(" ").map(Number);
        svgWidth = width;
        svgHeight = height;
      } else {
        const explicitWidth = svg.getAttribute("width");
        const explicitHeight = svg.getAttribute("height");
        if (explicitWidth && explicitHeight) {
          svgWidth = parseFloat(explicitWidth);
          svgHeight = parseFloat(explicitHeight);
        } else {
          const svgRect = svg.getBoundingClientRect();
          svgWidth = svgRect.width;
          svgHeight = svgRect.height;
        }
      }
      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;
      if (svgWidth <= 0 || svgHeight <= 0 || containerWidth <= 0 || containerHeight <= 0) {
        return;
      }
      let scale = 1;
      switch (fitStrategy) {
        case "width":
          scale = containerWidth * padding / svgWidth;
          break;
        case "height":
          scale = containerHeight * padding / svgHeight;
          break;
        case "contain":
        default:
          scale = Math.min(containerWidth * padding / svgWidth, containerHeight * padding / svgHeight);
          break;
      }
      scale = Math.min(Math.max(scale, 0.3), 3);
      setCalculatedScale(scale);
      setHasInitialized(true);
      setIsCalculating(false);
    };
    const resizeObserver = new ResizeObserver(() => {
      calculateOptimalScale();
    });
    resizeObserver.observe(containerRef.current);
    setTimeout(calculateOptimalScale, 100);
    setTimeout(calculateOptimalScale, 500);
    return () => {
      resizeObserver.disconnect();
    };
  }, [code, fitStrategy, padding]);
  useEffect5(() => {
    if (hasInitialized && transformRef.current) {
      const { centerView } = transformRef.current;
      centerView(calculatedScale, 0, "easeOut");
    }
  }, [hasInitialized, calculatedScale]);
  const buttonStyle = {
    padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
    marginRight: theme2.space[2],
    backgroundColor: theme2.colors.background,
    color: theme2.colors.text,
    border: `1px solid ${theme2.colors.border}`,
    borderRadius: theme2.radii[1],
    fontSize: theme2.fontSizes[2],
    fontWeight: theme2.fontWeights.medium,
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontFamily: theme2.fonts.body
  };
  const handleButtonHover = (e) => {
    e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
  };
  const handleButtonLeave = (e) => {
    e.currentTarget.style.backgroundColor = theme2.colors.background;
  };
  return /* @__PURE__ */ React10.createElement("div", {
    ref: containerRef,
    style: {
      width: "100%",
      height: "100%",
      position: "relative",
      backgroundColor: theme2.colors.background
    }
  }, /* @__PURE__ */ React10.createElement(TransformWrapper, {
    limitToBounds: true,
    doubleClick: { disabled: true },
    minScale: 0.1,
    maxScale: 10,
    initialScale: 1,
    initialPositionX: 0,
    initialPositionY: 0,
    centerOnInit: true,
    centerZoomedOut: true,
    alignmentAnimation: { disabled: true },
    zoomAnimation: { disabled: false, size: 0.2 }
  }, ({ centerView, instance }) => {
    transformRef.current = { centerView, instance };
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement("div", {
      style: {
        position: "absolute",
        top: theme2.space[3],
        right: theme2.space[3],
        zIndex: 10,
        display: "flex",
        gap: theme2.space[2]
      }
    }, /* @__PURE__ */ React10.createElement("button", {
      onClick: () => {
        centerView(calculatedScale, 200, "easeOut");
      },
      style: buttonStyle,
      onMouseEnter: handleButtonHover,
      onMouseLeave: handleButtonLeave,
      title: "Reset view"
    }, "⟲"), isCalculating && /* @__PURE__ */ React10.createElement("span", {
      style: {
        padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
        fontSize: theme2.fontSizes[1],
        color: theme2.colors.textMuted,
        fontFamily: theme2.fonts.body
      }
    }, "Optimizing view...")), /* @__PURE__ */ React10.createElement(TransformComponent, {
      wrapperStyle: {
        width: "100%",
        height: "100%",
        backgroundColor: theme2.colors.background,
        overflow: "hidden"
      },
      contentStyle: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /* @__PURE__ */ React10.createElement("div", {
      ref: diagramRef,
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%"
      }
    }, /* @__PURE__ */ React10.createElement(IndustryMermaidDiagram, {
      code,
      id,
      isModalMode: true,
      theme: theme2
    }))));
  }));
}

// industryMarkdown/components/IndustryMermaidModal.tsx
function IndustryMermaidModal({
  isOpen,
  onClose,
  mermaidCode,
  theme: theme2
}) {
  const modalRef = useRef6(null);
  useEffect6(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };
  if (!isOpen) {
    return null;
  }
  const modalContent = /* @__PURE__ */ React11.createElement("div", {
    onClick: handleBackdropClick,
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 50,
      padding: theme2.space[4]
    }
  }, /* @__PURE__ */ React11.createElement("div", {
    ref: modalRef,
    onClick: (e) => e.stopPropagation(),
    style: {
      position: "relative",
      backgroundColor: theme2.colors.background,
      borderRadius: theme2.radii[3],
      padding: 0,
      width: "95vw",
      height: "95vh",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxShadow: theme2.shadows[4]
    }
  }, /* @__PURE__ */ React11.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      onClose();
    },
    style: {
      position: "absolute",
      top: theme2.space[2],
      right: theme2.space[2],
      zIndex: 100,
      background: theme2.colors.background,
      border: `1px solid ${theme2.colors.border}`,
      fontSize: theme2.fontSizes[4],
      color: theme2.colors.text,
      cursor: "pointer",
      lineHeight: 1,
      padding: `${theme2.space[1]}px`,
      borderRadius: theme2.radii[1],
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease"
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
      e.currentTarget.style.color = theme2.colors.text;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.background;
      e.currentTarget.style.color = theme2.colors.text;
    },
    "aria-label": "Close"
  }, "×"), /* @__PURE__ */ React11.createElement("div", {
    style: {
      flex: 1,
      overflow: "hidden",
      position: "relative",
      backgroundColor: theme2.colors.background,
      padding: `${theme2.space[5]}px ${theme2.space[2]}px ${theme2.space[2]}px ${theme2.space[2]}px`
    }
  }, /* @__PURE__ */ React11.createElement(IndustryZoomableMermaidDiagram, {
    id: "mermaid-modal-diagram",
    code: mermaidCode,
    theme: theme2
  }))));
  return createPortal(modalContent, document.body);
}

// industryMarkdown/components/IndustryPlaceholderModal.tsx
import React12, { useState as useState8 } from "react";
function IndustryPlaceholderModal({
  isOpen,
  onClose,
  placeholders,
  promptContent,
  onCopy,
  theme: theme2
}) {
  const [values, setValues] = useState8({});
  if (!isOpen)
    return null;
  const handleSubmit = (e) => {
    e.preventDefault();
    let filledPrompt = promptContent;
    placeholders.forEach((placeholder) => {
      const value = values[placeholder] || `{{${placeholder}}}`;
      const regex = new RegExp(`\\{\\{${placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\}\\}`, "g");
      filledPrompt = filledPrompt.replace(regex, value);
    });
    navigator.clipboard.writeText(filledPrompt).then(() => {
      onCopy(filledPrompt);
      onClose();
      setValues({});
    }).catch((err) => {
      console.error("Failed to copy filled prompt:", err);
    });
  };
  return /* @__PURE__ */ React12.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 50,
      padding: theme2.space[5]
    },
    onClick: onClose
  }, /* @__PURE__ */ React12.createElement("div", {
    style: {
      backgroundColor: theme2.colors.background,
      borderRadius: theme2.radii[3],
      maxWidth: "600px",
      width: "100%",
      maxHeight: "80vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      border: `1px solid ${theme2.colors.border}`,
      boxShadow: theme2.shadows[4]
    },
    onClick: (e) => e.stopPropagation()
  }, /* @__PURE__ */ React12.createElement("div", {
    style: {
      padding: theme2.space[4],
      borderBottom: `1px solid ${theme2.colors.border}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: theme2.colors.backgroundSecondary
    }
  }, /* @__PURE__ */ React12.createElement("h3", {
    style: {
      margin: 0,
      color: theme2.colors.text,
      fontSize: theme2.fontSizes[3],
      fontWeight: theme2.fontWeights.semibold,
      fontFamily: theme2.fonts.heading
    }
  }, "Fill Prompt Placeholders"), /* @__PURE__ */ React12.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      onClose();
    },
    style: {
      background: "none",
      border: "none",
      fontSize: theme2.fontSizes[5],
      cursor: "pointer",
      color: theme2.colors.textSecondary,
      padding: `${theme2.space[1]}px`,
      borderRadius: theme2.radii[1],
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "32px",
      height: "32px",
      transition: "all 0.2s ease"
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundTertiary;
      e.currentTarget.style.color = theme2.colors.text;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = "transparent";
      e.currentTarget.style.color = theme2.colors.textSecondary;
    },
    title: "Close",
    "aria-label": "Close modal"
  }, "×")), /* @__PURE__ */ React12.createElement("div", {
    style: {
      padding: theme2.space[5],
      overflow: "auto",
      flex: 1,
      backgroundColor: theme2.colors.background
    }
  }, /* @__PURE__ */ React12.createElement("p", {
    style: {
      margin: `0 0 ${theme2.space[4]}px 0`,
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[2],
      lineHeight: theme2.lineHeights.body,
      fontFamily: theme2.fonts.body
    }
  }, "Fill in the values for the placeholders below. The prompt will be copied to your clipboard with the values substituted."), /* @__PURE__ */ React12.createElement("form", {
    onSubmit: handleSubmit
  }, placeholders.map((placeholder, index) => /* @__PURE__ */ React12.createElement("div", {
    key: index,
    style: { marginBottom: theme2.space[4] }
  }, /* @__PURE__ */ React12.createElement("label", {
    style: {
      display: "block",
      marginBottom: theme2.space[2],
      fontWeight: theme2.fontWeights.medium,
      color: theme2.colors.text,
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.body
    }
  }, placeholder), /* @__PURE__ */ React12.createElement("input", {
    type: "text",
    value: values[placeholder] || "",
    onChange: (e) => setValues((prev) => ({
      ...prev,
      [placeholder]: e.target.value
    })),
    style: {
      width: "100%",
      padding: `${theme2.space[3]}px`,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      fontSize: theme2.fontSizes[2],
      backgroundColor: theme2.colors.background,
      color: theme2.colors.text,
      outline: "none",
      fontFamily: theme2.fonts.body,
      transition: "border-color 0.2s ease"
    },
    onFocus: (e) => {
      e.currentTarget.style.borderColor = theme2.colors.primary;
    },
    onBlur: (e) => {
      e.currentTarget.style.borderColor = theme2.colors.border;
    },
    placeholder: `Enter value for ${placeholder}`
  }))), /* @__PURE__ */ React12.createElement("div", {
    style: {
      display: "flex",
      gap: theme2.space[3],
      justifyContent: "flex-end",
      marginTop: theme2.space[5]
    }
  }, /* @__PURE__ */ React12.createElement("button", {
    type: "button",
    onClick: onClose,
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[4]}px`,
      borderRadius: theme2.radii[1],
      fontSize: theme2.fontSizes[2],
      fontWeight: theme2.fontWeights.medium,
      cursor: "pointer",
      border: `1px solid ${theme2.colors.border}`,
      display: "flex",
      alignItems: "center",
      gap: theme2.space[2],
      backgroundColor: theme2.colors.background,
      color: theme2.colors.text,
      fontFamily: theme2.fonts.body,
      transition: "all 0.2s ease"
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.background;
    }
  }, "Cancel"), /* @__PURE__ */ React12.createElement("button", {
    type: "submit",
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[4]}px`,
      borderRadius: theme2.radii[1],
      fontSize: theme2.fontSizes[2],
      fontWeight: theme2.fontWeights.medium,
      cursor: "pointer",
      border: "none",
      display: "flex",
      alignItems: "center",
      gap: theme2.space[2],
      backgroundColor: theme2.colors.primary,
      color: "white",
      fontFamily: theme2.fonts.body,
      transition: "all 0.2s ease"
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.opacity = "0.9";
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.opacity = "1";
    }
  }, "Copy to Clipboard"))))));
}

// industryMarkdown/components/IndustryMarkdownSlide.tsx
var highlightOverrides = `
  /* Override root .hljs class with maximum specificity */
  .markdown-slide .hljs,
  .markdown-slide pre .hljs,
  .markdown-slide code.hljs,
  .markdown-slide pre code.hljs {
    color: inherit !important;
    background: transparent !important;
    background-color: transparent !important;
  }


  /* Remove backgrounds from all highlight.js classes in code blocks */
  pre code .hljs,
  pre code .hljs-keyword,
  pre code .hljs-selector-tag,
  pre code .hljs-literal,
  pre code .hljs-strong,
  pre code .hljs-name,
  pre code .hljs-variable,
  pre code .hljs-number,
  pre code .hljs-string,
  pre code .hljs-comment,
  pre code .hljs-type,
  pre code .hljs-built_in,
  pre code .hljs-builtin-name,
  pre code .hljs-meta,
  pre code .hljs-tag,
  pre code .hljs-title,
  pre code .hljs-attr,
  pre code .hljs-attribute,
  pre code .hljs-addition,
  pre code .hljs-deletion,
  pre code .hljs-link,
  pre code .hljs-doctag,
  pre code .hljs-formula,
  pre code .hljs-section,
  pre code .hljs-selector-class,
  pre code .hljs-selector-attr,
  pre code .hljs-selector-pseudo,
  pre code .hljs-symbol,
  pre code .hljs-bullet,
  pre code .hljs-selector-id,
  pre code .hljs-emphasis,
  pre code .hljs-quote,
  pre code .hljs-template-variable,
  pre code .hljs-regexp,
  pre code .hljs-subst {
    background-color: transparent !important;
  }

  /* Aggressive removal of backgrounds and padding for inline code */
  p code,
  li code,
  td code,
  th code,
  h1 code,
  h2 code,
  h3 code,
  h4 code,
  h5 code,
  h6 code,
  blockquote code,
  .inline-code,
  code:not(pre code) {
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;
    box-shadow: none !important;
    color: var(--text-color, currentColor) !important;
  }

  /* Ensure inline code uses its own color even with hljs classes */
  .inline-code,
  .inline-code[class*="hljs"],
  .inline-code[class*="language"] {
    color: var(--text-color) !important;
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
  }

  /* Override any highlight.js styles on inline code */
  p code[class*="hljs"],
  li code[class*="hljs"],
  td code[class*="hljs"],
  th code[class*="hljs"],
  p code[class*="language"],
  li code[class*="language"],
  td code[class*="language"],
  th code[class*="language"] {
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;
    box-shadow: none !important;
    color: var(--text-color) !important;
  }

  /* Remove all hljs styling from any inline code - comprehensive override */
  :not(pre) > code.hljs,
  :not(pre) > code[class*="hljs"],
  :not(pre) > code[class*="language"] {
    all: unset !important;
    font-family: var(--monospace-font-family, monospace) !important;
    font-size: 0.875em !important;
    color: var(--text-color) !important;
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }

  /* Override all possible hljs token classes for inline code */
  :not(pre) > code .hljs-keyword,
  :not(pre) > code .hljs-selector-tag,
  :not(pre) > code .hljs-literal,
  :not(pre) > code .hljs-strong,
  :not(pre) > code .hljs-name,
  :not(pre) > code .hljs-variable,
  :not(pre) > code .hljs-number,
  :not(pre) > code .hljs-string,
  :not(pre) > code .hljs-comment,
  :not(pre) > code .hljs-type,
  :not(pre) > code .hljs-built_in,
  :not(pre) > code .hljs-builtin-name,
  :not(pre) > code .hljs-meta,
  :not(pre) > code .hljs-tag,
  :not(pre) > code .hljs-title,
  :not(pre) > code .hljs-attr,
  :not(pre) > code .hljs-attribute,
  :not(pre) > code .hljs-addition,
  :not(pre) > code .hljs-deletion,
  :not(pre) > code .hljs-link,
  :not(pre) > code .hljs-doctag,
  :not(pre) > code .hljs-formula,
  :not(pre) > code .hljs-section,
  :not(pre) > code .hljs-selector-class,
  :not(pre) > code .hljs-selector-attr,
  :not(pre) > code .hljs-selector-pseudo,
  :not(pre) > code .hljs-symbol,
  :not(pre) > code .hljs-bullet,
  :not(pre) > code .hljs-selector-id,
  :not(pre) > code .hljs-emphasis,
  :not(pre) > code .hljs-quote,
  :not(pre) > code .hljs-template-variable,
  :not(pre) > code .hljs-regexp,
  :not(pre) > code .hljs-subst {
    color: var(--text-color) !important;
    background: transparent !important;
    background-color: transparent !important;
    font-weight: inherit !important;
    font-style: inherit !important;
    text-decoration: none !important;
  }
`;
var fontTransitionCSS = `
  .markdown-slide * {
    transition: font-size 0.2s ease-in-out;
  }
  
  /* Disable transitions and dynamic sizing on form elements to prevent flashing */
  .markdown-slide input,
  .markdown-slide label,
  .markdown-slide button,
  .markdown-slide input[type="checkbox"],
  .markdown-slide input[type="radio"] {
    transition: none !important;
    font-size: inherit !important; /* Prevent dynamic font sizing from affecting form elements */
  }
  
  /* Ensure checkbox labels maintain fixed sizing */
  .markdown-slide label[for*="checkbox"] {
    font-size: 1rem !important; /* Fixed size for checkbox labels */
  }
  
  /* Remove top margin from any first element - must override inline styles */
  .markdown-slide > *:first-child,
  .markdown-slide > *:first-child > *:first-child {
    margin-top: 0 !important;
  }

  /* Specifically target all possible first-child elements */
  .markdown-slide > h1:first-child,
  .markdown-slide > h2:first-child,
  .markdown-slide > h3:first-child,
  .markdown-slide > h4:first-child,
  .markdown-slide > h5:first-child,
  .markdown-slide > h6:first-child,
  .markdown-slide > p:first-child,
  .markdown-slide > ul:first-child,
  .markdown-slide > ol:first-child,
  .markdown-slide > div:first-child,
  .markdown-slide > blockquote:first-child,
  .markdown-slide > pre:first-child {
    margin-top: 0 !important;
  }
`;
var stylesInjected = false;
var injectStyles = () => {
  if (typeof document !== "undefined" && !stylesInjected) {
    if (!document.getElementById("markdown-slide-highlight-overrides")) {
      const highlightStyle = document.createElement("style");
      highlightStyle.id = "markdown-slide-highlight-overrides";
      highlightStyle.textContent = highlightOverrides;
      document.head.appendChild(highlightStyle);
    }
    if (!document.getElementById("markdown-slide-font-transitions")) {
      const transitionStyle = document.createElement("style");
      transitionStyle.id = "markdown-slide-font-transitions";
      transitionStyle.textContent = fontTransitionCSS;
      document.head.appendChild(transitionStyle);
    }
    stylesInjected = true;
  }
};
var IndustryMarkdownSlide = React13.memo(function IndustryMarkdownSlide2({
  content,
  slideIdPrefix,
  slideIndex,
  isVisible = false,
  onLinkClick,
  onCheckboxChange,
  onCopyMermaidError,
  onShowMermaidInPanel,
  handleRunBashCommand,
  handlePromptCopy,
  enableHtmlPopout = true,
  autoFocusOnVisible = true,
  searchQuery,
  slideHeaderMarginTopOverride,
  theme: themeOverride,
  fontSizeScale = 1,
  containerWidth,
  transparentBackground = false,
  additionalPadding,
  disableScroll = false,
  minScreenWidth: _minScreenWidth,
  maxScreenWidth: _maxScreenWidth,
  enableKeyboardScrolling = true,
  keyboardScrollConfig,
  repositoryInfo,
  editable = false
}) {
  const slideRef = useRef7(null);
  const scrollPositionsRef = useRef7(new Map);
  const [measuredContainerWidth, setMeasuredContainerWidth] = useState9(null);
  let chunks = [];
  try {
    if (typeof content === "string") {
      chunks = parseMarkdownChunks2(content, slideIdPrefix);
    } else {}
  } catch (error) {
    console.error("Error parsing markdown chunks:", error);
  }
  const [checkedItems, setCheckedItems] = useState9({});
  const { htmlModalOpen, htmlModalContent, openHtmlModal, closeHtmlModal } = useIndustryHtmlModal();
  const [mermaidModalOpen, setMermaidModalOpen] = useState9(false);
  const [mermaidModalCode, setMermaidModalCode] = useState9("");
  const [placeholderModalOpen, setPlaceholderModalOpen] = useState9(false);
  const [placeholderModalData, setPlaceholderModalData] = useState9(null);
  useEffect7(() => {
    injectStyles();
  }, []);
  useEffect7(() => {
    if (containerWidth !== undefined) {
      return;
    }
    if (!slideRef.current) {
      return;
    }
    const setupResizeObserver = () => {
      const parentContainer = slideRef.current?.parentElement;
      if (!parentContainer) {
        return;
      }
      const resizeObserver2 = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const { width } = entry.contentRect;
          setMeasuredContainerWidth(width);
        }
      });
      resizeObserver2.observe(parentContainer);
      return resizeObserver2;
    };
    let resizeObserver = setupResizeObserver();
    if (!resizeObserver) {
      const timeoutId = setTimeout(() => {
        resizeObserver = setupResizeObserver();
      }, 100);
      return () => {
        clearTimeout(timeoutId);
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
      };
    }
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [containerWidth]);
  const defaultScrollConfig = {
    scrollAmount: 100,
    pageScrollRatio: 0.8,
    smoothScroll: true,
    keys: {
      scrollUp: ["ArrowUp"],
      scrollDown: ["ArrowDown"],
      pageUp: ["PageUp"],
      pageDown: ["PageDown"]
    },
    enableDebugLogging: false
  };
  const scrollConfig = {
    ...defaultScrollConfig,
    ...keyboardScrollConfig,
    keys: {
      ...defaultScrollConfig.keys,
      ...keyboardScrollConfig?.keys
    }
  };
  const handleKeyDown = useCallback((event) => {
    if (!enableKeyboardScrolling) {
      return;
    }
    if (!isVisible) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`\uD83D\uDEAB Slide ${slideIndex} ignoring key press - not visible`);
      }
      return;
    }
    if (scrollConfig.enableDebugLogging) {
      console.log(`\uD83D\uDD39 Slide ${slideIndex} key pressed:`, event.key, "Target:", event.target);
    }
    if (!slideRef.current) {
      if (scrollConfig.enableDebugLogging) {
        console.log("❌ slideRef.current is null");
      }
      return;
    }
    const container = slideRef.current;
    const scrollInfo = {
      scrollTop: container.scrollTop,
      scrollHeight: container.scrollHeight,
      clientHeight: container.clientHeight,
      canScroll: container.scrollHeight > container.clientHeight,
      maxScroll: container.scrollHeight - container.clientHeight
    };
    if (scrollConfig.enableDebugLogging) {
      console.log(`\uD83D\uDCCA Slide ${slideIndex} Scroll Info:`, scrollInfo);
      let parent = container.parentElement;
      let level = 1;
      while (parent && level <= 3) {
        const parentScrollInfo = {
          level,
          tagName: parent.tagName,
          className: parent.className,
          scrollTop: parent.scrollTop,
          scrollHeight: parent.scrollHeight,
          clientHeight: parent.clientHeight,
          canScroll: parent.scrollHeight > parent.clientHeight,
          overflowY: getComputedStyle(parent).overflowY
        };
        console.log(`\uD83D\uDCCA Slide ${slideIndex} Parent ${level} Info:`, parentScrollInfo);
        parent = parent.parentElement;
        level++;
      }
    }
    const isScrollDown = scrollConfig.keys.scrollDown.includes(event.key);
    const isScrollUp = scrollConfig.keys.scrollUp.includes(event.key);
    const isPageDown = scrollConfig.keys.pageDown.includes(event.key);
    const isPageUp = scrollConfig.keys.pageUp.includes(event.key);
    if (!isScrollDown && !isScrollUp && !isPageDown && !isPageUp) {
      return;
    }
    let scrollTarget = container;
    if (!scrollInfo.canScroll) {
      let parent = container.parentElement;
      while (parent) {
        if (parent.scrollHeight > parent.clientHeight) {
          if (scrollConfig.enableDebugLogging) {
            console.log(`\uD83C\uDFAF Slide ${slideIndex} Found scrollable parent:`, parent.tagName, parent.className);
          }
          scrollTarget = parent;
          break;
        }
        parent = parent.parentElement;
      }
    }
    if (scrollTarget.scrollHeight <= scrollTarget.clientHeight) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`⚠️ Slide ${slideIndex} Cannot scroll - content fits in container`);
      }
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    let scrollAmount = 0;
    if (isScrollDown) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`⬇️ Slide ${slideIndex} Scroll down pressed`);
      }
      scrollAmount = scrollConfig.scrollAmount;
    } else if (isScrollUp) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`⬆️ Slide ${slideIndex} Scroll up pressed`);
      }
      scrollAmount = -scrollConfig.scrollAmount;
    } else if (isPageDown) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`\uD83D\uDCC4⬇️ Slide ${slideIndex} Page down pressed`);
      }
      scrollAmount = scrollTarget.clientHeight * scrollConfig.pageScrollRatio;
    } else if (isPageUp) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`\uD83D\uDCC4⬆️ Slide ${slideIndex} Page up pressed`);
      }
      scrollAmount = -scrollTarget.clientHeight * scrollConfig.pageScrollRatio;
    }
    const beforeScroll = scrollTarget.scrollTop;
    scrollTarget.scrollBy({
      top: scrollAmount,
      behavior: scrollConfig.smoothScroll ? "smooth" : "auto"
    });
    if (scrollConfig.enableDebugLogging) {
      setTimeout(() => {
        const afterScroll = scrollTarget.scrollTop;
        console.log(`\uD83D\uDCC8 Slide ${slideIndex} Scroll: ${beforeScroll} → ${afterScroll} (diff: ${afterScroll - beforeScroll})`);
      }, scrollConfig.smoothScroll ? 100 : 0);
    }
  }, [enableKeyboardScrolling, isVisible, slideIndex, scrollConfig]);
  useEffect7(() => {
    if (autoFocusOnVisible && isVisible && slideRef.current) {
      slideRef.current.focus({ preventScroll: true });
    }
  }, [autoFocusOnVisible, isVisible]);
  const openPlaceholderModal = (placeholders, promptContent) => {
    if (!handlePromptCopy)
      return;
    setPlaceholderModalData({ placeholders, promptContent });
    setPlaceholderModalOpen(true);
  };
  const closePlaceholderModal = () => {
    setPlaceholderModalOpen(false);
    setPlaceholderModalData(null);
  };
  const openMermaidModal = (code) => {
    setMermaidModalCode(code);
    setMermaidModalOpen(true);
  };
  const closeMermaidModal = () => {
    setMermaidModalOpen(false);
    setMermaidModalCode("");
  };
  const baseTheme = themeOverride ?? theme;
  const theme2 = useMemo2(() => {
    if (fontSizeScale === 1)
      return baseTheme;
    return {
      ...baseTheme,
      fontSizes: baseTheme.fontSizes.map((size) => Math.round(size * fontSizeScale))
    };
  }, [baseTheme, fontSizeScale]);
  const calculateSlidePadding = useMemo2(() => {
    const effectiveContainerWidth = containerWidth ?? measuredContainerWidth ?? 800;
    const paddingPercentage = 0.03;
    const horizontalPadding = Math.max(5, Math.round(effectiveContainerWidth * paddingPercentage));
    const verticalPadding = Math.max(5, Math.round(effectiveContainerWidth * (paddingPercentage - 0.015)));
    const result = {
      vertical: `${verticalPadding}px`,
      horizontal: `${horizontalPadding}px`
    };
    return result;
  }, [containerWidth, measuredContainerWidth]);
  const finalPadding = useMemo2(() => {
    const basePadding = calculateSlidePadding.horizontal;
    const baseVerticalPadding = calculateSlidePadding.vertical;
    const baseHorizontalValue = parseInt(basePadding.replace("px", ""), 10);
    const baseVerticalValue = parseInt(baseVerticalPadding.replace("px", ""), 10);
    const leftExtra = additionalPadding?.left ? parseInt(additionalPadding.left.replace("px", ""), 10) : 0;
    const rightExtra = additionalPadding?.right ? parseInt(additionalPadding.right.replace("px", ""), 10) : 0;
    const topExtra = additionalPadding?.top ? parseInt(additionalPadding.top.replace("px", ""), 10) : 0;
    const bottomExtra = additionalPadding?.bottom ? parseInt(additionalPadding.bottom.replace("px", ""), 10) : 0;
    const top = Math.round(baseVerticalValue * 1.5) + topExtra;
    const right = baseHorizontalValue + rightExtra;
    const bottom = Math.round(baseVerticalValue * 1.5) + bottomExtra;
    const left = baseHorizontalValue + leftExtra;
    return `${top}px ${right}px ${bottom}px ${left}px`;
  }, [calculateSlidePadding.horizontal, calculateSlidePadding.vertical, additionalPadding]);
  useEffect7(() => {
    const slideElement = slideRef.current;
    if (slideElement) {
      const handleScroll = () => {
        scrollPositionsRef.current.set(slideIndex, slideElement.scrollTop || 0);
      };
      slideElement.addEventListener("scroll", handleScroll);
      return () => {
        slideElement.removeEventListener("scroll", handleScroll);
      };
    }
    return;
  }, [slideIndex]);
  useLayoutEffect(() => {
    if (slideRef.current) {
      const savedPosition = scrollPositionsRef.current.get(slideIndex) ?? 0;
      slideRef.current.scrollTop = savedPosition;
    }
  }, [slideIndex]);
  const sanitizeSchema = useMemo2(() => ({
    ...defaultSchema,
    tagNames: [...defaultSchema.tagNames || [], "picture", "source", "mark"],
    attributes: {
      ...defaultSchema.attributes,
      mark: ["style", "className"],
      code: [...defaultSchema.attributes?.code || [], "className", "style"],
      span: [...defaultSchema.attributes?.span || [], "className", "style"],
      pre: [...defaultSchema.attributes?.pre || [], "className", "style"],
      div: [...defaultSchema.attributes?.div || [], "style", "className", "id"],
      p: [...defaultSchema.attributes?.p || [], "style", "className", "id"],
      h1: [...defaultSchema.attributes?.h1 || [], "style", "className", "id"],
      h2: [...defaultSchema.attributes?.h2 || [], "style", "className", "id"],
      h3: [...defaultSchema.attributes?.h3 || [], "style", "className", "id"],
      h4: [...defaultSchema.attributes?.h4 || [], "style", "className", "id"],
      h5: [...defaultSchema.attributes?.h5 || [], "style", "className", "id"],
      h6: [...defaultSchema.attributes?.h6 || [], "style", "className", "id"],
      strong: [...defaultSchema.attributes?.strong || [], "style", "className"],
      em: [...defaultSchema.attributes?.em || [], "style", "className"],
      ul: [...defaultSchema.attributes?.ul || [], "style", "className"],
      ol: [...defaultSchema.attributes?.ol || [], "style", "className"],
      li: [...defaultSchema.attributes?.li || [], "style", "className"],
      a: [...defaultSchema.attributes?.a || [], "style", "className"],
      img: [...defaultSchema.attributes?.img || [], "style", "className"],
      picture: [...defaultSchema.attributes?.picture || [], "style", "className"],
      source: [
        ...defaultSchema.attributes?.source || [],
        "srcSet",
        "media",
        "type",
        "sizes",
        "style",
        "className"
      ],
      table: [...defaultSchema.attributes?.table || [], "style", "className"],
      thead: [...defaultSchema.attributes?.thead || [], "style", "className"],
      tbody: [...defaultSchema.attributes?.tbody || [], "style", "className"],
      tr: [...defaultSchema.attributes?.tr || [], "style", "className"],
      th: [...defaultSchema.attributes?.th || [], "style", "className"],
      td: [...defaultSchema.attributes?.td || [], "style", "className"],
      blockquote: [...defaultSchema.attributes?.blockquote || [], "style", "className"],
      hr: [...defaultSchema.attributes?.hr || [], "style", "className"],
      label: [...defaultSchema.attributes?.label || [], "style", "className", "for"],
      input: [
        ...defaultSchema.attributes?.input || [],
        "style",
        "className",
        "type",
        "placeholder",
        "value",
        "checked",
        "disabled"
      ],
      button: [
        ...defaultSchema.attributes?.button || [],
        "style",
        "className",
        "type",
        "disabled"
      ],
      details: [...defaultSchema.attributes?.details || [], "style", "className", "open"],
      summary: [...defaultSchema.attributes?.summary || [], "style", "className"],
      footer: [...defaultSchema.attributes?.footer || [], "style", "className"],
      header: [...defaultSchema.attributes?.header || [], "style", "className"],
      section: [...defaultSchema.attributes?.section || [], "style", "className"]
    }
  }), []);
  const rootMargin = isVisible ? "0px" : "100px";
  const getMarkdownComponents = useCallback((chunkIndex) => {
    const baseComponents = createIndustryMarkdownComponents({
      theme: theme2,
      slideIdPrefix,
      slideIndex,
      onLinkClick,
      onCheckboxChange,
      checkedItems,
      setCheckedItems,
      openHtmlModal,
      openPlaceholderModal: handlePromptCopy ? openPlaceholderModal : undefined,
      handleRunBashCommand,
      enableHtmlPopout,
      slideHeaderMarginTopOverride,
      index: chunkIndex,
      repositoryInfo,
      editable
    });
    if (searchQuery) {
      return {
        ...baseComponents,
        mark: ({ children }) => /* @__PURE__ */ React13.createElement("mark", {
          style: {
            backgroundColor: theme2.colors.highlightBg || "rgba(255, 193, 7, 0.25)",
            color: theme2.colors.text,
            padding: "0.05em 0.15em",
            borderRadius: `${theme2.radii[0]}px`,
            border: `1px solid ${theme2.colors.highlightBorder || "rgba(255, 193, 7, 0.4)"}`,
            fontWeight: "inherit",
            textDecoration: "none"
          }
        }, children)
      };
    }
    return baseComponents;
  }, [
    theme2,
    slideIdPrefix,
    slideIndex,
    onLinkClick,
    onCheckboxChange,
    checkedItems,
    setCheckedItems,
    openHtmlModal,
    handlePromptCopy,
    handleRunBashCommand,
    enableHtmlPopout,
    slideHeaderMarginTopOverride,
    repositoryInfo,
    searchQuery,
    editable
  ]);
  return /* @__PURE__ */ React13.createElement("div", {
    className: "markdown-slide",
    ref: slideRef,
    style: {
      height: "100%",
      overflowY: disableScroll ? "visible" : "auto",
      overflowX: disableScroll ? "visible" : "hidden",
      position: "relative",
      backgroundColor: transparentBackground ? "transparent" : theme2.colors.background,
      color: theme2.colors.text,
      fontFamily: theme2.fonts.body,
      padding: finalPadding,
      outline: "none",
      border: "2px solid transparent",
      transition: "border-color 0.2s ease",
      boxSizing: "border-box"
    },
    tabIndex: 0,
    onKeyDown: handleKeyDown,
    onClick: () => {
      if (slideRef.current) {
        slideRef.current.focus();
      }
    }
  }, chunks.length === 0 ? /* @__PURE__ */ React13.createElement("div", {
    style: {
      padding: theme2.space[4],
      textAlign: "center",
      color: theme2.colors.muted,
      fontSize: theme2.fontSizes[2]
    }
  }, "No content to display") : chunks.map((chunk, index) => {
    if (chunk.type === "markdown_chunk") {
      const processedContent = searchQuery ? highlightSearchMatches(chunk.content, searchQuery) : chunk.content;
      return /* @__PURE__ */ React13.createElement(ReactMarkdown, {
        key: `${chunk.id}-${JSON.stringify(theme2.colors.accent)}`,
        remarkPlugins: [remarkGfm],
        rehypePlugins: [
          rehypeRaw,
          [rehypeSanitize, sanitizeSchema],
          rehypeSlug,
          rehypeHighlight
        ],
        components: getMarkdownComponents(index)
      }, processedContent);
    }
    if (chunk.type === "mermaid_chunk") {
      const mermaidProps = {
        id: chunk.id,
        code: chunk.content,
        onCopyError: onCopyMermaidError,
        rootMargin,
        theme: theme2,
        onExpandClick: () => openMermaidModal(chunk.content)
      };
      if (onShowMermaidInPanel) {
        mermaidProps.onShowInPanel = onShowMermaidInPanel;
      }
      return /* @__PURE__ */ React13.createElement(IndustryLazyMermaidDiagram, {
        key: chunk.id,
        ...mermaidProps
      });
    }
    return null;
  }), /* @__PURE__ */ React13.createElement(IndustryHtmlModal, {
    isOpen: htmlModalOpen,
    onClose: closeHtmlModal,
    htmlContent: htmlModalContent,
    theme: theme2
  }), /* @__PURE__ */ React13.createElement(IndustryMermaidModal, {
    isOpen: mermaidModalOpen,
    onClose: closeMermaidModal,
    mermaidCode: mermaidModalCode,
    theme: theme2
  }), handlePromptCopy && placeholderModalData && /* @__PURE__ */ React13.createElement(IndustryPlaceholderModal, {
    isOpen: placeholderModalOpen,
    onClose: closePlaceholderModal,
    placeholders: placeholderModalData.placeholders,
    promptContent: placeholderModalData.promptContent,
    onCopy: handlePromptCopy,
    theme: theme2
  }));
});
// node_modules/@principal-ade/panels/dist/index.esm.js
import { jsx as e, jsxs as t, Fragment as n } from "react/jsx-runtime";
import r, { useState as o, useRef as i, useCallback as a, useEffect as l, forwardRef as s, useImperativeHandle as c, useMemo as d, useLayoutEffect as u, createContext as p, memo as h, useReducer as m, useContext as f } from "react";

// node_modules/react-resizable-panels/dist/react-resizable-panels.browser.development.js
import * as React14 from "react";
import { createContext as createContext2, useLayoutEffect as useLayoutEffect2, useRef as useRef8, forwardRef, createElement, useContext as useContext2, useImperativeHandle, useState as useState10, useCallback as useCallback2, useEffect as useEffect8, useMemo as useMemo3 } from "react";
var PanelGroupContext = createContext2(null);
PanelGroupContext.displayName = "PanelGroupContext";
var DATA_ATTRIBUTES = {
  group: "data-panel-group",
  groupDirection: "data-panel-group-direction",
  groupId: "data-panel-group-id",
  panel: "data-panel",
  panelCollapsible: "data-panel-collapsible",
  panelId: "data-panel-id",
  panelSize: "data-panel-size",
  resizeHandle: "data-resize-handle",
  resizeHandleActive: "data-resize-handle-active",
  resizeHandleEnabled: "data-panel-resize-handle-enabled",
  resizeHandleId: "data-panel-resize-handle-id",
  resizeHandleState: "data-resize-handle-state"
};
var PRECISION = 10;
var useIsomorphicLayoutEffect = useLayoutEffect2;
var useId = React14["useId".toString()];
var wrappedUseId = typeof useId === "function" ? useId : () => null;
var counter = 0;
function useUniqueId(idFromParams = null) {
  const idFromUseId = wrappedUseId();
  const idRef = useRef8(idFromParams || idFromUseId || null);
  if (idRef.current === null) {
    idRef.current = "" + counter++;
  }
  return idFromParams !== null && idFromParams !== undefined ? idFromParams : idRef.current;
}
function PanelWithForwardedRef({
  children,
  className: classNameFromProps = "",
  collapsedSize,
  collapsible,
  defaultSize,
  forwardedRef,
  id: idFromProps,
  maxSize,
  minSize,
  onCollapse,
  onExpand,
  onResize,
  order,
  style: styleFromProps,
  tagName: Type = "div",
  ...rest
}) {
  const context = useContext2(PanelGroupContext);
  if (context === null) {
    throw Error(`Panel components must be rendered within a PanelGroup container`);
  }
  const {
    collapsePanel,
    expandPanel,
    getPanelSize,
    getPanelStyle,
    groupId,
    isPanelCollapsed,
    reevaluatePanelConstraints,
    registerPanel,
    resizePanel,
    unregisterPanel
  } = context;
  const panelId = useUniqueId(idFromProps);
  const panelDataRef = useRef8({
    callbacks: {
      onCollapse,
      onExpand,
      onResize
    },
    constraints: {
      collapsedSize,
      collapsible,
      defaultSize,
      maxSize,
      minSize
    },
    id: panelId,
    idIsFromProps: idFromProps !== undefined,
    order
  });
  const devWarningsRef = useRef8({
    didLogMissingDefaultSizeWarning: false
  });
  {
    if (!devWarningsRef.current.didLogMissingDefaultSizeWarning)
      ;
  }
  useIsomorphicLayoutEffect(() => {
    const {
      callbacks,
      constraints
    } = panelDataRef.current;
    const prevConstraints = {
      ...constraints
    };
    panelDataRef.current.id = panelId;
    panelDataRef.current.idIsFromProps = idFromProps !== undefined;
    panelDataRef.current.order = order;
    callbacks.onCollapse = onCollapse;
    callbacks.onExpand = onExpand;
    callbacks.onResize = onResize;
    constraints.collapsedSize = collapsedSize;
    constraints.collapsible = collapsible;
    constraints.defaultSize = defaultSize;
    constraints.maxSize = maxSize;
    constraints.minSize = minSize;
    if (prevConstraints.collapsedSize !== constraints.collapsedSize || prevConstraints.collapsible !== constraints.collapsible || prevConstraints.maxSize !== constraints.maxSize || prevConstraints.minSize !== constraints.minSize) {
      reevaluatePanelConstraints(panelDataRef.current, prevConstraints);
    }
  });
  useIsomorphicLayoutEffect(() => {
    const panelData = panelDataRef.current;
    registerPanel(panelData);
    return () => {
      unregisterPanel(panelData);
    };
  }, [order, panelId, registerPanel, unregisterPanel]);
  useImperativeHandle(forwardedRef, () => ({
    collapse: () => {
      collapsePanel(panelDataRef.current);
    },
    expand: (minSize2) => {
      expandPanel(panelDataRef.current, minSize2);
    },
    getId() {
      return panelId;
    },
    getSize() {
      return getPanelSize(panelDataRef.current);
    },
    isCollapsed() {
      return isPanelCollapsed(panelDataRef.current);
    },
    isExpanded() {
      return !isPanelCollapsed(panelDataRef.current);
    },
    resize: (size) => {
      resizePanel(panelDataRef.current, size);
    }
  }), [collapsePanel, expandPanel, getPanelSize, isPanelCollapsed, panelId, resizePanel]);
  const style = getPanelStyle(panelDataRef.current, defaultSize);
  return createElement(Type, {
    ...rest,
    children,
    className: classNameFromProps,
    id: panelId,
    style: {
      ...style,
      ...styleFromProps
    },
    [DATA_ATTRIBUTES.groupId]: groupId,
    [DATA_ATTRIBUTES.panel]: "",
    [DATA_ATTRIBUTES.panelCollapsible]: collapsible || undefined,
    [DATA_ATTRIBUTES.panelId]: panelId,
    [DATA_ATTRIBUTES.panelSize]: parseFloat("" + style.flexGrow).toFixed(1)
  });
}
var Panel = forwardRef((props, ref) => createElement(PanelWithForwardedRef, {
  ...props,
  forwardedRef: ref
}));
PanelWithForwardedRef.displayName = "Panel";
Panel.displayName = "forwardRef(Panel)";
var nonce;
function getNonce() {
  return nonce;
}
var currentCursorStyle = null;
var enabled = true;
var getCustomCursorStyleFunction = null;
var prevRuleIndex = -1;
var styleElement = null;
function getCursorStyle(state, constraintFlags, isPointerDown) {
  const horizontalMin = (constraintFlags & EXCEEDED_HORIZONTAL_MIN) !== 0;
  const horizontalMax = (constraintFlags & EXCEEDED_HORIZONTAL_MAX) !== 0;
  const verticalMin = (constraintFlags & EXCEEDED_VERTICAL_MIN) !== 0;
  const verticalMax = (constraintFlags & EXCEEDED_VERTICAL_MAX) !== 0;
  if (getCustomCursorStyleFunction) {
    return getCustomCursorStyleFunction({
      exceedsHorizontalMaximum: horizontalMax,
      exceedsHorizontalMinimum: horizontalMin,
      exceedsVerticalMaximum: verticalMax,
      exceedsVerticalMinimum: verticalMin,
      intersectsHorizontalDragHandle: state === "horizontal" || state === "intersection",
      intersectsVerticalDragHandle: state === "vertical" || state === "intersection",
      isPointerDown
    });
  }
  if (constraintFlags) {
    if (horizontalMin) {
      if (verticalMin) {
        return "se-resize";
      } else if (verticalMax) {
        return "ne-resize";
      } else {
        return "e-resize";
      }
    } else if (horizontalMax) {
      if (verticalMin) {
        return "sw-resize";
      } else if (verticalMax) {
        return "nw-resize";
      } else {
        return "w-resize";
      }
    } else if (verticalMin) {
      return "s-resize";
    } else if (verticalMax) {
      return "n-resize";
    }
  }
  switch (state) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function resetGlobalCursorStyle() {
  if (styleElement !== null) {
    document.head.removeChild(styleElement);
    currentCursorStyle = null;
    styleElement = null;
    prevRuleIndex = -1;
  }
}
function setGlobalCursorStyle(state, constraintFlags, isPointerDown) {
  var _styleElement$sheet$i, _styleElement$sheet2;
  if (!enabled) {
    return;
  }
  const style = getCursorStyle(state, constraintFlags, isPointerDown);
  if (currentCursorStyle === style) {
    return;
  }
  currentCursorStyle = style;
  if (styleElement === null) {
    styleElement = document.createElement("style");
    const nonce2 = getNonce();
    if (nonce2) {
      styleElement.setAttribute("nonce", nonce2);
    }
    document.head.appendChild(styleElement);
  }
  if (prevRuleIndex >= 0) {
    var _styleElement$sheet;
    (_styleElement$sheet = styleElement.sheet) === null || _styleElement$sheet === undefined || _styleElement$sheet.removeRule(prevRuleIndex);
  }
  prevRuleIndex = (_styleElement$sheet$i = (_styleElement$sheet2 = styleElement.sheet) === null || _styleElement$sheet2 === undefined ? undefined : _styleElement$sheet2.insertRule(`*{cursor: ${style} !important;}`)) !== null && _styleElement$sheet$i !== undefined ? _styleElement$sheet$i : -1;
}
function isKeyDown(event) {
  return event.type === "keydown";
}
function isPointerEvent(event) {
  return event.type.startsWith("pointer");
}
function isMouseEvent(event) {
  return event.type.startsWith("mouse");
}
function getResizeEventCoordinates(event) {
  if (isPointerEvent(event)) {
    if (event.isPrimary) {
      return {
        x: event.clientX,
        y: event.clientY
      };
    }
  } else if (isMouseEvent(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  return {
    x: Infinity,
    y: Infinity
  };
}
function getInputType() {
  if (typeof matchMedia === "function") {
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
  }
}
function intersects(rectOne, rectTwo, strict) {
  if (strict) {
    return rectOne.x < rectTwo.x + rectTwo.width && rectOne.x + rectOne.width > rectTwo.x && rectOne.y < rectTwo.y + rectTwo.height && rectOne.y + rectOne.height > rectTwo.y;
  } else {
    return rectOne.x <= rectTwo.x + rectTwo.width && rectOne.x + rectOne.width >= rectTwo.x && rectOne.y <= rectTwo.y + rectTwo.height && rectOne.y + rectOne.height >= rectTwo.y;
  }
}
function compare(a, b) {
  if (a === b)
    throw new Error("Cannot compare node with itself");
  const ancestors = {
    a: get_ancestors(a),
    b: get_ancestors(b)
  };
  let common_ancestor;
  while (ancestors.a.at(-1) === ancestors.b.at(-1)) {
    a = ancestors.a.pop();
    b = ancestors.b.pop();
    common_ancestor = a;
  }
  assert(common_ancestor, "Stacking order can only be calculated for elements with a common ancestor");
  const z_indexes = {
    a: get_z_index(find_stacking_context(ancestors.a)),
    b: get_z_index(find_stacking_context(ancestors.b))
  };
  if (z_indexes.a === z_indexes.b) {
    const children = common_ancestor.childNodes;
    const furthest_ancestors = {
      a: ancestors.a.at(-1),
      b: ancestors.b.at(-1)
    };
    let i = children.length;
    while (i--) {
      const child = children[i];
      if (child === furthest_ancestors.a)
        return 1;
      if (child === furthest_ancestors.b)
        return -1;
    }
  }
  return Math.sign(z_indexes.a - z_indexes.b);
}
var props = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function is_flex_item(node) {
  var _get_parent;
  const display = getComputedStyle((_get_parent = get_parent(node)) !== null && _get_parent !== undefined ? _get_parent : node).display;
  return display === "flex" || display === "inline-flex";
}
function creates_stacking_context(node) {
  const style = getComputedStyle(node);
  if (style.position === "fixed")
    return true;
  if (style.zIndex !== "auto" && (style.position !== "static" || is_flex_item(node)))
    return true;
  if (+style.opacity < 1)
    return true;
  if ("transform" in style && style.transform !== "none")
    return true;
  if ("webkitTransform" in style && style.webkitTransform !== "none")
    return true;
  if ("mixBlendMode" in style && style.mixBlendMode !== "normal")
    return true;
  if ("filter" in style && style.filter !== "none")
    return true;
  if ("webkitFilter" in style && style.webkitFilter !== "none")
    return true;
  if ("isolation" in style && style.isolation === "isolate")
    return true;
  if (props.test(style.willChange))
    return true;
  if (style.webkitOverflowScrolling === "touch")
    return true;
  return false;
}
function find_stacking_context(nodes) {
  let i = nodes.length;
  while (i--) {
    const node = nodes[i];
    assert(node, "Missing node");
    if (creates_stacking_context(node))
      return node;
  }
  return null;
}
function get_z_index(node) {
  return node && Number(getComputedStyle(node).zIndex) || 0;
}
function get_ancestors(node) {
  const ancestors = [];
  while (node) {
    ancestors.push(node);
    node = get_parent(node);
  }
  return ancestors;
}
function get_parent(node) {
  const {
    parentNode
  } = node;
  if (parentNode && parentNode instanceof ShadowRoot) {
    return parentNode.host;
  }
  return parentNode;
}
var EXCEEDED_HORIZONTAL_MIN = 1;
var EXCEEDED_HORIZONTAL_MAX = 2;
var EXCEEDED_VERTICAL_MIN = 4;
var EXCEEDED_VERTICAL_MAX = 8;
var isCoarsePointer = getInputType() === "coarse";
var intersectingHandles = [];
var isPointerDown = false;
var ownerDocumentCounts = new Map;
var panelConstraintFlags = new Map;
var registeredResizeHandlers = new Set;
function registerResizeHandle(resizeHandleId, element, direction, hitAreaMargins, setResizeHandlerState) {
  var _ownerDocumentCounts$;
  const {
    ownerDocument
  } = element;
  const data = {
    direction,
    element,
    hitAreaMargins,
    setResizeHandlerState
  };
  const count = (_ownerDocumentCounts$ = ownerDocumentCounts.get(ownerDocument)) !== null && _ownerDocumentCounts$ !== undefined ? _ownerDocumentCounts$ : 0;
  ownerDocumentCounts.set(ownerDocument, count + 1);
  registeredResizeHandlers.add(data);
  updateListeners();
  return function unregisterResizeHandle() {
    var _ownerDocumentCounts$2;
    panelConstraintFlags.delete(resizeHandleId);
    registeredResizeHandlers.delete(data);
    const count2 = (_ownerDocumentCounts$2 = ownerDocumentCounts.get(ownerDocument)) !== null && _ownerDocumentCounts$2 !== undefined ? _ownerDocumentCounts$2 : 1;
    ownerDocumentCounts.set(ownerDocument, count2 - 1);
    updateListeners();
    if (count2 === 1) {
      ownerDocumentCounts.delete(ownerDocument);
    }
    if (intersectingHandles.includes(data)) {
      const index = intersectingHandles.indexOf(data);
      if (index >= 0) {
        intersectingHandles.splice(index, 1);
      }
      updateCursor();
      setResizeHandlerState("up", true, null);
    }
  };
}
function handlePointerDown(event) {
  const {
    target
  } = event;
  const {
    x,
    y
  } = getResizeEventCoordinates(event);
  isPointerDown = true;
  recalculateIntersectingHandles({
    target,
    x,
    y
  });
  updateListeners();
  if (intersectingHandles.length > 0) {
    updateResizeHandlerStates("down", event);
    updateCursor();
    event.preventDefault();
    if (!isWithinResizeHandle(target)) {
      event.stopImmediatePropagation();
    }
  }
}
function handlePointerMove(event) {
  const {
    x,
    y
  } = getResizeEventCoordinates(event);
  if (isPointerDown && event.type !== "pointerleave" && event.buttons === 0) {
    isPointerDown = false;
    updateResizeHandlerStates("up", event);
  }
  if (!isPointerDown) {
    const {
      target
    } = event;
    recalculateIntersectingHandles({
      target,
      x,
      y
    });
  }
  updateResizeHandlerStates("move", event);
  updateCursor();
  if (intersectingHandles.length > 0) {
    event.preventDefault();
  }
}
function handlePointerUp(event) {
  const {
    target
  } = event;
  const {
    x,
    y
  } = getResizeEventCoordinates(event);
  panelConstraintFlags.clear();
  isPointerDown = false;
  if (intersectingHandles.length > 0) {
    event.preventDefault();
    if (!isWithinResizeHandle(target)) {
      event.stopImmediatePropagation();
    }
  }
  updateResizeHandlerStates("up", event);
  recalculateIntersectingHandles({
    target,
    x,
    y
  });
  updateCursor();
  updateListeners();
}
function isWithinResizeHandle(element) {
  let currentElement = element;
  while (currentElement) {
    if (currentElement.hasAttribute(DATA_ATTRIBUTES.resizeHandle)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function recalculateIntersectingHandles({
  target,
  x,
  y
}) {
  intersectingHandles.splice(0);
  let targetElement = null;
  if (target instanceof HTMLElement || target instanceof SVGElement) {
    targetElement = target;
  }
  registeredResizeHandlers.forEach((data) => {
    const {
      element: dragHandleElement,
      hitAreaMargins
    } = data;
    const dragHandleRect = dragHandleElement.getBoundingClientRect();
    const {
      bottom,
      left,
      right,
      top
    } = dragHandleRect;
    const margin = isCoarsePointer ? hitAreaMargins.coarse : hitAreaMargins.fine;
    const eventIntersects = x >= left - margin && x <= right + margin && y >= top - margin && y <= bottom + margin;
    if (eventIntersects) {
      if (targetElement !== null && document.contains(targetElement) && dragHandleElement !== targetElement && !dragHandleElement.contains(targetElement) && !targetElement.contains(dragHandleElement) && compare(targetElement, dragHandleElement) > 0) {
        let currentElement = targetElement;
        let didIntersect = false;
        while (currentElement) {
          if (currentElement.contains(dragHandleElement)) {
            break;
          } else if (intersects(currentElement.getBoundingClientRect(), dragHandleRect, true)) {
            didIntersect = true;
            break;
          }
          currentElement = currentElement.parentElement;
        }
        if (didIntersect) {
          return;
        }
      }
      intersectingHandles.push(data);
    }
  });
}
function reportConstraintsViolation(resizeHandleId, flag) {
  panelConstraintFlags.set(resizeHandleId, flag);
}
function updateCursor() {
  let intersectsHorizontal = false;
  let intersectsVertical = false;
  intersectingHandles.forEach((data) => {
    const {
      direction
    } = data;
    if (direction === "horizontal") {
      intersectsHorizontal = true;
    } else {
      intersectsVertical = true;
    }
  });
  let constraintFlags = 0;
  panelConstraintFlags.forEach((flag) => {
    constraintFlags |= flag;
  });
  if (intersectsHorizontal && intersectsVertical) {
    setGlobalCursorStyle("intersection", constraintFlags, isPointerDown);
  } else if (intersectsHorizontal) {
    setGlobalCursorStyle("horizontal", constraintFlags, isPointerDown);
  } else if (intersectsVertical) {
    setGlobalCursorStyle("vertical", constraintFlags, isPointerDown);
  } else {
    resetGlobalCursorStyle();
  }
}
var listenersAbortController;
function updateListeners() {
  var _listenersAbortContro;
  (_listenersAbortContro = listenersAbortController) === null || _listenersAbortContro === undefined || _listenersAbortContro.abort();
  listenersAbortController = new AbortController;
  const options = {
    capture: true,
    signal: listenersAbortController.signal
  };
  if (!registeredResizeHandlers.size) {
    return;
  }
  if (isPointerDown) {
    if (intersectingHandles.length > 0) {
      ownerDocumentCounts.forEach((count, ownerDocument) => {
        const {
          body
        } = ownerDocument;
        if (count > 0) {
          body.addEventListener("contextmenu", handlePointerUp, options);
          body.addEventListener("pointerleave", handlePointerMove, options);
          body.addEventListener("pointermove", handlePointerMove, options);
        }
      });
    }
    ownerDocumentCounts.forEach((_, ownerDocument) => {
      const {
        body
      } = ownerDocument;
      body.addEventListener("pointerup", handlePointerUp, options);
      body.addEventListener("pointercancel", handlePointerUp, options);
    });
  } else {
    ownerDocumentCounts.forEach((count, ownerDocument) => {
      const {
        body
      } = ownerDocument;
      if (count > 0) {
        body.addEventListener("pointerdown", handlePointerDown, options);
        body.addEventListener("pointermove", handlePointerMove, options);
      }
    });
  }
}
function updateResizeHandlerStates(action, event) {
  registeredResizeHandlers.forEach((data) => {
    const {
      setResizeHandlerState
    } = data;
    const isActive = intersectingHandles.includes(data);
    setResizeHandlerState(action, isActive, event);
  });
}
function useForceUpdate() {
  const [_, setCount] = useState10(0);
  return useCallback2(() => setCount((prevCount) => prevCount + 1), []);
}
function assert(expectedCondition, message) {
  if (!expectedCondition) {
    console.error(message);
    throw Error(message);
  }
}
function fuzzyCompareNumbers(actual, expected, fractionDigits = PRECISION) {
  if (actual.toFixed(fractionDigits) === expected.toFixed(fractionDigits)) {
    return 0;
  } else {
    return actual > expected ? 1 : -1;
  }
}
function fuzzyNumbersEqual$1(actual, expected, fractionDigits = PRECISION) {
  return fuzzyCompareNumbers(actual, expected, fractionDigits) === 0;
}
function fuzzyNumbersEqual(actual, expected, fractionDigits) {
  return fuzzyCompareNumbers(actual, expected, fractionDigits) === 0;
}
function fuzzyLayoutsEqual(actual, expected, fractionDigits) {
  if (actual.length !== expected.length) {
    return false;
  }
  for (let index = 0;index < actual.length; index++) {
    const actualSize = actual[index];
    const expectedSize = expected[index];
    if (!fuzzyNumbersEqual(actualSize, expectedSize, fractionDigits)) {
      return false;
    }
  }
  return true;
}
function resizePanel({
  panelConstraints: panelConstraintsArray,
  panelIndex,
  size
}) {
  const panelConstraints = panelConstraintsArray[panelIndex];
  assert(panelConstraints != null, `Panel constraints not found for index ${panelIndex}`);
  let {
    collapsedSize = 0,
    collapsible,
    maxSize = 100,
    minSize = 0
  } = panelConstraints;
  if (fuzzyCompareNumbers(size, minSize) < 0) {
    if (collapsible) {
      const halfwayPoint = (collapsedSize + minSize) / 2;
      if (fuzzyCompareNumbers(size, halfwayPoint) < 0) {
        size = collapsedSize;
      } else {
        size = minSize;
      }
    } else {
      size = minSize;
    }
  }
  size = Math.min(maxSize, size);
  size = parseFloat(size.toFixed(PRECISION));
  return size;
}
function adjustLayoutByDelta({
  delta,
  initialLayout,
  panelConstraints: panelConstraintsArray,
  pivotIndices,
  prevLayout,
  trigger
}) {
  if (fuzzyNumbersEqual(delta, 0)) {
    return initialLayout;
  }
  const nextLayout = [...initialLayout];
  const [firstPivotIndex, secondPivotIndex] = pivotIndices;
  assert(firstPivotIndex != null, "Invalid first pivot index");
  assert(secondPivotIndex != null, "Invalid second pivot index");
  let deltaApplied = 0;
  {
    if (trigger === "keyboard") {
      {
        const index = delta < 0 ? secondPivotIndex : firstPivotIndex;
        const panelConstraints = panelConstraintsArray[index];
        assert(panelConstraints, `Panel constraints not found for index ${index}`);
        const {
          collapsedSize = 0,
          collapsible,
          minSize = 0
        } = panelConstraints;
        if (collapsible) {
          const prevSize = initialLayout[index];
          assert(prevSize != null, `Previous layout not found for panel index ${index}`);
          if (fuzzyNumbersEqual(prevSize, collapsedSize)) {
            const localDelta = minSize - prevSize;
            if (fuzzyCompareNumbers(localDelta, Math.abs(delta)) > 0) {
              delta = delta < 0 ? 0 - localDelta : localDelta;
            }
          }
        }
      }
      {
        const index = delta < 0 ? firstPivotIndex : secondPivotIndex;
        const panelConstraints = panelConstraintsArray[index];
        assert(panelConstraints, `No panel constraints found for index ${index}`);
        const {
          collapsedSize = 0,
          collapsible,
          minSize = 0
        } = panelConstraints;
        if (collapsible) {
          const prevSize = initialLayout[index];
          assert(prevSize != null, `Previous layout not found for panel index ${index}`);
          if (fuzzyNumbersEqual(prevSize, minSize)) {
            const localDelta = prevSize - collapsedSize;
            if (fuzzyCompareNumbers(localDelta, Math.abs(delta)) > 0) {
              delta = delta < 0 ? 0 - localDelta : localDelta;
            }
          }
        }
      }
    }
  }
  {
    const increment = delta < 0 ? 1 : -1;
    let index = delta < 0 ? secondPivotIndex : firstPivotIndex;
    let maxAvailableDelta = 0;
    while (true) {
      const prevSize = initialLayout[index];
      assert(prevSize != null, `Previous layout not found for panel index ${index}`);
      const maxSafeSize = resizePanel({
        panelConstraints: panelConstraintsArray,
        panelIndex: index,
        size: 100
      });
      const delta2 = maxSafeSize - prevSize;
      maxAvailableDelta += delta2;
      index += increment;
      if (index < 0 || index >= panelConstraintsArray.length) {
        break;
      }
    }
    const minAbsDelta = Math.min(Math.abs(delta), Math.abs(maxAvailableDelta));
    delta = delta < 0 ? 0 - minAbsDelta : minAbsDelta;
  }
  {
    const pivotIndex = delta < 0 ? firstPivotIndex : secondPivotIndex;
    let index = pivotIndex;
    while (index >= 0 && index < panelConstraintsArray.length) {
      const deltaRemaining = Math.abs(delta) - Math.abs(deltaApplied);
      const prevSize = initialLayout[index];
      assert(prevSize != null, `Previous layout not found for panel index ${index}`);
      const unsafeSize = prevSize - deltaRemaining;
      const safeSize = resizePanel({
        panelConstraints: panelConstraintsArray,
        panelIndex: index,
        size: unsafeSize
      });
      if (!fuzzyNumbersEqual(prevSize, safeSize)) {
        deltaApplied += prevSize - safeSize;
        nextLayout[index] = safeSize;
        if (deltaApplied.toFixed(3).localeCompare(Math.abs(delta).toFixed(3), undefined, {
          numeric: true
        }) >= 0) {
          break;
        }
      }
      if (delta < 0) {
        index--;
      } else {
        index++;
      }
    }
  }
  if (fuzzyLayoutsEqual(prevLayout, nextLayout)) {
    return prevLayout;
  }
  {
    const pivotIndex = delta < 0 ? secondPivotIndex : firstPivotIndex;
    const prevSize = initialLayout[pivotIndex];
    assert(prevSize != null, `Previous layout not found for panel index ${pivotIndex}`);
    const unsafeSize = prevSize + deltaApplied;
    const safeSize = resizePanel({
      panelConstraints: panelConstraintsArray,
      panelIndex: pivotIndex,
      size: unsafeSize
    });
    nextLayout[pivotIndex] = safeSize;
    if (!fuzzyNumbersEqual(safeSize, unsafeSize)) {
      let deltaRemaining = unsafeSize - safeSize;
      const pivotIndex2 = delta < 0 ? secondPivotIndex : firstPivotIndex;
      let index = pivotIndex2;
      while (index >= 0 && index < panelConstraintsArray.length) {
        const prevSize2 = nextLayout[index];
        assert(prevSize2 != null, `Previous layout not found for panel index ${index}`);
        const unsafeSize2 = prevSize2 + deltaRemaining;
        const safeSize2 = resizePanel({
          panelConstraints: panelConstraintsArray,
          panelIndex: index,
          size: unsafeSize2
        });
        if (!fuzzyNumbersEqual(prevSize2, safeSize2)) {
          deltaRemaining -= safeSize2 - prevSize2;
          nextLayout[index] = safeSize2;
        }
        if (fuzzyNumbersEqual(deltaRemaining, 0)) {
          break;
        }
        if (delta > 0) {
          index--;
        } else {
          index++;
        }
      }
    }
  }
  const totalSize = nextLayout.reduce((total, size) => size + total, 0);
  if (!fuzzyNumbersEqual(totalSize, 100)) {
    return prevLayout;
  }
  return nextLayout;
}
function calculateAriaValues({
  layout,
  panelsArray,
  pivotIndices
}) {
  let currentMinSize = 0;
  let currentMaxSize = 100;
  let totalMinSize = 0;
  let totalMaxSize = 0;
  const firstIndex = pivotIndices[0];
  assert(firstIndex != null, "No pivot index found");
  panelsArray.forEach((panelData, index) => {
    const {
      constraints
    } = panelData;
    const {
      maxSize = 100,
      minSize = 0
    } = constraints;
    if (index === firstIndex) {
      currentMinSize = minSize;
      currentMaxSize = maxSize;
    } else {
      totalMinSize += minSize;
      totalMaxSize += maxSize;
    }
  });
  const valueMax = Math.min(currentMaxSize, 100 - totalMinSize);
  const valueMin = Math.max(currentMinSize, 100 - totalMaxSize);
  const valueNow = layout[firstIndex];
  return {
    valueMax,
    valueMin,
    valueNow
  };
}
function getResizeHandleElementsForGroup(groupId, scope = document) {
  return Array.from(scope.querySelectorAll(`[${DATA_ATTRIBUTES.resizeHandleId}][data-panel-group-id="${groupId}"]`));
}
function getResizeHandleElementIndex(groupId, id, scope = document) {
  const handles = getResizeHandleElementsForGroup(groupId, scope);
  const index = handles.findIndex((handle) => handle.getAttribute(DATA_ATTRIBUTES.resizeHandleId) === id);
  return index !== null && index !== undefined ? index : null;
}
function determinePivotIndices(groupId, dragHandleId, panelGroupElement) {
  const index = getResizeHandleElementIndex(groupId, dragHandleId, panelGroupElement);
  return index != null ? [index, index + 1] : [-1, -1];
}
function isHTMLElement(target) {
  if (target instanceof HTMLElement) {
    return true;
  }
  return typeof target === "object" && target !== null && "tagName" in target && "getAttribute" in target;
}
function getPanelGroupElement(id, rootElement = document) {
  if (isHTMLElement(rootElement) && rootElement.dataset.panelGroupId == id) {
    return rootElement;
  }
  const element = rootElement.querySelector(`[data-panel-group][data-panel-group-id="${id}"]`);
  if (element) {
    return element;
  }
  return null;
}
function getResizeHandleElement(id, scope = document) {
  const element = scope.querySelector(`[${DATA_ATTRIBUTES.resizeHandleId}="${id}"]`);
  if (element) {
    return element;
  }
  return null;
}
function getResizeHandlePanelIds(groupId, handleId, panelsArray, scope = document) {
  var _panelsArray$index$id, _panelsArray$index, _panelsArray$id, _panelsArray;
  const handle = getResizeHandleElement(handleId, scope);
  const handles = getResizeHandleElementsForGroup(groupId, scope);
  const index = handle ? handles.indexOf(handle) : -1;
  const idBefore = (_panelsArray$index$id = (_panelsArray$index = panelsArray[index]) === null || _panelsArray$index === undefined ? undefined : _panelsArray$index.id) !== null && _panelsArray$index$id !== undefined ? _panelsArray$index$id : null;
  const idAfter = (_panelsArray$id = (_panelsArray = panelsArray[index + 1]) === null || _panelsArray === undefined ? undefined : _panelsArray.id) !== null && _panelsArray$id !== undefined ? _panelsArray$id : null;
  return [idBefore, idAfter];
}
function useWindowSplitterPanelGroupBehavior({
  committedValuesRef,
  eagerValuesRef,
  groupId,
  layout,
  panelDataArray,
  panelGroupElement,
  setLayout
}) {
  const devWarningsRef = useRef8({
    didWarnAboutMissingResizeHandle: false
  });
  useIsomorphicLayoutEffect(() => {
    if (!panelGroupElement) {
      return;
    }
    const resizeHandleElements = getResizeHandleElementsForGroup(groupId, panelGroupElement);
    for (let index = 0;index < panelDataArray.length - 1; index++) {
      const {
        valueMax,
        valueMin,
        valueNow
      } = calculateAriaValues({
        layout,
        panelsArray: panelDataArray,
        pivotIndices: [index, index + 1]
      });
      const resizeHandleElement = resizeHandleElements[index];
      if (resizeHandleElement == null) {
        {
          const {
            didWarnAboutMissingResizeHandle
          } = devWarningsRef.current;
          if (!didWarnAboutMissingResizeHandle) {
            devWarningsRef.current.didWarnAboutMissingResizeHandle = true;
            console.warn(`WARNING: Missing resize handle for PanelGroup "${groupId}"`);
          }
        }
      } else {
        const panelData = panelDataArray[index];
        assert(panelData, `No panel data found for index "${index}"`);
        resizeHandleElement.setAttribute("aria-controls", panelData.id);
        resizeHandleElement.setAttribute("aria-valuemax", "" + Math.round(valueMax));
        resizeHandleElement.setAttribute("aria-valuemin", "" + Math.round(valueMin));
        resizeHandleElement.setAttribute("aria-valuenow", valueNow != null ? "" + Math.round(valueNow) : "");
      }
    }
    return () => {
      resizeHandleElements.forEach((resizeHandleElement, index) => {
        resizeHandleElement.removeAttribute("aria-controls");
        resizeHandleElement.removeAttribute("aria-valuemax");
        resizeHandleElement.removeAttribute("aria-valuemin");
        resizeHandleElement.removeAttribute("aria-valuenow");
      });
    };
  }, [groupId, layout, panelDataArray, panelGroupElement]);
  useEffect8(() => {
    if (!panelGroupElement) {
      return;
    }
    const eagerValues = eagerValuesRef.current;
    assert(eagerValues, `Eager values not found`);
    const {
      panelDataArray: panelDataArray2
    } = eagerValues;
    const groupElement = getPanelGroupElement(groupId, panelGroupElement);
    assert(groupElement != null, `No group found for id "${groupId}"`);
    const handles = getResizeHandleElementsForGroup(groupId, panelGroupElement);
    assert(handles, `No resize handles found for group id "${groupId}"`);
    const cleanupFunctions = handles.map((handle) => {
      const handleId = handle.getAttribute(DATA_ATTRIBUTES.resizeHandleId);
      assert(handleId, `Resize handle element has no handle id attribute`);
      const [idBefore, idAfter] = getResizeHandlePanelIds(groupId, handleId, panelDataArray2, panelGroupElement);
      if (idBefore == null || idAfter == null) {
        return () => {};
      }
      const onKeyDown = (event) => {
        if (event.defaultPrevented) {
          return;
        }
        switch (event.key) {
          case "Enter": {
            event.preventDefault();
            const index = panelDataArray2.findIndex((panelData) => panelData.id === idBefore);
            if (index >= 0) {
              const panelData = panelDataArray2[index];
              assert(panelData, `No panel data found for index ${index}`);
              const size = layout[index];
              const {
                collapsedSize = 0,
                collapsible,
                minSize = 0
              } = panelData.constraints;
              if (size != null && collapsible) {
                const nextLayout = adjustLayoutByDelta({
                  delta: fuzzyNumbersEqual(size, collapsedSize) ? minSize - collapsedSize : collapsedSize - size,
                  initialLayout: layout,
                  panelConstraints: panelDataArray2.map((panelData2) => panelData2.constraints),
                  pivotIndices: determinePivotIndices(groupId, handleId, panelGroupElement),
                  prevLayout: layout,
                  trigger: "keyboard"
                });
                if (layout !== nextLayout) {
                  setLayout(nextLayout);
                }
              }
            }
            break;
          }
        }
      };
      handle.addEventListener("keydown", onKeyDown);
      return () => {
        handle.removeEventListener("keydown", onKeyDown);
      };
    });
    return () => {
      cleanupFunctions.forEach((cleanupFunction) => cleanupFunction());
    };
  }, [panelGroupElement, committedValuesRef, eagerValuesRef, groupId, layout, panelDataArray, setLayout]);
}
function areEqual(arrayA, arrayB) {
  if (arrayA.length !== arrayB.length) {
    return false;
  }
  for (let index = 0;index < arrayA.length; index++) {
    if (arrayA[index] !== arrayB[index]) {
      return false;
    }
  }
  return true;
}
function getResizeEventCursorPosition(direction, event) {
  const isHorizontal = direction === "horizontal";
  const {
    x,
    y
  } = getResizeEventCoordinates(event);
  return isHorizontal ? x : y;
}
function calculateDragOffsetPercentage(event, dragHandleId, direction, initialDragState, panelGroupElement) {
  const isHorizontal = direction === "horizontal";
  const handleElement = getResizeHandleElement(dragHandleId, panelGroupElement);
  assert(handleElement, `No resize handle element found for id "${dragHandleId}"`);
  const groupId = handleElement.getAttribute(DATA_ATTRIBUTES.groupId);
  assert(groupId, `Resize handle element has no group id attribute`);
  let {
    initialCursorPosition
  } = initialDragState;
  const cursorPosition = getResizeEventCursorPosition(direction, event);
  const groupElement = getPanelGroupElement(groupId, panelGroupElement);
  assert(groupElement, `No group element found for id "${groupId}"`);
  const groupRect = groupElement.getBoundingClientRect();
  const groupSizeInPixels = isHorizontal ? groupRect.width : groupRect.height;
  const offsetPixels = cursorPosition - initialCursorPosition;
  const offsetPercentage = offsetPixels / groupSizeInPixels * 100;
  return offsetPercentage;
}
function calculateDeltaPercentage(event, dragHandleId, direction, initialDragState, keyboardResizeBy, panelGroupElement) {
  if (isKeyDown(event)) {
    const isHorizontal = direction === "horizontal";
    let delta = 0;
    if (event.shiftKey) {
      delta = 100;
    } else if (keyboardResizeBy != null) {
      delta = keyboardResizeBy;
    } else {
      delta = 10;
    }
    let movement = 0;
    switch (event.key) {
      case "ArrowDown":
        movement = isHorizontal ? 0 : delta;
        break;
      case "ArrowLeft":
        movement = isHorizontal ? -delta : 0;
        break;
      case "ArrowRight":
        movement = isHorizontal ? delta : 0;
        break;
      case "ArrowUp":
        movement = isHorizontal ? 0 : -delta;
        break;
      case "End":
        movement = 100;
        break;
      case "Home":
        movement = -100;
        break;
    }
    return movement;
  } else {
    if (initialDragState == null) {
      return 0;
    }
    return calculateDragOffsetPercentage(event, dragHandleId, direction, initialDragState, panelGroupElement);
  }
}
function calculateUnsafeDefaultLayout({
  panelDataArray
}) {
  const layout = Array(panelDataArray.length);
  const panelConstraintsArray = panelDataArray.map((panelData) => panelData.constraints);
  let numPanelsWithSizes = 0;
  let remainingSize = 100;
  for (let index = 0;index < panelDataArray.length; index++) {
    const panelConstraints = panelConstraintsArray[index];
    assert(panelConstraints, `Panel constraints not found for index ${index}`);
    const {
      defaultSize
    } = panelConstraints;
    if (defaultSize != null) {
      numPanelsWithSizes++;
      layout[index] = defaultSize;
      remainingSize -= defaultSize;
    }
  }
  for (let index = 0;index < panelDataArray.length; index++) {
    const panelConstraints = panelConstraintsArray[index];
    assert(panelConstraints, `Panel constraints not found for index ${index}`);
    const {
      defaultSize
    } = panelConstraints;
    if (defaultSize != null) {
      continue;
    }
    const numRemainingPanels = panelDataArray.length - numPanelsWithSizes;
    const size = remainingSize / numRemainingPanels;
    numPanelsWithSizes++;
    layout[index] = size;
    remainingSize -= size;
  }
  return layout;
}
function callPanelCallbacks(panelsArray, layout, panelIdToLastNotifiedSizeMap) {
  layout.forEach((size, index) => {
    const panelData = panelsArray[index];
    assert(panelData, `Panel data not found for index ${index}`);
    const {
      callbacks,
      constraints,
      id: panelId
    } = panelData;
    const {
      collapsedSize = 0,
      collapsible
    } = constraints;
    const lastNotifiedSize = panelIdToLastNotifiedSizeMap[panelId];
    if (lastNotifiedSize == null || size !== lastNotifiedSize) {
      panelIdToLastNotifiedSizeMap[panelId] = size;
      const {
        onCollapse,
        onExpand,
        onResize
      } = callbacks;
      if (onResize) {
        onResize(size, lastNotifiedSize);
      }
      if (collapsible && (onCollapse || onExpand)) {
        if (onExpand && (lastNotifiedSize == null || fuzzyNumbersEqual$1(lastNotifiedSize, collapsedSize)) && !fuzzyNumbersEqual$1(size, collapsedSize)) {
          onExpand();
        }
        if (onCollapse && (lastNotifiedSize == null || !fuzzyNumbersEqual$1(lastNotifiedSize, collapsedSize)) && fuzzyNumbersEqual$1(size, collapsedSize)) {
          onCollapse();
        }
      }
    }
  });
}
function compareLayouts(a, b) {
  if (a.length !== b.length) {
    return false;
  } else {
    for (let index = 0;index < a.length; index++) {
      if (a[index] != b[index]) {
        return false;
      }
    }
  }
  return true;
}
function computePanelFlexBoxStyle({
  defaultSize,
  dragState,
  layout,
  panelData,
  panelIndex,
  precision = 3
}) {
  const size = layout[panelIndex];
  let flexGrow;
  if (size == null) {
    flexGrow = defaultSize != null ? defaultSize.toFixed(precision) : "1";
  } else if (panelData.length === 1) {
    flexGrow = "1";
  } else {
    flexGrow = size.toFixed(precision);
  }
  return {
    flexBasis: 0,
    flexGrow,
    flexShrink: 1,
    overflow: "hidden",
    pointerEvents: dragState !== null ? "none" : undefined
  };
}
function debounce(callback, durationMs = 10) {
  let timeoutId = null;
  let callable = (...args) => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      callback(...args);
    }, durationMs);
  };
  return callable;
}
function initializeDefaultStorage(storageObject) {
  try {
    if (typeof localStorage !== "undefined") {
      storageObject.getItem = (name) => {
        return localStorage.getItem(name);
      };
      storageObject.setItem = (name, value) => {
        localStorage.setItem(name, value);
      };
    } else {
      throw new Error("localStorage not supported in this environment");
    }
  } catch (error) {
    console.error(error);
    storageObject.getItem = () => null;
    storageObject.setItem = () => {};
  }
}
function getPanelGroupKey(autoSaveId) {
  return `react-resizable-panels:${autoSaveId}`;
}
function getPanelKey(panels) {
  return panels.map((panel) => {
    const {
      constraints,
      id,
      idIsFromProps,
      order
    } = panel;
    if (idIsFromProps) {
      return id;
    } else {
      return order ? `${order}:${JSON.stringify(constraints)}` : JSON.stringify(constraints);
    }
  }).sort((a, b) => a.localeCompare(b)).join(",");
}
function loadSerializedPanelGroupState(autoSaveId, storage) {
  try {
    const panelGroupKey = getPanelGroupKey(autoSaveId);
    const serialized = storage.getItem(panelGroupKey);
    if (serialized) {
      const parsed = JSON.parse(serialized);
      if (typeof parsed === "object" && parsed != null) {
        return parsed;
      }
    }
  } catch (error) {}
  return null;
}
function loadPanelGroupState(autoSaveId, panels, storage) {
  var _loadSerializedPanelG, _state$panelKey;
  const state = (_loadSerializedPanelG = loadSerializedPanelGroupState(autoSaveId, storage)) !== null && _loadSerializedPanelG !== undefined ? _loadSerializedPanelG : {};
  const panelKey = getPanelKey(panels);
  return (_state$panelKey = state[panelKey]) !== null && _state$panelKey !== undefined ? _state$panelKey : null;
}
function savePanelGroupState(autoSaveId, panels, panelSizesBeforeCollapse, sizes, storage) {
  var _loadSerializedPanelG2;
  const panelGroupKey = getPanelGroupKey(autoSaveId);
  const panelKey = getPanelKey(panels);
  const state = (_loadSerializedPanelG2 = loadSerializedPanelGroupState(autoSaveId, storage)) !== null && _loadSerializedPanelG2 !== undefined ? _loadSerializedPanelG2 : {};
  state[panelKey] = {
    expandToSizes: Object.fromEntries(panelSizesBeforeCollapse.entries()),
    layout: sizes
  };
  try {
    storage.setItem(panelGroupKey, JSON.stringify(state));
  } catch (error) {
    console.error(error);
  }
}
function validatePanelConstraints({
  panelConstraints: panelConstraintsArray,
  panelId,
  panelIndex
}) {
  {
    const warnings = [];
    const panelConstraints = panelConstraintsArray[panelIndex];
    assert(panelConstraints, `No panel constraints found for index ${panelIndex}`);
    const {
      collapsedSize = 0,
      collapsible = false,
      defaultSize,
      maxSize = 100,
      minSize = 0
    } = panelConstraints;
    if (minSize > maxSize) {
      warnings.push(`min size (${minSize}%) should not be greater than max size (${maxSize}%)`);
    }
    if (defaultSize != null) {
      if (defaultSize < 0) {
        warnings.push("default size should not be less than 0");
      } else if (defaultSize < minSize && (!collapsible || defaultSize !== collapsedSize)) {
        warnings.push("default size should not be less than min size");
      }
      if (defaultSize > 100) {
        warnings.push("default size should not be greater than 100");
      } else if (defaultSize > maxSize) {
        warnings.push("default size should not be greater than max size");
      }
    }
    if (collapsedSize > minSize) {
      warnings.push("collapsed size should not be greater than min size");
    }
    if (warnings.length > 0) {
      const name = panelId != null ? `Panel "${panelId}"` : "Panel";
      console.warn(`${name} has an invalid configuration:

${warnings.join(`
`)}`);
      return false;
    }
  }
  return true;
}
function validatePanelGroupLayout({
  layout: prevLayout,
  panelConstraints
}) {
  const nextLayout = [...prevLayout];
  const nextLayoutTotalSize = nextLayout.reduce((accumulated, current) => accumulated + current, 0);
  if (nextLayout.length !== panelConstraints.length) {
    throw Error(`Invalid ${panelConstraints.length} panel layout: ${nextLayout.map((size) => `${size}%`).join(", ")}`);
  } else if (!fuzzyNumbersEqual(nextLayoutTotalSize, 100) && nextLayout.length > 0) {
    {
      console.warn(`WARNING: Invalid layout total size: ${nextLayout.map((size) => `${size}%`).join(", ")}. Layout normalization will be applied.`);
    }
    for (let index = 0;index < panelConstraints.length; index++) {
      const unsafeSize = nextLayout[index];
      assert(unsafeSize != null, `No layout data found for index ${index}`);
      const safeSize = 100 / nextLayoutTotalSize * unsafeSize;
      nextLayout[index] = safeSize;
    }
  }
  let remainingSize = 0;
  for (let index = 0;index < panelConstraints.length; index++) {
    const unsafeSize = nextLayout[index];
    assert(unsafeSize != null, `No layout data found for index ${index}`);
    const safeSize = resizePanel({
      panelConstraints,
      panelIndex: index,
      size: unsafeSize
    });
    if (unsafeSize != safeSize) {
      remainingSize += unsafeSize - safeSize;
      nextLayout[index] = safeSize;
    }
  }
  if (!fuzzyNumbersEqual(remainingSize, 0)) {
    for (let index = 0;index < panelConstraints.length; index++) {
      const prevSize = nextLayout[index];
      assert(prevSize != null, `No layout data found for index ${index}`);
      const unsafeSize = prevSize + remainingSize;
      const safeSize = resizePanel({
        panelConstraints,
        panelIndex: index,
        size: unsafeSize
      });
      if (prevSize !== safeSize) {
        remainingSize -= safeSize - prevSize;
        nextLayout[index] = safeSize;
        if (fuzzyNumbersEqual(remainingSize, 0)) {
          break;
        }
      }
    }
  }
  return nextLayout;
}
var LOCAL_STORAGE_DEBOUNCE_INTERVAL = 100;
var defaultStorage = {
  getItem: (name) => {
    initializeDefaultStorage(defaultStorage);
    return defaultStorage.getItem(name);
  },
  setItem: (name, value) => {
    initializeDefaultStorage(defaultStorage);
    defaultStorage.setItem(name, value);
  }
};
var debounceMap = {};
function PanelGroupWithForwardedRef({
  autoSaveId = null,
  children,
  className: classNameFromProps = "",
  direction,
  forwardedRef,
  id: idFromProps = null,
  onLayout = null,
  keyboardResizeBy = null,
  storage = defaultStorage,
  style: styleFromProps,
  tagName: Type = "div",
  ...rest
}) {
  const groupId = useUniqueId(idFromProps);
  const panelGroupElementRef = useRef8(null);
  const [dragState, setDragState] = useState10(null);
  const [layout, setLayout] = useState10([]);
  const forceUpdate = useForceUpdate();
  const panelIdToLastNotifiedSizeMapRef = useRef8({});
  const panelSizeBeforeCollapseRef = useRef8(new Map);
  const prevDeltaRef = useRef8(0);
  const committedValuesRef = useRef8({
    autoSaveId,
    direction,
    dragState,
    id: groupId,
    keyboardResizeBy,
    onLayout,
    storage
  });
  const eagerValuesRef = useRef8({
    layout,
    panelDataArray: [],
    panelDataArrayChanged: false
  });
  const devWarningsRef = useRef8({
    didLogIdAndOrderWarning: false,
    didLogPanelConstraintsWarning: false,
    prevPanelIds: []
  });
  useImperativeHandle(forwardedRef, () => ({
    getId: () => committedValuesRef.current.id,
    getLayout: () => {
      const {
        layout: layout2
      } = eagerValuesRef.current;
      return layout2;
    },
    setLayout: (unsafeLayout) => {
      const {
        onLayout: onLayout2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      const safeLayout = validatePanelGroupLayout({
        layout: unsafeLayout,
        panelConstraints: panelDataArray.map((panelData) => panelData.constraints)
      });
      if (!areEqual(prevLayout, safeLayout)) {
        setLayout(safeLayout);
        eagerValuesRef.current.layout = safeLayout;
        if (onLayout2) {
          onLayout2(safeLayout);
        }
        callPanelCallbacks(panelDataArray, safeLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    }
  }), []);
  useIsomorphicLayoutEffect(() => {
    committedValuesRef.current.autoSaveId = autoSaveId;
    committedValuesRef.current.direction = direction;
    committedValuesRef.current.dragState = dragState;
    committedValuesRef.current.id = groupId;
    committedValuesRef.current.onLayout = onLayout;
    committedValuesRef.current.storage = storage;
  });
  useWindowSplitterPanelGroupBehavior({
    committedValuesRef,
    eagerValuesRef,
    groupId,
    layout,
    panelDataArray: eagerValuesRef.current.panelDataArray,
    setLayout,
    panelGroupElement: panelGroupElementRef.current
  });
  useEffect8(() => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    if (autoSaveId) {
      if (layout.length === 0 || layout.length !== panelDataArray.length) {
        return;
      }
      let debouncedSave = debounceMap[autoSaveId];
      if (debouncedSave == null) {
        debouncedSave = debounce(savePanelGroupState, LOCAL_STORAGE_DEBOUNCE_INTERVAL);
        debounceMap[autoSaveId] = debouncedSave;
      }
      const clonedPanelDataArray = [...panelDataArray];
      const clonedPanelSizesBeforeCollapse = new Map(panelSizeBeforeCollapseRef.current);
      debouncedSave(autoSaveId, clonedPanelDataArray, clonedPanelSizesBeforeCollapse, layout, storage);
    }
  }, [autoSaveId, layout, storage]);
  useEffect8(() => {
    {
      const {
        panelDataArray
      } = eagerValuesRef.current;
      const {
        didLogIdAndOrderWarning,
        didLogPanelConstraintsWarning,
        prevPanelIds
      } = devWarningsRef.current;
      if (!didLogIdAndOrderWarning) {
        const panelIds = panelDataArray.map(({
          id
        }) => id);
        devWarningsRef.current.prevPanelIds = panelIds;
        const panelsHaveChanged = prevPanelIds.length > 0 && !areEqual(prevPanelIds, panelIds);
        if (panelsHaveChanged) {
          if (panelDataArray.find(({
            idIsFromProps,
            order
          }) => !idIsFromProps || order == null)) {
            devWarningsRef.current.didLogIdAndOrderWarning = true;
            console.warn(`WARNING: Panel id and order props recommended when panels are dynamically rendered`);
          }
        }
      }
      if (!didLogPanelConstraintsWarning) {
        const panelConstraints = panelDataArray.map((panelData) => panelData.constraints);
        for (let panelIndex = 0;panelIndex < panelConstraints.length; panelIndex++) {
          const panelData = panelDataArray[panelIndex];
          assert(panelData, `Panel data not found for index ${panelIndex}`);
          const isValid = validatePanelConstraints({
            panelConstraints,
            panelId: panelData.id,
            panelIndex
          });
          if (!isValid) {
            devWarningsRef.current.didLogPanelConstraintsWarning = true;
            break;
          }
        }
      }
    }
  });
  const collapsePanel = useCallback2((panelData) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    if (panelData.constraints.collapsible) {
      const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
      const {
        collapsedSize = 0,
        panelSize,
        pivotIndices
      } = panelDataHelper(panelDataArray, panelData, prevLayout);
      assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
      if (!fuzzyNumbersEqual$1(panelSize, collapsedSize)) {
        panelSizeBeforeCollapseRef.current.set(panelData.id, panelSize);
        const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
        const delta = isLastPanel ? panelSize - collapsedSize : collapsedSize - panelSize;
        const nextLayout = adjustLayoutByDelta({
          delta,
          initialLayout: prevLayout,
          panelConstraints: panelConstraintsArray,
          pivotIndices,
          prevLayout,
          trigger: "imperative-api"
        });
        if (!compareLayouts(prevLayout, nextLayout)) {
          setLayout(nextLayout);
          eagerValuesRef.current.layout = nextLayout;
          if (onLayout2) {
            onLayout2(nextLayout);
          }
          callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
        }
      }
    }
  }, []);
  const expandPanel = useCallback2((panelData, minSizeOverride) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    if (panelData.constraints.collapsible) {
      const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
      const {
        collapsedSize = 0,
        panelSize = 0,
        minSize: minSizeFromProps = 0,
        pivotIndices
      } = panelDataHelper(panelDataArray, panelData, prevLayout);
      const minSize = minSizeOverride !== null && minSizeOverride !== undefined ? minSizeOverride : minSizeFromProps;
      if (fuzzyNumbersEqual$1(panelSize, collapsedSize)) {
        const prevPanelSize = panelSizeBeforeCollapseRef.current.get(panelData.id);
        const baseSize = prevPanelSize != null && prevPanelSize >= minSize ? prevPanelSize : minSize;
        const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
        const delta = isLastPanel ? panelSize - baseSize : baseSize - panelSize;
        const nextLayout = adjustLayoutByDelta({
          delta,
          initialLayout: prevLayout,
          panelConstraints: panelConstraintsArray,
          pivotIndices,
          prevLayout,
          trigger: "imperative-api"
        });
        if (!compareLayouts(prevLayout, nextLayout)) {
          setLayout(nextLayout);
          eagerValuesRef.current.layout = nextLayout;
          if (onLayout2) {
            onLayout2(nextLayout);
          }
          callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
        }
      }
    }
  }, []);
  const getPanelSize = useCallback2((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return panelSize;
  }, []);
  const getPanelStyle = useCallback2((panelData, defaultSize) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    const panelIndex = findPanelDataIndex(panelDataArray, panelData);
    return computePanelFlexBoxStyle({
      defaultSize,
      dragState,
      layout,
      panelData: panelDataArray,
      panelIndex
    });
  }, [dragState, layout]);
  const isPanelCollapsed = useCallback2((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize = 0,
      collapsible,
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return collapsible === true && fuzzyNumbersEqual$1(panelSize, collapsedSize);
  }, []);
  const isPanelExpanded = useCallback2((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize = 0,
      collapsible,
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return !collapsible || fuzzyCompareNumbers(panelSize, collapsedSize) > 0;
  }, []);
  const registerPanel = useCallback2((panelData) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    panelDataArray.push(panelData);
    panelDataArray.sort((panelA, panelB) => {
      const orderA = panelA.order;
      const orderB = panelB.order;
      if (orderA == null && orderB == null) {
        return 0;
      } else if (orderA == null) {
        return -1;
      } else if (orderB == null) {
        return 1;
      } else {
        return orderA - orderB;
      }
    });
    eagerValuesRef.current.panelDataArrayChanged = true;
    forceUpdate();
  }, [forceUpdate]);
  useIsomorphicLayoutEffect(() => {
    if (eagerValuesRef.current.panelDataArrayChanged) {
      eagerValuesRef.current.panelDataArrayChanged = false;
      const {
        autoSaveId: autoSaveId2,
        onLayout: onLayout2,
        storage: storage2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      let unsafeLayout = null;
      if (autoSaveId2) {
        const state = loadPanelGroupState(autoSaveId2, panelDataArray, storage2);
        if (state) {
          panelSizeBeforeCollapseRef.current = new Map(Object.entries(state.expandToSizes));
          unsafeLayout = state.layout;
        }
      }
      if (unsafeLayout == null) {
        unsafeLayout = calculateUnsafeDefaultLayout({
          panelDataArray
        });
      }
      const nextLayout = validatePanelGroupLayout({
        layout: unsafeLayout,
        panelConstraints: panelDataArray.map((panelData) => panelData.constraints)
      });
      if (!areEqual(prevLayout, nextLayout)) {
        setLayout(nextLayout);
        eagerValuesRef.current.layout = nextLayout;
        if (onLayout2) {
          onLayout2(nextLayout);
        }
        callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    }
  });
  useIsomorphicLayoutEffect(() => {
    const eagerValues = eagerValuesRef.current;
    return () => {
      eagerValues.layout = [];
    };
  }, []);
  const registerResizeHandle2 = useCallback2((dragHandleId) => {
    let isRTL = false;
    const panelGroupElement = panelGroupElementRef.current;
    if (panelGroupElement) {
      const style2 = window.getComputedStyle(panelGroupElement, null);
      if (style2.getPropertyValue("direction") === "rtl") {
        isRTL = true;
      }
    }
    return function resizeHandler(event) {
      event.preventDefault();
      const panelGroupElement2 = panelGroupElementRef.current;
      if (!panelGroupElement2) {
        return () => null;
      }
      const {
        direction: direction2,
        dragState: dragState2,
        id: groupId2,
        keyboardResizeBy: keyboardResizeBy2,
        onLayout: onLayout2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      const {
        initialLayout
      } = dragState2 !== null && dragState2 !== undefined ? dragState2 : {};
      const pivotIndices = determinePivotIndices(groupId2, dragHandleId, panelGroupElement2);
      let delta = calculateDeltaPercentage(event, dragHandleId, direction2, dragState2, keyboardResizeBy2, panelGroupElement2);
      const isHorizontal = direction2 === "horizontal";
      if (isHorizontal && isRTL) {
        delta = -delta;
      }
      const panelConstraints = panelDataArray.map((panelData) => panelData.constraints);
      const nextLayout = adjustLayoutByDelta({
        delta,
        initialLayout: initialLayout !== null && initialLayout !== undefined ? initialLayout : prevLayout,
        panelConstraints,
        pivotIndices,
        prevLayout,
        trigger: isKeyDown(event) ? "keyboard" : "mouse-or-touch"
      });
      const layoutChanged = !compareLayouts(prevLayout, nextLayout);
      if (isPointerEvent(event) || isMouseEvent(event)) {
        if (prevDeltaRef.current != delta) {
          prevDeltaRef.current = delta;
          if (!layoutChanged && delta !== 0) {
            if (isHorizontal) {
              reportConstraintsViolation(dragHandleId, delta < 0 ? EXCEEDED_HORIZONTAL_MIN : EXCEEDED_HORIZONTAL_MAX);
            } else {
              reportConstraintsViolation(dragHandleId, delta < 0 ? EXCEEDED_VERTICAL_MIN : EXCEEDED_VERTICAL_MAX);
            }
          } else {
            reportConstraintsViolation(dragHandleId, 0);
          }
        }
      }
      if (layoutChanged) {
        setLayout(nextLayout);
        eagerValuesRef.current.layout = nextLayout;
        if (onLayout2) {
          onLayout2(nextLayout);
        }
        callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    };
  }, []);
  const resizePanel2 = useCallback2((panelData, unsafePanelSize) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
    const {
      panelSize,
      pivotIndices
    } = panelDataHelper(panelDataArray, panelData, prevLayout);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
    const delta = isLastPanel ? panelSize - unsafePanelSize : unsafePanelSize - panelSize;
    const nextLayout = adjustLayoutByDelta({
      delta,
      initialLayout: prevLayout,
      panelConstraints: panelConstraintsArray,
      pivotIndices,
      prevLayout,
      trigger: "imperative-api"
    });
    if (!compareLayouts(prevLayout, nextLayout)) {
      setLayout(nextLayout);
      eagerValuesRef.current.layout = nextLayout;
      if (onLayout2) {
        onLayout2(nextLayout);
      }
      callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
    }
  }, []);
  const reevaluatePanelConstraints = useCallback2((panelData, prevConstraints) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize: prevCollapsedSize = 0,
      collapsible: prevCollapsible
    } = prevConstraints;
    const {
      collapsedSize: nextCollapsedSize = 0,
      collapsible: nextCollapsible,
      maxSize: nextMaxSize = 100,
      minSize: nextMinSize = 0
    } = panelData.constraints;
    const {
      panelSize: prevPanelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    if (prevPanelSize == null) {
      return;
    }
    if (prevCollapsible && nextCollapsible && fuzzyNumbersEqual$1(prevPanelSize, prevCollapsedSize)) {
      if (!fuzzyNumbersEqual$1(prevCollapsedSize, nextCollapsedSize)) {
        resizePanel2(panelData, nextCollapsedSize);
      }
    } else if (prevPanelSize < nextMinSize) {
      resizePanel2(panelData, nextMinSize);
    } else if (prevPanelSize > nextMaxSize) {
      resizePanel2(panelData, nextMaxSize);
    }
  }, [resizePanel2]);
  const startDragging = useCallback2((dragHandleId, event) => {
    const {
      direction: direction2
    } = committedValuesRef.current;
    const {
      layout: layout2
    } = eagerValuesRef.current;
    if (!panelGroupElementRef.current) {
      return;
    }
    const handleElement = getResizeHandleElement(dragHandleId, panelGroupElementRef.current);
    assert(handleElement, `Drag handle element not found for id "${dragHandleId}"`);
    const initialCursorPosition = getResizeEventCursorPosition(direction2, event);
    setDragState({
      dragHandleId,
      dragHandleRect: handleElement.getBoundingClientRect(),
      initialCursorPosition,
      initialLayout: layout2
    });
  }, []);
  const stopDragging = useCallback2(() => {
    setDragState(null);
  }, []);
  const unregisterPanel = useCallback2((panelData) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    const index = findPanelDataIndex(panelDataArray, panelData);
    if (index >= 0) {
      panelDataArray.splice(index, 1);
      delete panelIdToLastNotifiedSizeMapRef.current[panelData.id];
      eagerValuesRef.current.panelDataArrayChanged = true;
      forceUpdate();
    }
  }, [forceUpdate]);
  const context = useMemo3(() => ({
    collapsePanel,
    direction,
    dragState,
    expandPanel,
    getPanelSize,
    getPanelStyle,
    groupId,
    isPanelCollapsed,
    isPanelExpanded,
    reevaluatePanelConstraints,
    registerPanel,
    registerResizeHandle: registerResizeHandle2,
    resizePanel: resizePanel2,
    startDragging,
    stopDragging,
    unregisterPanel,
    panelGroupElement: panelGroupElementRef.current
  }), [collapsePanel, dragState, direction, expandPanel, getPanelSize, getPanelStyle, groupId, isPanelCollapsed, isPanelExpanded, reevaluatePanelConstraints, registerPanel, registerResizeHandle2, resizePanel2, startDragging, stopDragging, unregisterPanel]);
  const style = {
    display: "flex",
    flexDirection: direction === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return createElement(PanelGroupContext.Provider, {
    value: context
  }, createElement(Type, {
    ...rest,
    children,
    className: classNameFromProps,
    id: idFromProps,
    ref: panelGroupElementRef,
    style: {
      ...style,
      ...styleFromProps
    },
    [DATA_ATTRIBUTES.group]: "",
    [DATA_ATTRIBUTES.groupDirection]: direction,
    [DATA_ATTRIBUTES.groupId]: groupId
  }));
}
var PanelGroup = forwardRef((props2, ref) => createElement(PanelGroupWithForwardedRef, {
  ...props2,
  forwardedRef: ref
}));
PanelGroupWithForwardedRef.displayName = "PanelGroup";
PanelGroup.displayName = "forwardRef(PanelGroup)";
function findPanelDataIndex(panelDataArray, panelData) {
  return panelDataArray.findIndex((prevPanelData) => prevPanelData === panelData || prevPanelData.id === panelData.id);
}
function panelDataHelper(panelDataArray, panelData, layout) {
  const panelIndex = findPanelDataIndex(panelDataArray, panelData);
  const isLastPanel = panelIndex === panelDataArray.length - 1;
  const pivotIndices = isLastPanel ? [panelIndex - 1, panelIndex] : [panelIndex, panelIndex + 1];
  const panelSize = layout[panelIndex];
  return {
    ...panelData.constraints,
    panelSize,
    pivotIndices
  };
}
function useWindowSplitterResizeHandlerBehavior({
  disabled,
  handleId,
  resizeHandler,
  panelGroupElement
}) {
  useEffect8(() => {
    if (disabled || resizeHandler == null || panelGroupElement == null) {
      return;
    }
    const handleElement = getResizeHandleElement(handleId, panelGroupElement);
    if (handleElement == null) {
      return;
    }
    const onKeyDown = (event) => {
      if (event.defaultPrevented) {
        return;
      }
      switch (event.key) {
        case "ArrowDown":
        case "ArrowLeft":
        case "ArrowRight":
        case "ArrowUp":
        case "End":
        case "Home": {
          event.preventDefault();
          resizeHandler(event);
          break;
        }
        case "F6": {
          event.preventDefault();
          const groupId = handleElement.getAttribute(DATA_ATTRIBUTES.groupId);
          assert(groupId, `No group element found for id "${groupId}"`);
          const handles = getResizeHandleElementsForGroup(groupId, panelGroupElement);
          const index = getResizeHandleElementIndex(groupId, handleId, panelGroupElement);
          assert(index !== null, `No resize element found for id "${handleId}"`);
          const nextIndex = event.shiftKey ? index > 0 ? index - 1 : handles.length - 1 : index + 1 < handles.length ? index + 1 : 0;
          const nextHandle = handles[nextIndex];
          nextHandle.focus();
          break;
        }
      }
    };
    handleElement.addEventListener("keydown", onKeyDown);
    return () => {
      handleElement.removeEventListener("keydown", onKeyDown);
    };
  }, [panelGroupElement, disabled, handleId, resizeHandler]);
}
function PanelResizeHandle({
  children = null,
  className: classNameFromProps = "",
  disabled = false,
  hitAreaMargins,
  id: idFromProps,
  onBlur,
  onClick,
  onDragging,
  onFocus,
  onPointerDown,
  onPointerUp,
  style: styleFromProps = {},
  tabIndex = 0,
  tagName: Type = "div",
  ...rest
}) {
  var _hitAreaMargins$coars, _hitAreaMargins$fine;
  const elementRef = useRef8(null);
  const callbacksRef = useRef8({
    onClick,
    onDragging,
    onPointerDown,
    onPointerUp
  });
  useEffect8(() => {
    callbacksRef.current.onClick = onClick;
    callbacksRef.current.onDragging = onDragging;
    callbacksRef.current.onPointerDown = onPointerDown;
    callbacksRef.current.onPointerUp = onPointerUp;
  });
  const panelGroupContext = useContext2(PanelGroupContext);
  if (panelGroupContext === null) {
    throw Error(`PanelResizeHandle components must be rendered within a PanelGroup container`);
  }
  const {
    direction,
    groupId,
    registerResizeHandle: registerResizeHandleWithParentGroup,
    startDragging,
    stopDragging,
    panelGroupElement
  } = panelGroupContext;
  const resizeHandleId = useUniqueId(idFromProps);
  const [state, setState] = useState10("inactive");
  const [isFocused, setIsFocused] = useState10(false);
  const [resizeHandler, setResizeHandler] = useState10(null);
  const committedValuesRef = useRef8({
    state
  });
  useIsomorphicLayoutEffect(() => {
    committedValuesRef.current.state = state;
  });
  useEffect8(() => {
    if (disabled) {
      setResizeHandler(null);
    } else {
      const resizeHandler2 = registerResizeHandleWithParentGroup(resizeHandleId);
      setResizeHandler(() => resizeHandler2);
    }
  }, [disabled, resizeHandleId, registerResizeHandleWithParentGroup]);
  const coarseHitAreaMargins = (_hitAreaMargins$coars = hitAreaMargins === null || hitAreaMargins === undefined ? undefined : hitAreaMargins.coarse) !== null && _hitAreaMargins$coars !== undefined ? _hitAreaMargins$coars : 15;
  const fineHitAreaMargins = (_hitAreaMargins$fine = hitAreaMargins === null || hitAreaMargins === undefined ? undefined : hitAreaMargins.fine) !== null && _hitAreaMargins$fine !== undefined ? _hitAreaMargins$fine : 5;
  useEffect8(() => {
    if (disabled || resizeHandler == null) {
      return;
    }
    const element = elementRef.current;
    assert(element, "Element ref not attached");
    let didMove = false;
    const setResizeHandlerState = (action, isActive, event) => {
      if (!isActive) {
        setState("inactive");
        return;
      }
      switch (action) {
        case "down": {
          setState("drag");
          didMove = false;
          assert(event, 'Expected event to be defined for "down" action');
          startDragging(resizeHandleId, event);
          const {
            onDragging: onDragging2,
            onPointerDown: onPointerDown2
          } = callbacksRef.current;
          onDragging2 === null || onDragging2 === undefined || onDragging2(true);
          onPointerDown2 === null || onPointerDown2 === undefined || onPointerDown2();
          break;
        }
        case "move": {
          const {
            state: state2
          } = committedValuesRef.current;
          didMove = true;
          if (state2 !== "drag") {
            setState("hover");
          }
          assert(event, 'Expected event to be defined for "move" action');
          resizeHandler(event);
          break;
        }
        case "up": {
          setState("hover");
          stopDragging();
          const {
            onClick: onClick2,
            onDragging: onDragging2,
            onPointerUp: onPointerUp2
          } = callbacksRef.current;
          onDragging2 === null || onDragging2 === undefined || onDragging2(false);
          onPointerUp2 === null || onPointerUp2 === undefined || onPointerUp2();
          if (!didMove) {
            onClick2 === null || onClick2 === undefined || onClick2();
          }
          break;
        }
      }
    };
    return registerResizeHandle(resizeHandleId, element, direction, {
      coarse: coarseHitAreaMargins,
      fine: fineHitAreaMargins
    }, setResizeHandlerState);
  }, [coarseHitAreaMargins, direction, disabled, fineHitAreaMargins, registerResizeHandleWithParentGroup, resizeHandleId, resizeHandler, startDragging, stopDragging]);
  useWindowSplitterResizeHandlerBehavior({
    disabled,
    handleId: resizeHandleId,
    resizeHandler,
    panelGroupElement
  });
  const style = {
    touchAction: "none",
    userSelect: "none"
  };
  return createElement(Type, {
    ...rest,
    children,
    className: classNameFromProps,
    id: idFromProps,
    onBlur: () => {
      setIsFocused(false);
      onBlur === null || onBlur === undefined || onBlur();
    },
    onFocus: () => {
      setIsFocused(true);
      onFocus === null || onFocus === undefined || onFocus();
    },
    ref: elementRef,
    role: "separator",
    style: {
      ...style,
      ...styleFromProps
    },
    tabIndex,
    [DATA_ATTRIBUTES.groupDirection]: direction,
    [DATA_ATTRIBUTES.groupId]: groupId,
    [DATA_ATTRIBUTES.resizeHandle]: "",
    [DATA_ATTRIBUTES.resizeHandleActive]: state === "drag" ? "pointer" : isFocused ? "keyboard" : undefined,
    [DATA_ATTRIBUTES.resizeHandleEnabled]: !disabled,
    [DATA_ATTRIBUTES.resizeHandleId]: resizeHandleId,
    [DATA_ATTRIBUTES.resizeHandleState]: state
  });
}
PanelResizeHandle.displayName = "PanelResizeHandle";

// node_modules/@principal-ade/panels/dist/index.esm.js
import { flushSync as y, unstable_batchedUpdates as w, createPortal as x } from "react-dom";
function C(e2) {
  return { "--panel-background": e2.colors.background, "--panel-border": e2.colors.border, "--panel-handle": e2.colors.backgroundSecondary, "--panel-handle-hover": e2.colors.backgroundHover, "--panel-handle-active": e2.colors.primary, "--panel-button-bg": e2.colors.surface, "--panel-button-hover": e2.colors.backgroundHover, "--panel-button-border": e2.colors.border, "--panel-button-icon": e2.colors.textSecondary, "--panel-accent-bg": e2.colors.primary + "15" };
}
var R = ({ leftPanel: n2, rightPanel: r2, collapsibleSide: s2 = "left", defaultSize: c2 = 25, minSize: d2 = 5, className: u2 = "", collapsed: p2 = false, style: h2, showCollapseButton: m2 = false, animationDuration: f2 = 300, animationEasing: y2 = "cubic-bezier(0.4, 0, 0.2, 1)", onCollapseStart: w2, onCollapseComplete: x2, onExpandStart: S, onExpandComplete: R2, theme: N }) => {
  const [E, D] = o(p2), [z, M] = o(false), [T, A] = o(false), [k, L] = o(p2), [P, F] = o(p2 ? 0 : c2), $ = i(null), B = i(undefined), O = i(undefined), I = i(undefined), q = a((e2, t2, n3) => {
    if (!$.current)
      return;
    B.current && cancelAnimationFrame(B.current), O.current = performance.now();
    const r3 = (o2) => {
      if (!O.current || !$.current)
        return;
      const i2 = o2 - O.current, a2 = Math.min(i2 / f2, 1), l2 = a2 < 0.5 ? 4 * a2 * a2 * a2 : 1 - Math.pow(-2 * a2 + 2, 3) / 2, s3 = e2 + (t2 - e2) * l2;
      $.current.resize(s3), a2 < 1 ? B.current = requestAnimationFrame(r3) : (t2 === 0 ? $.current.collapse() : $.current.resize(t2), M(false), n3 && n3());
    };
    B.current = requestAnimationFrame(r3);
  }, [f2]), W = a(() => {
    z || T || (M(true), D(true), w2 && w2(), q(P, 0, () => {
      F(0), L(true), x2 && x2();
    }));
  }, [z, T, P, q, w2, x2]), _ = a(() => {
    z || T || (M(true), D(false), L(false), S && S(), q(0, c2, () => {
      F(c2), R2 && R2();
    }));
  }, [z, T, c2, q, S, R2]), j = a(() => {
    E ? _() : W();
  }, [E, W, _]), H = a((e2) => {
    z || (F(e2), e2 > 0 && D(false));
  }, [z]), K = a(() => {
    A(true);
  }, []), U = a(() => {
    A(false);
  }, []);
  l(() => {
    p2 !== E && (p2 ? W() : _());
  }, [p2]), l(() => {
    p2 && !z ? L(true) : p2 || z || L(false);
  }, [p2, z]), l(() => {
    const e2 = B.current, t2 = I.current;
    return () => {
      e2 && cancelAnimationFrame(e2), t2 && clearTimeout(t2);
    };
  }, []);
  const X = s2 === "left", Y = E ? X ? "▸" : "◂" : X ? "◂" : "▸", V = C(N), J = z && !T ? { transition: `flex ${f2}ms ${y2}` } : undefined, G = (e2) => {
    let t2 = "hybrid-panel";
    return e2 && (t2 += " collapsible-panel", z && !T && (t2 += " animating"), E && (t2 += " collapsed")), t2;
  };
  return e("div", { className: `animated-resizable-layout ${u2}`, style: { ...V, ...h2 }, children: /* @__PURE__ */ t(PanelGroup, { direction: "horizontal", onLayout: U, children: [
    /* @__PURE__ */ e(Panel, { ref: X ? $ : undefined, collapsible: X, defaultSize: X ? p2 ? 0 : c2 : undefined, minSize: X ? d2 : 30, collapsedSize: 0, onResize: X ? H : undefined, onCollapse: X ? () => D(true) : undefined, onExpand: X ? () => D(false) : undefined, className: G(X), style: X ? J : undefined, children: /* @__PURE__ */ e("div", { className: "panel-content-wrapper", style: { opacity: X && E ? 0 : 1, transition: z ? `opacity ${0.5 * f2}ms ${y2}` : "none" }, children: n2 }) }),
    /* @__PURE__ */ e(PanelResizeHandle, { className: "resize-handle " + (k ? "collapsed" : ""), onDragging: K, style: k ? { visibility: "hidden", width: 0 } : undefined, children: m2 && /* @__PURE__ */ e("div", { className: "handle-bar", children: /* @__PURE__ */ e("button", { onClick: j, className: "collapse-toggle", disabled: z, "aria-label": E ? "Expand panel" : "Collapse panel", children: Y }) }) }),
    /* @__PURE__ */ e(Panel, { ref: X ? undefined : $, collapsible: !X, defaultSize: X ? undefined : p2 ? 0 : c2, minSize: X ? 30 : d2, collapsedSize: 0, onResize: X ? undefined : H, onCollapse: X ? undefined : () => D(true), onExpand: X ? undefined : () => D(false), className: G(!X), style: X ? undefined : J, children: /* @__PURE__ */ e("div", { className: "panel-content-wrapper", style: { opacity: !X && E ? 0 : 1, transition: z ? `opacity ${0.5 * f2}ms ${y2}` : "none" }, children: r2 }) })
  ] }) });
};
var z = s(({ panels: o2, className: a2 = "", style: s2, theme: d2, minPanelWidth: u2 = 350, idealPanelWidth: p2 = 0.333, showSeparator: h2 = false, onPanelChange: m2, preventKeyboardScroll: f2 = true, disableSwipe: g = false }, v) => {
  const b = i(null), y2 = i(false), w2 = i(null), x2 = C(d2);
  c(v, () => ({ scrollToPanel: (e2) => {
    if (!b.current)
      return;
    const t2 = b.current, n2 = t2.children[e2];
    if (n2) {
      y2.current = true, w2.current && clearTimeout(w2.current);
      const e3 = n2.offsetLeft;
      t2.scrollTo({ left: e3, behavior: "smooth" }), w2.current = setTimeout(() => {
        y2.current = false;
      }, 500);
    }
  }, getCurrentPanel: () => {
    if (!b.current || b.current.children.length === 0)
      return 0;
    const e2 = b.current, t2 = e2.getBoundingClientRect().left;
    let n2 = 0, r2 = 1 / 0;
    for (let o3 = 0;o3 < e2.children.length; o3++) {
      const i2 = e2.children[o3].getBoundingClientRect(), a3 = Math.abs(i2.left - t2);
      a3 < r2 && (r2 = a3, n2 = o3);
    }
    return n2;
  } }));
  l(() => {
    if (!f2 || !b.current)
      return;
    const e2 = b.current, t2 = (e3) => {
      const t3 = e3.target;
      if (t3.tagName === "INPUT" || t3.tagName === "TEXTAREA" || t3.tagName === "SELECT" || t3.isContentEditable || t3.closest(".xterm") !== null || t3.closest('[contenteditable="true"]') !== null)
        return;
      [" ", "Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "PageUp", "PageDown"].includes(e3.key) && e3.preventDefault();
    };
    return e2.addEventListener("keydown", t2), () => {
      e2.removeEventListener("keydown", t2);
    };
  }, [f2]), l(() => () => {
    w2.current && clearTimeout(w2.current);
  }, []);
  const S = o2.length, R2 = 2 * u2;
  let N;
  N = S === 1 || S === 2 ? "100%" : `max(${u2}px, ${100 * p2}%)`;
  const E = r.useId().replace(/:/g, "_");
  return t(n, { children: [
    S === 2 && /* @__PURE__ */ e("style", { children: `
            .snap-carousel-container[data-carousel-id="${E}"][data-panel-count="2"] .snap-carousel-panel {
              width: 100%;
            }
            @container (min-width: ${R2}px) {
              .snap-carousel-container[data-carousel-id="${E}"][data-panel-count="2"] .snap-carousel-panel {
                width: 50%;
              }
            }
          ` }),
    /* @__PURE__ */ e("div", { ref: b, className: `snap-carousel-container ${g ? "swipe-disabled" : ""} ${a2}`, style: { ...x2, ...s2, "--snap-carousel-min-width": `${u2}px`, "--snap-carousel-ideal-width": 100 * p2 + "%", "--snap-carousel-gap": h2 ? "1px" : "0px", "--snap-carousel-panel-width": N, "--snap-carousel-panel-count": S, "--snap-carousel-two-panel-threshold": `${R2}px` }, onScroll: (e2) => {
      if (!m2 || !b.current || b.current.children.length === 0)
        return;
      if (y2.current)
        return;
      const t2 = b.current, n2 = t2.getBoundingClientRect().left;
      let r2 = 0, o3 = 1 / 0;
      for (let i2 = 0;i2 < t2.children.length; i2++) {
        const e3 = t2.children[i2].getBoundingClientRect(), a3 = Math.abs(e3.left - n2);
        a3 < o3 && (o3 = a3, r2 = i2);
      }
      m2(r2);
    }, "data-panel-count": S, "data-carousel-id": E, children: o2.map((t2, n2) => /* @__PURE__ */ e("div", { className: "snap-carousel-panel", children: t2 }, n2)) })
  ] });
});
z.displayName = "SnapCarousel";
var A = typeof window != "undefined" && window.document !== undefined && window.document.createElement !== undefined;
function k(e2) {
  const t2 = Object.prototype.toString.call(e2);
  return t2 === "[object Window]" || t2 === "[object global]";
}
function L(e2) {
  return "nodeType" in e2;
}
function P(e2) {
  var t2, n2;
  return e2 ? k(e2) ? e2 : L(e2) && (t2 = (n2 = e2.ownerDocument) == null ? undefined : n2.defaultView) != null ? t2 : window : window;
}
function F(e2) {
  const { Document: t2 } = P(e2);
  return e2 instanceof t2;
}
function $(e2) {
  return !k(e2) && e2 instanceof P(e2).HTMLElement;
}
function B(e2) {
  return e2 instanceof P(e2).SVGElement;
}
function O(e2) {
  return e2 ? k(e2) ? e2.document : L(e2) ? F(e2) ? e2 : $(e2) || B(e2) ? e2.ownerDocument : document : document : document;
}
function X(e2) {
  return function(t2) {
    for (var n2 = arguments.length, r2 = new Array(n2 > 1 ? n2 - 1 : 0), o2 = 1;o2 < n2; o2++)
      r2[o2 - 1] = arguments[o2];
    return r2.reduce((t3, n3) => {
      const r3 = Object.entries(n3);
      for (const [o3, i2] of r3) {
        const n4 = t3[o3];
        n4 != null && (t3[o3] = n4 + e2 * i2);
      }
      return t3;
    }, { ...t2 });
  };
}
var Y = /* @__PURE__ */ X(1);
var V = /* @__PURE__ */ X(-1);
function J(e2) {
  if (!e2)
    return false;
  const { KeyboardEvent: t2 } = P(e2.target);
  return t2 && e2 instanceof t2;
}
function G(e2) {
  if (function(e3) {
    if (!e3)
      return false;
    const { TouchEvent: t2 } = P(e3.target);
    return t2 && e3 instanceof t2;
  }(e2)) {
    if (e2.touches && e2.touches.length) {
      const { clientX: t2, clientY: n2 } = e2.touches[0];
      return { x: t2, y: n2 };
    }
    if (e2.changedTouches && e2.changedTouches.length) {
      const { clientX: t2, clientY: n2 } = e2.changedTouches[0];
      return { x: t2, y: n2 };
    }
  }
  return function(e3) {
    return "clientX" in e3 && "clientY" in e3;
  }(e2) ? { x: e2.clientX, y: e2.clientY } : null;
}
var le;
var se;
(se = le || (le = {})).DragStart = "dragStart", se.DragMove = "dragMove", se.DragEnd = "dragEnd", se.DragCancel = "dragCancel", se.DragOver = "dragOver", se.RegisterDroppable = "registerDroppable", se.SetDroppableDisabled = "setDroppableDisabled", se.UnregisterDroppable = "unregisterDroppable";
var de = /* @__PURE__ */ Object.freeze({ x: 0, y: 0 });
var xe = { ignoreTransform: false };
function Ce(e2, t2) {
  t2 === undefined && (t2 = xe);
  let n2 = e2.getBoundingClientRect();
  if (t2.ignoreTransform) {
    const { transform: t3, transformOrigin: r3 } = P(e2).getComputedStyle(e2);
    t3 && (n2 = function(e3, t4, n3) {
      const r4 = function(e4) {
        if (e4.startsWith("matrix3d(")) {
          const t5 = e4.slice(9, -1).split(/, /);
          return { x: +t5[12], y: +t5[13], scaleX: +t5[0], scaleY: +t5[5] };
        }
        if (e4.startsWith("matrix(")) {
          const t5 = e4.slice(7, -1).split(/, /);
          return { x: +t5[4], y: +t5[5], scaleX: +t5[0], scaleY: +t5[3] };
        }
        return null;
      }(t4);
      if (!r4)
        return e3;
      const { scaleX: o3, scaleY: i3, x: a3, y: l3 } = r4, s3 = e3.left - a3 - (1 - o3) * parseFloat(n3), c2 = e3.top - l3 - (1 - i3) * parseFloat(n3.slice(n3.indexOf(" ") + 1)), d2 = o3 ? e3.width / o3 : e3.width, u2 = i3 ? e3.height / i3 : e3.height;
      return { width: d2, height: u2, top: c2, right: s3 + d2, bottom: c2 + u2, left: s3 };
    }(n2, t3, r3));
  }
  const { top: r2, left: o2, width: i2, height: a2, bottom: l2, right: s2 } = n2;
  return { top: r2, left: o2, width: i2, height: a2, bottom: l2, right: s2 };
}
function Se(e2) {
  return Ce(e2, { ignoreTransform: true });
}
function Re(e2, t2) {
  const n2 = [];
  return e2 ? function r(o2) {
    if (t2 != null && n2.length >= t2)
      return n2;
    if (!o2)
      return n2;
    if (F(o2) && o2.scrollingElement != null && !n2.includes(o2.scrollingElement))
      return n2.push(o2.scrollingElement), n2;
    if (!$(o2) || B(o2))
      return n2;
    if (n2.includes(o2))
      return n2;
    const i2 = P(e2).getComputedStyle(o2);
    return o2 !== e2 && function(e3, t3) {
      t3 === undefined && (t3 = P(e3).getComputedStyle(e3));
      const n3 = /(auto|scroll|overlay)/;
      return ["overflow", "overflowX", "overflowY"].some((e4) => {
        const r2 = t3[e4];
        return typeof r2 == "string" && n3.test(r2);
      });
    }(o2, i2) && n2.push(o2), function(e3, t3) {
      return t3 === undefined && (t3 = P(e3).getComputedStyle(e3)), t3.position === "fixed";
    }(o2, i2) ? n2 : r(o2.parentNode);
  }(e2) : n2;
}
function Ne(e2) {
  const [t2] = Re(e2, 1);
  return t2 != null ? t2 : null;
}
var Te;
var Ae;
function ke(e2) {
  return !(!A || !e2) && e2 === document.scrollingElement;
}
function Le(e2) {
  const t2 = { x: 0, y: 0 }, n2 = ke(e2) ? { height: window.innerHeight, width: window.innerWidth } : { height: e2.clientHeight, width: e2.clientWidth }, r2 = { x: e2.scrollWidth - n2.width, y: e2.scrollHeight - n2.height };
  return { isTop: e2.scrollTop <= t2.y, isLeft: e2.scrollLeft <= t2.x, isBottom: e2.scrollTop >= r2.y, isRight: e2.scrollLeft >= r2.x, maxScroll: r2, minScroll: t2 };
}
(Ae = Te || (Te = {}))[Ae.Forward = 1] = "Forward", Ae[Ae.Backward = -1] = "Backward";
function $e(e2) {
  if (e2 === document.scrollingElement) {
    const { innerWidth: e3, innerHeight: t3 } = window;
    return { top: 0, left: 0, right: e3, bottom: t3, width: e3, height: t3 };
  }
  const { top: t2, left: n2, right: r2, bottom: o2 } = e2.getBoundingClientRect();
  return { top: t2, left: n2, right: r2, bottom: o2, width: e2.clientWidth, height: e2.clientHeight };
}
class qe {
  constructor(e2) {
    this.target = undefined, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((e3) => {
        var t2;
        return (t2 = this.target) == null ? undefined : t2.removeEventListener(...e3);
      });
    }, this.target = e2;
  }
  add(e2, t2, n2) {
    var r2;
    (r2 = this.target) == null || r2.addEventListener(e2, t2, n2), this.listeners.push([e2, t2, n2]);
  }
}
function We(e2, t2) {
  const n2 = Math.abs(e2.x), r2 = Math.abs(e2.y);
  return typeof t2 == "number" ? Math.sqrt(n2 ** 2 + r2 ** 2) > t2 : ("x" in t2) && ("y" in t2) ? n2 > t2.x && r2 > t2.y : ("x" in t2) ? n2 > t2.x : ("y" in t2) && r2 > t2.y;
}
var _e;
var je;
var He;
var Ke;
function Ue(e2) {
  e2.preventDefault();
}
function Xe(e2) {
  e2.stopPropagation();
}
(je = _e || (_e = {})).Click = "click", je.DragStart = "dragstart", je.Keydown = "keydown", je.ContextMenu = "contextmenu", je.Resize = "resize", je.SelectionChange = "selectionchange", je.VisibilityChange = "visibilitychange", (Ke = He || (He = {})).Space = "Space", Ke.Down = "ArrowDown", Ke.Right = "ArrowRight", Ke.Left = "ArrowLeft", Ke.Up = "ArrowUp", Ke.Esc = "Escape", Ke.Enter = "Enter", Ke.Tab = "Tab";
var Ye = { start: [He.Space, He.Enter], cancel: [He.Esc], end: [He.Space, He.Enter, He.Tab] };
var Ve = (e2, t2) => {
  let { currentCoordinates: n2 } = t2;
  switch (e2.code) {
    case He.Right:
      return { ...n2, x: n2.x + 25 };
    case He.Left:
      return { ...n2, x: n2.x - 25 };
    case He.Down:
      return { ...n2, y: n2.y + 25 };
    case He.Up:
      return { ...n2, y: n2.y - 25 };
  }
};

class Je {
  constructor(e2) {
    this.props = undefined, this.autoScrollEnabled = false, this.referenceCoordinates = undefined, this.listeners = undefined, this.windowListeners = undefined, this.props = e2;
    const { event: { target: t2 } } = e2;
    this.props = e2, this.listeners = new qe(O(t2)), this.windowListeners = new qe(P(t2)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(_e.Resize, this.handleCancel), this.windowListeners.add(_e.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(_e.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const { activeNode: e2, onStart: t2 } = this.props, n2 = e2.node.current;
    n2 && function(e3, t3) {
      if (t3 === undefined && (t3 = Ce), !e3)
        return;
      const { top: n3, left: r2, bottom: o2, right: i2 } = t3(e3);
      Ne(e3) && (o2 <= 0 || i2 <= 0 || n3 >= window.innerHeight || r2 >= window.innerWidth) && e3.scrollIntoView({ block: "center", inline: "center" });
    }(n2), t2(de);
  }
  handleKeyDown(e2) {
    if (J(e2)) {
      const { active: t2, context: n2, options: r2 } = this.props, { keyboardCodes: o2 = Ye, coordinateGetter: i2 = Ve, scrollBehavior: a2 = "smooth" } = r2, { code: l2 } = e2;
      if (o2.end.includes(l2))
        return void this.handleEnd(e2);
      if (o2.cancel.includes(l2))
        return void this.handleCancel(e2);
      const { collisionRect: s2 } = n2.current, c2 = s2 ? { x: s2.left, y: s2.top } : de;
      this.referenceCoordinates || (this.referenceCoordinates = c2);
      const d2 = i2(e2, { active: t2, context: n2.current, currentCoordinates: c2 });
      if (d2) {
        const t3 = V(d2, c2), r3 = { x: 0, y: 0 }, { scrollableAncestors: o3 } = n2.current;
        for (const n3 of o3) {
          const o4 = e2.code, { isTop: i3, isRight: l3, isLeft: s3, isBottom: c3, maxScroll: u2, minScroll: p2 } = Le(n3), h2 = $e(n3), m2 = { x: Math.min(o4 === He.Right ? h2.right - h2.width / 2 : h2.right, Math.max(o4 === He.Right ? h2.left : h2.left + h2.width / 2, d2.x)), y: Math.min(o4 === He.Down ? h2.bottom - h2.height / 2 : h2.bottom, Math.max(o4 === He.Down ? h2.top : h2.top + h2.height / 2, d2.y)) }, f2 = o4 === He.Right && !l3 || o4 === He.Left && !s3, g = o4 === He.Down && !c3 || o4 === He.Up && !i3;
          if (f2 && m2.x !== d2.x) {
            const e3 = n3.scrollLeft + t3.x, i4 = o4 === He.Right && e3 <= u2.x || o4 === He.Left && e3 >= p2.x;
            if (i4 && !t3.y)
              return void n3.scrollTo({ left: e3, behavior: a2 });
            r3.x = i4 ? n3.scrollLeft - e3 : o4 === He.Right ? n3.scrollLeft - u2.x : n3.scrollLeft - p2.x, r3.x && n3.scrollBy({ left: -r3.x, behavior: a2 });
            break;
          }
          if (g && m2.y !== d2.y) {
            const e3 = n3.scrollTop + t3.y, i4 = o4 === He.Down && e3 <= u2.y || o4 === He.Up && e3 >= p2.y;
            if (i4 && !t3.x)
              return void n3.scrollTo({ top: e3, behavior: a2 });
            r3.y = i4 ? n3.scrollTop - e3 : o4 === He.Down ? n3.scrollTop - u2.y : n3.scrollTop - p2.y, r3.y && n3.scrollBy({ top: -r3.y, behavior: a2 });
            break;
          }
        }
        this.handleMove(e2, Y(V(d2, this.referenceCoordinates), r3));
      }
    }
  }
  handleMove(e2, t2) {
    const { onMove: n2 } = this.props;
    e2.preventDefault(), n2(t2);
  }
  handleEnd(e2) {
    const { onEnd: t2 } = this.props;
    e2.preventDefault(), this.detach(), t2();
  }
  handleCancel(e2) {
    const { onCancel: t2 } = this.props;
    e2.preventDefault(), this.detach(), t2();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
function Ge(e2) {
  return Boolean(e2 && "distance" in e2);
}
function Qe(e2) {
  return Boolean(e2 && "delay" in e2);
}
Je.activators = [{ eventName: "onKeyDown", handler: (e2, t2, n2) => {
  let { keyboardCodes: r2 = Ye, onActivation: o2 } = t2, { active: i2 } = n2;
  const { code: a2 } = e2.nativeEvent;
  if (r2.start.includes(a2)) {
    const t3 = i2.activatorNode.current;
    return (!t3 || e2.target === t3) && (e2.preventDefault(), o2 == null || o2({ event: e2.nativeEvent }), true);
  }
  return false;
} }];

class Ze {
  constructor(e2, t2, n2) {
    var r2;
    n2 === undefined && (n2 = function(e3) {
      const { EventTarget: t3 } = P(e3);
      return e3 instanceof t3 ? e3 : O(e3);
    }(e2.event.target)), this.props = undefined, this.events = undefined, this.autoScrollEnabled = true, this.document = undefined, this.activated = false, this.initialCoordinates = undefined, this.timeoutId = null, this.listeners = undefined, this.documentListeners = undefined, this.windowListeners = undefined, this.props = e2, this.events = t2;
    const { event: o2 } = e2, { target: i2 } = o2;
    this.props = e2, this.events = t2, this.document = O(i2), this.documentListeners = new qe(this.document), this.listeners = new qe(n2), this.windowListeners = new qe(P(i2)), this.initialCoordinates = (r2 = G(o2)) != null ? r2 : de, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const { events: e2, props: { options: { activationConstraint: t2, bypassActivationConstraint: n2 } } } = this;
    if (this.listeners.add(e2.move.name, this.handleMove, { passive: false }), this.listeners.add(e2.end.name, this.handleEnd), e2.cancel && this.listeners.add(e2.cancel.name, this.handleCancel), this.windowListeners.add(_e.Resize, this.handleCancel), this.windowListeners.add(_e.DragStart, Ue), this.windowListeners.add(_e.VisibilityChange, this.handleCancel), this.windowListeners.add(_e.ContextMenu, Ue), this.documentListeners.add(_e.Keydown, this.handleKeydown), t2) {
      if (n2 != null && n2({ event: this.props.event, activeNode: this.props.activeNode, options: this.props.options }))
        return this.handleStart();
      if (Qe(t2))
        return this.timeoutId = setTimeout(this.handleStart, t2.delay), void this.handlePending(t2);
      if (Ge(t2))
        return void this.handlePending(t2);
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(e2, t2) {
    const { active: n2, onPending: r2 } = this.props;
    r2(n2, e2, this.initialCoordinates, t2);
  }
  handleStart() {
    const { initialCoordinates: e2 } = this, { onStart: t2 } = this.props;
    e2 && (this.activated = true, this.documentListeners.add(_e.Click, Xe, { capture: true }), this.removeTextSelection(), this.documentListeners.add(_e.SelectionChange, this.removeTextSelection), t2(e2));
  }
  handleMove(e2) {
    var t2;
    const { activated: n2, initialCoordinates: r2, props: o2 } = this, { onMove: i2, options: { activationConstraint: a2 } } = o2;
    if (!r2)
      return;
    const l2 = (t2 = G(e2)) != null ? t2 : de, s2 = V(r2, l2);
    if (!n2 && a2) {
      if (Ge(a2)) {
        if (a2.tolerance != null && We(s2, a2.tolerance))
          return this.handleCancel();
        if (We(s2, a2.distance))
          return this.handleStart();
      }
      return Qe(a2) && We(s2, a2.tolerance) ? this.handleCancel() : void this.handlePending(a2, s2);
    }
    e2.cancelable && e2.preventDefault(), i2(l2);
  }
  handleEnd() {
    const { onAbort: e2, onEnd: t2 } = this.props;
    this.detach(), this.activated || e2(this.props.active), t2();
  }
  handleCancel() {
    const { onAbort: e2, onCancel: t2 } = this.props;
    this.detach(), this.activated || e2(this.props.active), t2();
  }
  handleKeydown(e2) {
    e2.code === He.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var e2;
    (e2 = this.document.getSelection()) == null || e2.removeAllRanges();
  }
}
var et = { cancel: { name: "pointercancel" }, move: { name: "pointermove" }, end: { name: "pointerup" } };

class tt extends Ze {
  constructor(e2) {
    const { event: t2 } = e2, n2 = O(t2.target);
    super(e2, et, n2);
  }
}
tt.activators = [{ eventName: "onPointerDown", handler: (e2, t2) => {
  let { nativeEvent: n2 } = e2, { onActivation: r2 } = t2;
  return !(!n2.isPrimary || n2.button !== 0) && (r2 == null || r2({ event: n2 }), true);
} }];
var nt = { move: { name: "mousemove" }, end: { name: "mouseup" } };
var rt;
var ot;
(ot = rt || (rt = {}))[ot.RightClick = 2] = "RightClick";
(class extends Ze {
  constructor(e2) {
    super(e2, nt, O(e2.event.target));
  }
}).activators = [{ eventName: "onMouseDown", handler: (e2, t2) => {
  let { nativeEvent: n2 } = e2, { onActivation: r2 } = t2;
  return n2.button !== rt.RightClick && (r2 == null || r2({ event: n2 }), true);
} }];
var it = { cancel: { name: "touchcancel" }, move: { name: "touchmove" }, end: { name: "touchend" } };
var at;
var lt;
var st;
var ct;
(class extends Ze {
  constructor(e2) {
    super(e2, it);
  }
  static setup() {
    return window.addEventListener(it.move.name, e2, { capture: false, passive: false }), function() {
      window.removeEventListener(it.move.name, e2);
    };
    function e2() {}
  }
}).activators = [{ eventName: "onTouchStart", handler: (e2, t2) => {
  let { nativeEvent: n2 } = e2, { onActivation: r2 } = t2;
  const { touches: o2 } = n2;
  return !(o2.length > 1) && (r2 == null || r2({ event: n2 }), true);
} }], (lt = at || (at = {}))[lt.Pointer = 0] = "Pointer", lt[lt.DraggableRect = 1] = "DraggableRect", (ct = st || (st = {}))[ct.TreeOrder = 0] = "TreeOrder", ct[ct.ReversedTreeOrder = 1] = "ReversedTreeOrder";
var ut = { x: { [Te.Backward]: false, [Te.Forward]: false }, y: { [Te.Backward]: false, [Te.Forward]: false } };
var pt;
var ht;
var mt;
(ht = pt || (pt = {}))[ht.Always = 0] = "Always", ht[ht.BeforeDragging = 1] = "BeforeDragging", ht[ht.WhileDragging = 2] = "WhileDragging", (mt || (mt = {})).Optimized = "optimized";
var Dt = { draggable: { measure: Se }, droppable: { measure: Se, strategy: pt.WhileDragging, frequency: mt.Optimized }, dragOverlay: { measure: Ce } };
var Ft = /* @__PURE__ */ p({ ...de, scaleX: 1, scaleY: 1 });
var $t;
var Bt;
(Bt = $t || ($t = {}))[Bt.Uninitialized = 0] = "Uninitialized", Bt[Bt.Initializing = 1] = "Initializing", Bt[Bt.Initialized = 2] = "Initialized";
var Ut;
var Xt = (() => {
  if (typeof window != "undefined") {
    const e2 = window;
    return e2.__principlemd_theme_context__ || (e2.__principlemd_theme_context__ = p(undefined)), e2.__principlemd_theme_context__;
  }
  return Ut || (Ut = p(undefined)), Ut;
})();

// industryMarkdown/components/SlidePresentation.tsx
import React18, { useState as useState11, useCallback as useCallback3, useRef as useRef10, useEffect as useEffect10 } from "react";

// industryMarkdown/utils/extractSlideTitles.ts
function extractSlideTitle2(content, slideIndex) {
  const lines = content.split(`
`);
  for (const line of lines) {
    const trimmedLine = line.trim();
    if (trimmedLine.startsWith("#")) {
      const match = trimmedLine.match(/^#{1,2}\s+(.+)$/);
      if (match && match[1]) {
        return match[1].replace(/\*\*/g, "").replace(/\*/g, "").replace(/`/g, "").replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").trim();
      }
    }
  }
  return `Slide ${slideIndex + 1}`;
}
function extractAllSlideTitles(slides) {
  return slides.map((slide, index) => extractSlideTitle2(slide, index));
}

// industryMarkdown/components/SlideNavigationHeader.tsx
import {
  ChevronLeft,
  ChevronRight,
  Maximize2,
  Minimize2,
  Menu,
  PanelLeftClose,
  PanelRightClose,
  Columns,
  ExternalLink,
  X as X2
} from "lucide-react";
import React16 from "react";

// industryMarkdown/components/FocusLeftIcon.tsx
import React15 from "react";
var FocusLeftIcon = ({
  size = 18,
  color = "currentColor",
  style
}) => /* @__PURE__ */ React15.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style
}, /* @__PURE__ */ React15.createElement("rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "1"
}), /* @__PURE__ */ React15.createElement("path", {
  d: "M9 12L15 12M15 12L12 9M15 12L12 15",
  strokeWidth: "1.5"
}));
var FocusRightIcon = ({
  size = 18,
  color = "currentColor",
  style
}) => /* @__PURE__ */ React15.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style
}, /* @__PURE__ */ React15.createElement("rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "1"
}), /* @__PURE__ */ React15.createElement("path", {
  d: "M15 12L9 12M9 12L12 9M9 12L12 15",
  strokeWidth: "1.5"
}));

// industryMarkdown/components/SlideNavigationHeader.tsx
var HeaderButton = ({
  onClick,
  disabled = false,
  active = false,
  title,
  theme: theme2,
  children,
  width = "36px",
  minWidth,
  padding
}) => {
  const [isHovered, setIsHovered] = React16.useState(false);
  return /* @__PURE__ */ React16.createElement("button", {
    onClick,
    disabled,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: theme2.space[1],
      width: minWidth ? undefined : width,
      minWidth,
      height: "36px",
      padding: padding || (minWidth ? `0 ${theme2.space[2]}px` : undefined),
      backgroundColor: isHovered && !disabled && !active ? theme2.colors.backgroundSecondary : active ? theme2.colors.primary : "transparent",
      border: `1px solid ${isHovered && !disabled ? theme2.colors.text : active ? theme2.colors.primary : theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: active ? theme2.colors.background : disabled ? theme2.colors.muted : isHovered ? theme2.colors.text : theme2.colors.textSecondary,
      cursor: disabled ? "not-allowed" : "pointer",
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.body,
      opacity: disabled ? 0.5 : 1,
      transition: "all 0.2s ease"
    },
    title
  }, children);
};
var SlideNavigationHeader = ({
  currentSlide,
  totalSlides,
  showTOC,
  isFullscreen,
  showSlideCounter,
  showFullscreenButton,
  showPopoutButton = false,
  isPopout = false,
  isMobile = false,
  theme: theme2,
  viewMode = "single",
  tocDisplayMode = "overlay",
  collapseLeft = false,
  collapseRight = false,
  onPrevious,
  onNext,
  onToggleTOC,
  onToggleFullscreen,
  onPopout,
  onClose,
  onCollapseLeft,
  onCollapseRight
}) => {
  const navigationHeight = "48px";
  return /* @__PURE__ */ React16.createElement("div", {
    style: {
      height: navigationHeight,
      minHeight: navigationHeight,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: `0 ${theme2.space[3]}px`,
      borderBottom: `1px solid ${theme2.colors.border}`,
      backgroundColor: theme2.colors.background,
      flexShrink: 0
    }
  }, /* @__PURE__ */ React16.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: theme2.space[2]
    }
  }, /* @__PURE__ */ React16.createElement(HeaderButton, {
    onClick: onToggleTOC,
    active: showTOC,
    theme: theme2,
    title: tocDisplayMode === "sidebar" ? showTOC ? "Hide table of contents (T)" : "Show table of contents (T)" : showTOC ? "Close table of contents (Esc)" : "Open table of contents (T)"
  }, /* @__PURE__ */ React16.createElement(Menu, {
    size: 18
  })), /* @__PURE__ */ React16.createElement(HeaderButton, {
    onClick: onPrevious,
    disabled: currentSlide === 0,
    theme: theme2,
    title: "Previous slide",
    minWidth: isMobile ? undefined : "100px",
    width: isMobile ? "36px" : undefined
  }, /* @__PURE__ */ React16.createElement(ChevronLeft, {
    size: 18
  }), !isMobile && "Previous"), viewMode === "book" && onCollapseLeft && /* @__PURE__ */ React16.createElement(HeaderButton, {
    onClick: onCollapseLeft,
    active: collapseRight,
    theme: theme2,
    title: collapseLeft ? "Expand left panel" : collapseRight ? "Show both panels" : "Focus on left panel"
  }, collapseLeft ? /* @__PURE__ */ React16.createElement(PanelLeftClose, {
    size: 18,
    style: { transform: "rotate(180deg)" }
  }) : collapseRight ? /* @__PURE__ */ React16.createElement(Columns, {
    size: 18
  }) : /* @__PURE__ */ React16.createElement(FocusLeftIcon, {
    size: 18
  }))), showSlideCounter && /* @__PURE__ */ React16.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.monospace
    }
  }, viewMode === "book" ? /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement("span", {
    style: { fontWeight: 600 }
  }, Math.floor(currentSlide / 2) + 1), /* @__PURE__ */ React16.createElement("span", {
    style: { opacity: 0.5, margin: "0 0.4em" }
  }, "of"), /* @__PURE__ */ React16.createElement("span", {
    style: { fontWeight: 600 }
  }, Math.ceil(totalSlides / 2))) : /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement("span", {
    style: { fontWeight: 600 }
  }, currentSlide + 1), /* @__PURE__ */ React16.createElement("span", {
    style: { opacity: 0.5, margin: "0 0.4em" }
  }, "of"), /* @__PURE__ */ React16.createElement("span", {
    style: { fontWeight: 600 }
  }, totalSlides))), /* @__PURE__ */ React16.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: theme2.space[2]
    }
  }, viewMode === "book" && onCollapseRight && /* @__PURE__ */ React16.createElement(HeaderButton, {
    onClick: onCollapseRight,
    active: collapseLeft,
    theme: theme2,
    title: collapseRight ? "Expand right panel" : collapseLeft ? "Show both panels" : "Focus on right panel"
  }, collapseRight ? /* @__PURE__ */ React16.createElement(PanelRightClose, {
    size: 18,
    style: { transform: "rotate(180deg)" }
  }) : collapseLeft ? /* @__PURE__ */ React16.createElement(Columns, {
    size: 18
  }) : /* @__PURE__ */ React16.createElement(FocusRightIcon, {
    size: 18
  })), /* @__PURE__ */ React16.createElement(HeaderButton, {
    onClick: onNext,
    disabled: currentSlide === totalSlides - 1,
    theme: theme2,
    title: "Next slide",
    minWidth: isMobile ? undefined : "100px",
    width: isMobile ? "36px" : undefined
  }, !isMobile && "Next", /* @__PURE__ */ React16.createElement(ChevronRight, {
    size: 18
  })), showPopoutButton && onPopout && !isPopout && /* @__PURE__ */ React16.createElement(HeaderButton, {
    onClick: onPopout,
    theme: theme2,
    title: "Pop out to new window"
  }, /* @__PURE__ */ React16.createElement(ExternalLink, {
    size: 18
  })), isPopout && onClose && /* @__PURE__ */ React16.createElement(HeaderButton, {
    onClick: onClose,
    theme: theme2,
    title: "Close window"
  }, /* @__PURE__ */ React16.createElement(X2, {
    size: 18
  })), showFullscreenButton && !showPopoutButton && /* @__PURE__ */ React16.createElement(HeaderButton, {
    onClick: onToggleFullscreen,
    disabled: isMobile,
    theme: theme2,
    title: isMobile ? "Fullscreen not available on mobile" : isFullscreen ? "Exit fullscreen (F)" : "Enter fullscreen (F)"
  }, isFullscreen ? /* @__PURE__ */ React16.createElement(Minimize2, {
    size: 18
  }) : /* @__PURE__ */ React16.createElement(Maximize2, {
    size: 18
  }))));
};

// industryMarkdown/components/SlideSearchBar.tsx
import { Search, X as X3 } from "lucide-react";
import React17, { useRef as useRef9, useEffect as useEffect9 } from "react";
var SlideSearchBar = ({
  showSearch,
  searchQuery,
  setSearchQuery,
  searchResults,
  currentSearchResult,
  searchStartSlide,
  slideTitles,
  theme: theme2,
  onResultClick,
  onClose,
  onClear
}) => {
  const searchInputRef = useRef9(null);
  useEffect9(() => {
    if (showSearch && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [showSearch]);
  return /* @__PURE__ */ React17.createElement("div", {
    style: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      height: "56px",
      backgroundColor: theme2.colors.backgroundSecondary,
      borderTop: `1px solid ${theme2.colors.border}`,
      transform: showSearch ? "translateY(0)" : "translateY(100%)",
      transition: "transform 0.2s ease-out",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      padding: `0 ${theme2.space[3]}px`,
      gap: theme2.space[3]
    }
  }, /* @__PURE__ */ React17.createElement(Search, {
    size: 20,
    style: { color: theme2.colors.textSecondary, flexShrink: 0 }
  }), /* @__PURE__ */ React17.createElement("input", {
    ref: searchInputRef,
    type: "text",
    value: searchQuery,
    onChange: (e2) => setSearchQuery(e2.target.value),
    placeholder: "Search slides...",
    style: {
      flex: "0 0 auto",
      width: "240px",
      padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
      backgroundColor: theme2.colors.background,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: theme2.colors.text,
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.body,
      outline: "none"
    },
    onFocus: (e2) => {
      e2.currentTarget.style.borderColor = theme2.colors.primary;
    },
    onBlur: (e2) => {
      e2.currentTarget.style.borderColor = theme2.colors.border;
    }
  }), searchQuery && /* @__PURE__ */ React17.createElement("div", {
    style: {
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.body,
      flexShrink: 0
    }
  }, searchResults.length > 0 ? /* @__PURE__ */ React17.createElement(React17.Fragment, null, searchResults.reduce((sum, r2) => sum + r2.count, 0), " matches in ", searchResults.length, " ", "slide", searchResults.length !== 1 ? "s" : "") : "No results"), /* @__PURE__ */ React17.createElement("div", {
    style: {
      flex: 1,
      display: "flex",
      gap: theme2.space[1],
      overflowX: "auto",
      overflowY: "hidden",
      alignItems: "center",
      minHeight: "32px",
      padding: `0 ${theme2.space[1]}px`
    }
  }, searchQuery && !searchResults.some((r2) => r2.slideIndex === searchStartSlide) && /* @__PURE__ */ React17.createElement("div", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: theme2.space[1],
      padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
      backgroundColor: theme2.colors.backgroundSecondary,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[2],
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.monospace,
      whiteSpace: "nowrap",
      flexShrink: 0,
      opacity: 0.7
    }
  }, /* @__PURE__ */ React17.createElement("span", {
    style: { fontWeight: 600 }
  }, "#", searchStartSlide + 1, " (start)"), /* @__PURE__ */ React17.createElement("span", {
    style: { opacity: 0.8 }
  }, "(no matches)")), searchResults.map((result, index) => /* @__PURE__ */ React17.createElement("button", {
    key: result.slideIndex,
    onClick: () => onResultClick(index, result.slideIndex),
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: theme2.space[1],
      padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
      backgroundColor: currentSearchResult === index ? theme2.colors.primary : theme2.colors.background,
      border: `1px solid ${currentSearchResult === index ? theme2.colors.primary : theme2.colors.border}`,
      borderRadius: theme2.radii[2],
      color: currentSearchResult === index ? theme2.colors.background : theme2.colors.text,
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.monospace,
      cursor: "pointer",
      transition: "all 0.15s ease",
      whiteSpace: "nowrap",
      flexShrink: 0
    },
    onMouseOver: (e2) => {
      if (currentSearchResult !== index) {
        e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
      }
    },
    onMouseOut: (e2) => {
      if (currentSearchResult !== index) {
        e2.currentTarget.style.backgroundColor = theme2.colors.background;
      }
    },
    title: `Slide ${result.slideIndex + 1}: ${slideTitles[result.slideIndex]}`
  }, /* @__PURE__ */ React17.createElement("span", {
    style: { fontWeight: 600 }
  }, "#", result.slideIndex + 1), /* @__PURE__ */ React17.createElement("span", {
    style: { opacity: 0.8 }
  }, "(", result.count, " match", result.count !== 1 ? "es" : "", ")")))), searchQuery && onClear && /* @__PURE__ */ React17.createElement("button", {
    onClick: () => {
      onClear();
      searchInputRef.current?.focus();
    },
    style: {
      display: "flex",
      alignItems: "center",
      padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
      backgroundColor: "transparent",
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.body,
      cursor: "pointer",
      transition: "all 0.2s ease",
      flexShrink: 0
    },
    onMouseOver: (e2) => {
      e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
    },
    onMouseOut: (e2) => {
      e2.currentTarget.style.backgroundColor = "transparent";
    },
    title: "Clear search"
  }, "Clear"), /* @__PURE__ */ React17.createElement("button", {
    onClick: onClose,
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "32px",
      height: "32px",
      backgroundColor: "transparent",
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: theme2.colors.textSecondary,
      cursor: "pointer",
      transition: "all 0.2s ease",
      flexShrink: 0
    },
    onMouseOver: (e2) => {
      e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
    },
    onMouseOut: (e2) => {
      e2.currentTarget.style.backgroundColor = "transparent";
    },
    title: "Close search (Esc)"
  }, /* @__PURE__ */ React17.createElement(X3, {
    size: 16
  })));
};

// industryMarkdown/components/SlidePresentation.tsx
var SlidePresentation = ({
  slides,
  initialSlide = 0,
  onSlideChange,
  onCheckboxChange,
  showNavigation = true,
  showSlideCounter = true,
  showFullscreenButton = false,
  showPopoutButton = false,
  isPopout = false,
  containerHeight = "100%",
  tocDisplayMode = "overlay",
  tocSidebarPosition = "left",
  initialTocOpen,
  onPopout,
  onClose,
  slideIdPrefix = "slide",
  enableHtmlPopout = true,
  enableKeyboardScrolling = true,
  autoFocusOnVisible = true,
  onLinkClick,
  handleRunBashCommand,
  handlePromptCopy,
  fontSizeScale,
  theme: theme2
}) => {
  const [isMobile, setIsMobile] = useState11(false);
  useEffect10(() => {
    const checkMobile = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const effectiveTocDisplayMode = isMobile ? "overlay" : tocDisplayMode;
  const defaultTocOpen = initialTocOpen ?? effectiveTocDisplayMode === "sidebar";
  const [currentSlide, setCurrentSlide] = useState11(initialSlide);
  const [isFullscreen, setIsFullscreen] = useState11(false);
  const [showTOC, setShowTOC] = useState11(defaultTocOpen);
  const [showSearch, setShowSearch] = useState11(false);
  const [searchQuery, setSearchQuery] = useState11("");
  const [searchResults, setSearchResults] = useState11([]);
  const [currentSearchResult, setCurrentSearchResult] = useState11(-1);
  const [searchStartSlide, setSearchStartSlide] = useState11(0);
  const containerRef = useRef10(null);
  const slideTitles = extractAllSlideTitles(slides);
  const navigateToSlide = useCallback3((slideIndex) => {
    if (slideIndex >= 0 && slideIndex < slides.length) {
      setCurrentSlide(slideIndex);
      onSlideChange?.(slideIndex);
      if (effectiveTocDisplayMode === "overlay") {
        setShowTOC(false);
      }
    }
  }, [slides.length, onSlideChange, effectiveTocDisplayMode]);
  useEffect10(() => {
    if (!searchQuery.trim()) {
      setSearchResults([]);
      setCurrentSearchResult(-1);
      return;
    }
    const query = searchQuery.toLowerCase();
    const results = [];
    slides.forEach((slide, index) => {
      const slideText = slide.toLowerCase();
      const matches = slideText.split(query).length - 1;
      if (matches > 0) {
        results.push({ slideIndex: index, count: matches });
      }
    });
    setSearchResults(results);
    setCurrentSearchResult(-1);
  }, [searchQuery, slides]);
  const navigateToSearchResult = useCallback3((resultIndex) => {
    if (searchResults.length === 0)
      return;
    let newIndex = resultIndex;
    if (currentSearchResult === -1) {
      newIndex = resultIndex < 0 ? searchResults.length - 1 : 0;
    } else {
      newIndex = (resultIndex % searchResults.length + searchResults.length) % searchResults.length;
    }
    setCurrentSearchResult(newIndex);
    const targetSlide = searchResults[newIndex].slideIndex;
    if (targetSlide !== currentSlide) {
      navigateToSlide(targetSlide);
    }
  }, [searchResults, navigateToSlide, currentSlide, currentSearchResult]);
  const closeSearch = useCallback3(() => {
    setShowSearch(false);
  }, []);
  const clearSearch = useCallback3(() => {
    setSearchQuery("");
    setSearchResults([]);
    setCurrentSearchResult(-1);
    setSearchStartSlide(0);
  }, []);
  const goToPreviousSlide = useCallback3(() => {
    navigateToSlide(currentSlide - 1);
  }, [currentSlide, navigateToSlide]);
  const goToNextSlide = useCallback3(() => {
    navigateToSlide(currentSlide + 1);
  }, [currentSlide, navigateToSlide]);
  const toggleFullscreen = useCallback3(() => {
    if (!containerRef.current)
      return;
    if (!isFullscreen) {
      containerRef.current.requestFullscreen?.();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen?.();
      setIsFullscreen(false);
    }
  }, [isFullscreen]);
  useEffect10(() => {
    const handleKeyDown = (event) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        if (showSearch && (event.key === "Tab" || event.key === "Enter" || event.key === "Escape")) {} else {
          return;
        }
      }
      if ((event.metaKey || event.ctrlKey) && (event.key === "f" || event.key === "F")) {
        event.preventDefault();
        event.stopPropagation();
        if (!showSearch) {
          setSearchStartSlide(currentSlide);
          setShowSearch(true);
        } else {
          closeSearch();
        }
        return;
      }
      if (showSearch) {
        switch (event.key) {
          case "Escape":
            event.preventDefault();
            closeSearch();
            return;
          case "Tab":
            event.preventDefault();
            if (event.shiftKey) {
              navigateToSearchResult(currentSearchResult - 1);
            } else {
              navigateToSearchResult(currentSearchResult + 1);
            }
            return;
          case "Enter":
            event.preventDefault();
            if (currentSearchResult >= 0 && currentSearchResult < searchResults.length) {
              const targetSlide = searchResults[currentSearchResult].slideIndex;
              if (targetSlide !== currentSlide) {
                navigateToSlide(targetSlide);
              }
            }
            closeSearch();
            return;
        }
        return;
      }
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          goToPreviousSlide();
          break;
        case "ArrowRight":
          event.preventDefault();
          goToNextSlide();
          break;
        case " ":
          event.preventDefault();
          goToNextSlide();
          break;
        case "Enter":
          event.preventDefault();
          goToNextSlide();
          break;
        case "Backspace":
          event.preventDefault();
          goToPreviousSlide();
          break;
        case "Home":
          event.preventDefault();
          navigateToSlide(0);
          break;
        case "End":
          event.preventDefault();
          navigateToSlide(slides.length - 1);
          break;
        case "f":
        case "F":
          if (!event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            toggleFullscreen();
          }
          break;
        case "Escape":
          if (showTOC) {
            event.preventDefault();
            setShowTOC(false);
          }
          break;
        case "t":
        case "T":
          if (!event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            setShowTOC((prev) => !prev);
          }
          break;
      }
      if (!event.ctrlKey && !event.metaKey && !event.altKey) {
        const num = parseInt(event.key);
        if (num >= 1 && num <= 9 && num <= slides.length) {
          event.preventDefault();
          navigateToSlide(num - 1);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    goToPreviousSlide,
    goToNextSlide,
    navigateToSlide,
    slides.length,
    toggleFullscreen,
    showTOC,
    showSearch,
    closeSearch,
    navigateToSearchResult,
    currentSearchResult,
    tocDisplayMode
  ]);
  useEffect10(() => {
    if (currentSlide >= slides.length && slides.length > 0) {
      setCurrentSlide(slides.length - 1);
    }
  }, [slides.length, currentSlide]);
  return /* @__PURE__ */ React18.createElement("div", {
    ref: containerRef,
    style: {
      height: containerHeight,
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme2.colors.background,
      position: "relative"
    }
  }, showNavigation && /* @__PURE__ */ React18.createElement(SlideNavigationHeader, {
    currentSlide,
    totalSlides: slides.length,
    showTOC,
    isFullscreen,
    showSlideCounter,
    showFullscreenButton,
    showPopoutButton,
    isPopout,
    theme: theme2,
    tocDisplayMode: effectiveTocDisplayMode,
    isMobile,
    onPrevious: goToPreviousSlide,
    onNext: goToNextSlide,
    onToggleTOC: () => setShowTOC((prev) => !prev),
    onToggleFullscreen: toggleFullscreen,
    onPopout,
    onClose
  }), /* @__PURE__ */ React18.createElement("div", {
    style: {
      flex: 1,
      overflow: "hidden",
      position: "relative",
      display: "flex"
    }
  }, effectiveTocDisplayMode === "sidebar" ? /* @__PURE__ */ React18.createElement(R, {
    key: `toc-${tocSidebarPosition}`,
    collapsed: !showTOC,
    collapsibleSide: tocSidebarPosition,
    leftPanel: tocSidebarPosition === "left" ? /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: theme2.colors.backgroundSecondary,
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        backgroundColor: theme2.colors.background,
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    }, /* @__PURE__ */ React18.createElement("h3", {
      style: {
        margin: 0,
        fontSize: theme2.fontSizes[3],
        fontFamily: theme2.fonts.heading,
        color: theme2.colors.text,
        fontWeight: 600
      }
    }, "Table of Contents"), /* @__PURE__ */ React18.createElement("p", {
      style: {
        margin: `${theme2.space[1]}px 0 0 0`,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        fontFamily: theme2.fonts.body
      }
    }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React18.createElement("div", {
      style: { padding: theme2.space[2] }
    }, slideTitles.map((title, index) => /* @__PURE__ */ React18.createElement("button", {
      key: index,
      onClick: () => navigateToSlide(index),
      style: {
        display: "block",
        width: "100%",
        padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
        marginBottom: theme2.space[1],
        backgroundColor: currentSlide === index ? theme2.colors.primary : "transparent",
        border: "none",
        borderRadius: theme2.radii[1],
        color: currentSlide === index ? theme2.colors.background : theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body,
        textAlign: "left",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative"
      },
      onMouseOver: (e2) => {
        if (currentSlide !== index) {
          e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
        }
      },
      onMouseOut: (e2) => {
        if (currentSlide !== index) {
          e2.currentTarget.style.backgroundColor = "transparent";
        }
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
    }, /* @__PURE__ */ React18.createElement("span", {
      style: {
        display: "inline-block",
        minWidth: "24px",
        fontSize: theme2.fontSizes[0],
        fontFamily: theme2.fonts.monospace,
        opacity: 0.6
      }
    }, index + 1, "."), /* @__PURE__ */ React18.createElement("span", {
      style: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, title)), currentSlide === index && /* @__PURE__ */ React18.createElement("div", {
      style: {
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        width: "3px",
        height: "60%",
        backgroundColor: currentSlide === index ? theme2.colors.background : theme2.colors.primary,
        borderRadius: "0 2px 2px 0"
      }
    }))))) : /* @__PURE__ */ React18.createElement("div", {
      style: { height: "100%", width: "100%", position: "relative" }
    }, slides.length > 0 ? /* @__PURE__ */ React18.createElement(IndustryMarkdownSlide, {
      content: slides[currentSlide] || "",
      slideIdPrefix: `${slideIdPrefix}-${currentSlide}`,
      slideIndex: currentSlide,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined
    }) : /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.muted,
        fontSize: theme2.fontSizes[2],
        fontFamily: theme2.fonts.body
      }
    }, "No slides available")),
    rightPanel: tocSidebarPosition === "right" ? /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: theme2.colors.backgroundSecondary,
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        backgroundColor: theme2.colors.background,
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    }, /* @__PURE__ */ React18.createElement("h3", {
      style: {
        margin: 0,
        fontSize: theme2.fontSizes[3],
        fontFamily: theme2.fonts.heading,
        color: theme2.colors.text,
        fontWeight: 600
      }
    }, "Table of Contents"), /* @__PURE__ */ React18.createElement("p", {
      style: {
        margin: `${theme2.space[1]}px 0 0 0`,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        fontFamily: theme2.fonts.body
      }
    }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React18.createElement("div", {
      style: { padding: theme2.space[2] }
    }, slideTitles.map((title, index) => /* @__PURE__ */ React18.createElement("button", {
      key: index,
      onClick: () => navigateToSlide(index),
      style: {
        display: "block",
        width: "100%",
        padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
        marginBottom: theme2.space[1],
        backgroundColor: currentSlide === index ? theme2.colors.primary : "transparent",
        border: "none",
        borderRadius: theme2.radii[1],
        color: currentSlide === index ? theme2.colors.background : theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body,
        textAlign: "left",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative"
      },
      onMouseOver: (e2) => {
        if (currentSlide !== index) {
          e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
        }
      },
      onMouseOut: (e2) => {
        if (currentSlide !== index) {
          e2.currentTarget.style.backgroundColor = "transparent";
        }
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
    }, /* @__PURE__ */ React18.createElement("span", {
      style: {
        display: "inline-block",
        minWidth: "24px",
        fontSize: theme2.fontSizes[0],
        fontFamily: theme2.fonts.monospace,
        opacity: 0.6
      }
    }, index + 1, "."), /* @__PURE__ */ React18.createElement("span", {
      style: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, title)), currentSlide === index && /* @__PURE__ */ React18.createElement("div", {
      style: {
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        width: "3px",
        height: "60%",
        backgroundColor: currentSlide === index ? theme2.colors.background : theme2.colors.primary,
        borderRadius: "0 2px 2px 0"
      }
    }))))) : /* @__PURE__ */ React18.createElement("div", {
      style: { height: "100%", width: "100%", position: "relative" }
    }, slides.length > 0 ? /* @__PURE__ */ React18.createElement(IndustryMarkdownSlide, {
      content: slides[currentSlide] || "",
      slideIdPrefix: `${slideIdPrefix}-${currentSlide}`,
      slideIndex: currentSlide,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined
    }) : /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.muted,
        fontSize: theme2.fontSizes[2],
        fontFamily: theme2.fonts.body
      }
    }, "No slides available")),
    defaultSize: tocSidebarPosition === "left" ? 20 : 80,
    minSize: 15,
    showCollapseButton: false,
    theme: theme2
  }) : /* @__PURE__ */ React18.createElement(React18.Fragment, null, effectiveTocDisplayMode === "overlay" && /* @__PURE__ */ React18.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      width: "300px",
      backgroundColor: theme2.colors.backgroundSecondary,
      borderRight: `1px solid ${theme2.colors.border}`,
      transform: showTOC ? "translateX(0)" : "translateX(-100%)",
      transition: "transform 0.3s ease",
      zIndex: 10,
      overflowY: "auto",
      overflowX: "hidden"
    }
  }, /* @__PURE__ */ React18.createElement("div", {
    style: {
      padding: theme2.space[3],
      borderBottom: `1px solid ${theme2.colors.border}`,
      backgroundColor: theme2.colors.background,
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, /* @__PURE__ */ React18.createElement("h3", {
    style: {
      margin: 0,
      fontSize: theme2.fontSizes[3],
      fontFamily: theme2.fonts.heading,
      color: theme2.colors.text,
      fontWeight: 600
    }
  }, "Table of Contents"), /* @__PURE__ */ React18.createElement("p", {
    style: {
      margin: `${theme2.space[1]}px 0 0 0`,
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.body
    }
  }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React18.createElement("div", {
    style: { padding: theme2.space[2] }
  }, slideTitles.map((title, index) => /* @__PURE__ */ React18.createElement("button", {
    key: index,
    onClick: () => navigateToSlide(index),
    style: {
      display: "block",
      width: "100%",
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      marginBottom: theme2.space[1],
      backgroundColor: currentSlide === index ? theme2.colors.primary : "transparent",
      border: "none",
      borderRadius: theme2.radii[1],
      color: currentSlide === index ? theme2.colors.background : theme2.colors.text,
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.body,
      textAlign: "left",
      cursor: "pointer",
      transition: "all 0.2s ease",
      position: "relative"
    },
    onMouseOver: (e2) => {
      if (currentSlide !== index) {
        e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
      }
    },
    onMouseOut: (e2) => {
      if (currentSlide !== index) {
        e2.currentTarget.style.backgroundColor = "transparent";
      }
    }
  }, /* @__PURE__ */ React18.createElement("div", {
    style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
  }, /* @__PURE__ */ React18.createElement("span", {
    style: {
      display: "inline-block",
      minWidth: "24px",
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.monospace,
      opacity: 0.6
    }
  }, index + 1, "."), /* @__PURE__ */ React18.createElement("span", {
    style: {
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, title)), currentSlide === index && /* @__PURE__ */ React18.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: "50%",
      transform: "translateY(-50%)",
      width: "3px",
      height: "60%",
      backgroundColor: currentSlide === index ? theme2.colors.background : theme2.colors.primary,
      borderRadius: "0 2px 2px 0"
    }
  }))))), effectiveTocDisplayMode === "overlay" && showTOC && /* @__PURE__ */ React18.createElement("div", {
    onClick: () => setShowTOC(false),
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      zIndex: 9,
      cursor: "pointer"
    }
  }), /* @__PURE__ */ React18.createElement("div", {
    style: {
      flex: 1,
      position: "relative"
    }
  }, slides.length > 0 ? /* @__PURE__ */ React18.createElement(IndustryMarkdownSlide, {
    content: slides[currentSlide] || "",
    slideIdPrefix: `${slideIdPrefix}-${currentSlide}`,
    slideIndex: currentSlide,
    isVisible: true,
    theme: theme2,
    onCheckboxChange,
    enableHtmlPopout,
    enableKeyboardScrolling,
    autoFocusOnVisible,
    onLinkClick,
    handleRunBashCommand,
    handlePromptCopy,
    fontSizeScale,
    searchQuery: showSearch ? searchQuery : undefined
  }) : /* @__PURE__ */ React18.createElement("div", {
    style: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme2.colors.muted,
      fontSize: theme2.fontSizes[2],
      fontFamily: theme2.fonts.body
    }
  }, "No slides available")))), showNavigation && slides.length > 1 && /* @__PURE__ */ React18.createElement("div", {
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "2px",
      backgroundColor: theme2.colors.border,
      opacity: 0.3
    }
  }, /* @__PURE__ */ React18.createElement("div", {
    style: {
      height: "100%",
      width: `${(currentSlide + 1) / slides.length * 100}%`,
      backgroundColor: theme2.colors.primary,
      transition: "width 0.3s ease"
    }
  })), /* @__PURE__ */ React18.createElement(SlideSearchBar, {
    showSearch,
    searchQuery,
    setSearchQuery,
    searchResults,
    currentSearchResult,
    searchStartSlide,
    slideTitles,
    theme: theme2,
    onResultClick: (index, slideIndex) => {
      setCurrentSearchResult(index);
      navigateToSlide(slideIndex);
    },
    onClose: closeSearch,
    onClear: clearSearch
  }));
};
// industryMarkdown/components/SlidePresentationBook.tsx
import React19, { useState as useState12, useCallback as useCallback4, useRef as useRef11, useEffect as useEffect11 } from "react";
var SlidePresentationBook = ({
  slides,
  initialSlide = 0,
  onSlideChange,
  onCheckboxChange,
  showNavigation = true,
  showSlideCounter = true,
  showFullscreenButton = false,
  showPopoutButton = false,
  isPopout = false,
  containerHeight = "100%",
  viewMode = "single",
  tocDisplayMode,
  tocSidebarPosition = "left",
  initialTocOpen,
  onPopout,
  onClose,
  slideIdPrefix = "slide",
  enableHtmlPopout = true,
  enableKeyboardScrolling = true,
  autoFocusOnVisible = true,
  onLinkClick,
  handleRunBashCommand,
  handlePromptCopy,
  fontSizeScale,
  theme: theme2,
  repositoryInfo,
  width
}) => {
  const [isMobile, setIsMobile] = useState12(false);
  useEffect11(() => {
    const checkMobile = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const effectiveTocDisplayMode = isMobile && viewMode === "single" ? "overlay" : tocDisplayMode ?? (viewMode === "single" ? "sidebar" : "overlay");
  const defaultTocOpen = initialTocOpen ?? false;
  const adjustedInitialSlide = viewMode === "book" ? Math.floor(initialSlide / 2) * 2 : initialSlide;
  const [currentSlide, setCurrentSlide] = useState12(adjustedInitialSlide);
  const [isFullscreen, setIsFullscreen] = useState12(false);
  const [showTOC, setShowTOC] = useState12(defaultTocOpen);
  const [showSearch, setShowSearch] = useState12(false);
  const [searchQuery, setSearchQuery] = useState12("");
  const [searchResults, setSearchResults] = useState12([]);
  const [currentSearchResult, setCurrentSearchResult] = useState12(-1);
  const [searchStartSlide, setSearchStartSlide] = useState12(0);
  const [collapsedSide, setCollapsedSide] = useState12(null);
  const [lastInteractedSide, setLastInteractedSide] = useState12("left");
  const containerRef = useRef11(null);
  const slideTitles = extractAllSlideTitles(slides);
  const stepSize = viewMode === "book" ? 2 : 1;
  const navigateToSlide = useCallback4((slideIndex) => {
    const targetSlide = viewMode === "book" ? Math.floor(slideIndex / 2) * 2 : slideIndex;
    if (targetSlide >= 0 && targetSlide < slides.length) {
      setCurrentSlide(targetSlide);
      onSlideChange?.(targetSlide);
      if (effectiveTocDisplayMode === "overlay") {
        setShowTOC(false);
      }
    }
  }, [slides.length, onSlideChange, viewMode, effectiveTocDisplayMode]);
  useEffect11(() => {
    if (!searchQuery.trim()) {
      setSearchResults([]);
      setCurrentSearchResult(-1);
      return;
    }
    const query = searchQuery.toLowerCase();
    const results = [];
    slides.forEach((slide, index) => {
      const slideText = slide.toLowerCase();
      const matches = slideText.split(query).length - 1;
      if (matches > 0) {
        results.push({ slideIndex: index, count: matches });
      }
    });
    setSearchResults(results);
    setCurrentSearchResult(-1);
  }, [searchQuery, slides]);
  const navigateToSearchResult = useCallback4((resultIndex) => {
    if (searchResults.length === 0)
      return;
    let newIndex = resultIndex;
    if (currentSearchResult === -1) {
      newIndex = resultIndex < 0 ? searchResults.length - 1 : 0;
    } else {
      newIndex = (resultIndex % searchResults.length + searchResults.length) % searchResults.length;
    }
    setCurrentSearchResult(newIndex);
    const targetSlide = searchResults[newIndex].slideIndex;
    if (targetSlide !== currentSlide) {
      navigateToSlide(targetSlide);
    }
  }, [searchResults, navigateToSlide, currentSlide, currentSearchResult]);
  const closeSearch = useCallback4(() => {
    setShowSearch(false);
  }, []);
  const clearSearch = useCallback4(() => {
    setSearchQuery("");
    setSearchResults([]);
    setCurrentSearchResult(-1);
    setSearchStartSlide(0);
  }, []);
  const goToPreviousSlide = useCallback4(() => {
    navigateToSlide(currentSlide - stepSize);
  }, [currentSlide, navigateToSlide, stepSize]);
  const goToNextSlide = useCallback4(() => {
    navigateToSlide(currentSlide + stepSize);
  }, [currentSlide, navigateToSlide, stepSize]);
  const handleCollapseLeft = useCallback4(() => {
    if (collapsedSide === "left") {
      setCollapsedSide(null);
    } else if (collapsedSide === "right") {
      setCollapsedSide(null);
    } else {
      setLastInteractedSide("right");
      setCollapsedSide("right");
    }
  }, [collapsedSide]);
  const handleCollapseRight = useCallback4(() => {
    if (collapsedSide === "right") {
      setCollapsedSide(null);
    } else if (collapsedSide === "left") {
      setCollapsedSide(null);
    } else {
      setLastInteractedSide("left");
      setCollapsedSide("left");
    }
  }, [collapsedSide]);
  const toggleFullscreen = useCallback4(() => {
    if (!containerRef.current)
      return;
    if (!isFullscreen) {
      containerRef.current.requestFullscreen?.();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen?.();
      setIsFullscreen(false);
    }
  }, [isFullscreen]);
  useEffect11(() => {
    const handleKeyDown = (event) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        if (showSearch && (event.key === "Tab" || event.key === "Enter" || event.key === "Escape")) {} else {
          return;
        }
      }
      if ((event.metaKey || event.ctrlKey) && (event.key === "f" || event.key === "F")) {
        event.preventDefault();
        event.stopPropagation();
        if (!showSearch) {
          setSearchStartSlide(currentSlide);
          setShowSearch(true);
        } else {
          closeSearch();
        }
        return;
      }
      if (showSearch) {
        switch (event.key) {
          case "Escape":
            event.preventDefault();
            closeSearch();
            return;
          case "Tab":
            event.preventDefault();
            if (event.shiftKey) {
              navigateToSearchResult(currentSearchResult - 1);
            } else {
              navigateToSearchResult(currentSearchResult + 1);
            }
            return;
          case "Enter":
            event.preventDefault();
            if (currentSearchResult >= 0 && currentSearchResult < searchResults.length) {
              const targetSlide = searchResults[currentSearchResult].slideIndex;
              if (targetSlide !== currentSlide) {
                navigateToSlide(targetSlide);
              }
            }
            closeSearch();
            return;
        }
        return;
      }
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          goToPreviousSlide();
          break;
        case "ArrowRight":
          event.preventDefault();
          goToNextSlide();
          break;
        case " ":
          event.preventDefault();
          goToNextSlide();
          break;
        case "Enter":
          event.preventDefault();
          goToNextSlide();
          break;
        case "Backspace":
          event.preventDefault();
          goToPreviousSlide();
          break;
        case "Home":
          event.preventDefault();
          navigateToSlide(0);
          break;
        case "End":
          event.preventDefault();
          navigateToSlide(slides.length - 1);
          break;
        case "f":
        case "F":
          if (!event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            toggleFullscreen();
          }
          break;
        case "Escape":
          if (showTOC) {
            event.preventDefault();
            setShowTOC(false);
          }
          break;
        case "t":
        case "T":
          if (!event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            setShowTOC((prev) => !prev);
          }
          break;
      }
      if (!event.ctrlKey && !event.metaKey && !event.altKey) {
        const num = parseInt(event.key);
        if (num >= 1 && num <= 9 && num <= slides.length) {
          event.preventDefault();
          navigateToSlide(num - 1);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    goToPreviousSlide,
    goToNextSlide,
    navigateToSlide,
    slides.length,
    toggleFullscreen,
    showTOC,
    showSearch,
    closeSearch,
    navigateToSearchResult,
    currentSearchResult,
    searchResults,
    effectiveTocDisplayMode
  ]);
  useEffect11(() => {
    if (currentSlide >= slides.length && slides.length > 0) {
      setCurrentSlide(slides.length - 1);
    }
  }, [slides.length, currentSlide]);
  const leftSlideIndex = currentSlide;
  const rightSlideIndex = viewMode === "book" ? currentSlide + 1 : -1;
  return /* @__PURE__ */ React19.createElement("div", {
    ref: containerRef,
    style: {
      height: containerHeight,
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme2.colors.background,
      position: "relative"
    }
  }, showNavigation && /* @__PURE__ */ React19.createElement(SlideNavigationHeader, {
    currentSlide,
    totalSlides: slides.length,
    showTOC,
    isFullscreen,
    showSlideCounter,
    showFullscreenButton,
    showPopoutButton,
    isPopout,
    isMobile,
    theme: theme2,
    viewMode,
    tocDisplayMode: effectiveTocDisplayMode,
    collapseLeft: collapsedSide === "left",
    collapseRight: collapsedSide === "right",
    onPrevious: goToPreviousSlide,
    onNext: goToNextSlide,
    onToggleTOC: () => setShowTOC((prev) => !prev),
    onToggleFullscreen: toggleFullscreen,
    onPopout,
    onClose,
    onCollapseLeft: handleCollapseLeft,
    onCollapseRight: handleCollapseRight
  }), /* @__PURE__ */ React19.createElement("div", {
    style: {
      flex: 1,
      width: "100%",
      overflow: "hidden",
      position: "relative",
      display: "flex"
    }
  }, viewMode === "single" && effectiveTocDisplayMode === "sidebar" ? /* @__PURE__ */ React19.createElement(R, {
    key: `toc-${tocSidebarPosition}`,
    collapsed: !showTOC,
    collapsibleSide: tocSidebarPosition,
    leftPanel: tocSidebarPosition === "left" ? /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: theme2.colors.backgroundSecondary,
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /* @__PURE__ */ React19.createElement("div", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        backgroundColor: theme2.colors.background,
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    }, /* @__PURE__ */ React19.createElement("h3", {
      style: {
        margin: 0,
        fontSize: theme2.fontSizes[3],
        fontFamily: theme2.fonts.heading,
        color: theme2.colors.text,
        fontWeight: 600
      }
    }, "Table of Contents"), /* @__PURE__ */ React19.createElement("p", {
      style: {
        margin: `${theme2.space[1]}px 0 0 0`,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        fontFamily: theme2.fonts.body
      }
    }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React19.createElement("div", {
      style: { padding: theme2.space[2] }
    }, slideTitles.map((title, index) => {
      const isCurrentPage = index === currentSlide;
      return /* @__PURE__ */ React19.createElement("button", {
        key: index,
        onClick: () => navigateToSlide(index),
        style: {
          display: "block",
          width: "100%",
          padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
          marginBottom: theme2.space[1],
          backgroundColor: isCurrentPage ? theme2.colors.primary : "transparent",
          border: "none",
          borderRadius: theme2.radii[1],
          color: isCurrentPage ? theme2.colors.background : theme2.colors.text,
          fontSize: theme2.fontSizes[1],
          fontFamily: theme2.fonts.body,
          textAlign: "left",
          cursor: "pointer",
          transition: "all 0.2s ease",
          position: "relative"
        },
        onMouseOver: (e2) => {
          if (!isCurrentPage) {
            e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
          }
        },
        onMouseOut: (e2) => {
          if (!isCurrentPage) {
            e2.currentTarget.style.backgroundColor = "transparent";
          }
        }
      }, /* @__PURE__ */ React19.createElement("div", {
        style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
      }, /* @__PURE__ */ React19.createElement("span", {
        style: {
          display: "inline-block",
          minWidth: "24px",
          fontSize: theme2.fontSizes[0],
          fontFamily: theme2.fonts.monospace,
          opacity: 0.6
        }
      }, index + 1, "."), /* @__PURE__ */ React19.createElement("span", {
        style: {
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }, title)), isCurrentPage && /* @__PURE__ */ React19.createElement("div", {
        style: {
          position: "absolute",
          left: 0,
          top: "50%",
          transform: "translateY(-50%)",
          width: "3px",
          height: "60%",
          backgroundColor: isCurrentPage ? theme2.colors.background : theme2.colors.primary,
          borderRadius: "0 2px 2px 0"
        }
      }));
    }))) : /* @__PURE__ */ React19.createElement("div", {
      style: { height: "100%", width: "100%", position: "relative" }
    }, slides.length > 0 ? /* @__PURE__ */ React19.createElement(IndustryMarkdownSlide, {
      content: slides[leftSlideIndex] || "",
      slideIdPrefix: `${slideIdPrefix}-${leftSlideIndex}`,
      slideIndex: leftSlideIndex,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined,
      repositoryInfo,
      containerWidth: width
    }) : /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.muted,
        fontSize: theme2.fontSizes[2],
        fontFamily: theme2.fonts.body
      }
    }, "No slides available")),
    rightPanel: tocSidebarPosition === "right" ? /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: theme2.colors.backgroundSecondary,
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /* @__PURE__ */ React19.createElement("div", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        backgroundColor: theme2.colors.background,
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    }, /* @__PURE__ */ React19.createElement("h3", {
      style: {
        margin: 0,
        fontSize: theme2.fontSizes[3],
        fontFamily: theme2.fonts.heading,
        color: theme2.colors.text,
        fontWeight: 600
      }
    }, "Table of Contents"), /* @__PURE__ */ React19.createElement("p", {
      style: {
        margin: `${theme2.space[1]}px 0 0 0`,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        fontFamily: theme2.fonts.body
      }
    }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React19.createElement("div", {
      style: { padding: theme2.space[2] }
    }, slideTitles.map((title, index) => {
      const isCurrentPage = index === currentSlide;
      return /* @__PURE__ */ React19.createElement("button", {
        key: index,
        onClick: () => navigateToSlide(index),
        style: {
          display: "block",
          width: "100%",
          padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
          marginBottom: theme2.space[1],
          backgroundColor: isCurrentPage ? theme2.colors.primary : "transparent",
          border: "none",
          borderRadius: theme2.radii[1],
          color: isCurrentPage ? theme2.colors.background : theme2.colors.text,
          fontSize: theme2.fontSizes[1],
          fontFamily: theme2.fonts.body,
          textAlign: "left",
          cursor: "pointer",
          transition: "all 0.2s ease",
          position: "relative"
        },
        onMouseOver: (e2) => {
          if (!isCurrentPage) {
            e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
          }
        },
        onMouseOut: (e2) => {
          if (!isCurrentPage) {
            e2.currentTarget.style.backgroundColor = "transparent";
          }
        }
      }, /* @__PURE__ */ React19.createElement("div", {
        style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
      }, /* @__PURE__ */ React19.createElement("span", {
        style: {
          display: "inline-block",
          minWidth: "24px",
          fontSize: theme2.fontSizes[0],
          fontFamily: theme2.fonts.monospace,
          opacity: 0.6
        }
      }, index + 1, "."), /* @__PURE__ */ React19.createElement("span", {
        style: {
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }, title)), isCurrentPage && /* @__PURE__ */ React19.createElement("div", {
        style: {
          position: "absolute",
          left: 0,
          top: "50%",
          transform: "translateY(-50%)",
          width: "3px",
          height: "60%",
          backgroundColor: isCurrentPage ? theme2.colors.background : theme2.colors.primary,
          borderRadius: "0 2px 2px 0"
        }
      }));
    }))) : /* @__PURE__ */ React19.createElement("div", {
      style: { height: "100%", width: "100%", position: "relative" }
    }, slides.length > 0 ? /* @__PURE__ */ React19.createElement(IndustryMarkdownSlide, {
      content: slides[leftSlideIndex] || "",
      slideIdPrefix: `${slideIdPrefix}-${leftSlideIndex}`,
      slideIndex: leftSlideIndex,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined,
      repositoryInfo,
      containerWidth: width
    }) : /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.muted,
        fontSize: theme2.fontSizes[2],
        fontFamily: theme2.fonts.body
      }
    }, "No slides available")),
    defaultSize: tocSidebarPosition === "left" ? 20 : 80,
    minSize: 15,
    showCollapseButton: false,
    theme: theme2
  }) : /* @__PURE__ */ React19.createElement(React19.Fragment, null, effectiveTocDisplayMode === "overlay" && /* @__PURE__ */ React19.createElement("div", {
    style: {
      position: "absolute",
      ...isMobile ? {
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        maxHeight: "70vh",
        borderTop: `1px solid ${theme2.colors.border}`,
        borderRadius: `${theme2.radii[2]}px ${theme2.radii[2]}px 0 0`,
        transform: showTOC ? "translateY(0)" : "translateY(100%)"
      } : {
        top: 0,
        left: 0,
        bottom: 0,
        width: "300px",
        borderRight: `1px solid ${theme2.colors.border}`,
        transform: showTOC ? "translateX(0)" : "translateX(-100%)"
      },
      backgroundColor: theme2.colors.backgroundSecondary,
      transition: "transform 0.3s ease",
      zIndex: 10,
      overflowY: "auto",
      overflowX: "hidden"
    }
  }, /* @__PURE__ */ React19.createElement("div", {
    style: {
      padding: theme2.space[3],
      borderBottom: `1px solid ${theme2.colors.border}`,
      backgroundColor: theme2.colors.background,
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, /* @__PURE__ */ React19.createElement("h3", {
    style: {
      margin: 0,
      fontSize: theme2.fontSizes[3],
      fontFamily: theme2.fonts.heading,
      color: theme2.colors.text,
      fontWeight: 600
    }
  }, "Table of Contents"), /* @__PURE__ */ React19.createElement("p", {
    style: {
      margin: `${theme2.space[1]}px 0 0 0`,
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.body
    }
  }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React19.createElement("div", {
    style: { padding: theme2.space[2] }
  }, slideTitles.map((title, index) => {
    const isCurrentPage = viewMode === "book" ? index === leftSlideIndex || index === rightSlideIndex : index === currentSlide;
    return /* @__PURE__ */ React19.createElement("button", {
      key: index,
      onClick: () => navigateToSlide(index),
      style: {
        display: "block",
        width: "100%",
        padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
        marginBottom: theme2.space[1],
        backgroundColor: isCurrentPage ? theme2.colors.primary : "transparent",
        border: "none",
        borderRadius: theme2.radii[1],
        color: isCurrentPage ? theme2.colors.background : theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body,
        textAlign: "left",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative"
      },
      onMouseOver: (e2) => {
        if (!isCurrentPage) {
          e2.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
        }
      },
      onMouseOut: (e2) => {
        if (!isCurrentPage) {
          e2.currentTarget.style.backgroundColor = "transparent";
        }
      }
    }, /* @__PURE__ */ React19.createElement("div", {
      style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
    }, /* @__PURE__ */ React19.createElement("span", {
      style: {
        display: "inline-block",
        minWidth: "24px",
        fontSize: theme2.fontSizes[0],
        fontFamily: theme2.fonts.monospace,
        opacity: 0.6
      }
    }, index + 1, "."), /* @__PURE__ */ React19.createElement("span", {
      style: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, title)), isCurrentPage && /* @__PURE__ */ React19.createElement("div", {
      style: {
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        width: "3px",
        height: "60%",
        backgroundColor: isCurrentPage ? theme2.colors.background : theme2.colors.primary,
        borderRadius: "0 2px 2px 0"
      }
    }));
  }))), effectiveTocDisplayMode === "overlay" && showTOC && /* @__PURE__ */ React19.createElement("div", {
    onClick: () => setShowTOC(false),
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      zIndex: 9,
      cursor: "pointer"
    }
  }), /* @__PURE__ */ React19.createElement("div", {
    style: {
      flex: 1,
      position: "relative",
      display: "flex",
      gap: 0,
      padding: 0,
      backgroundColor: theme2.colors.background,
      width: "100%"
    }
  }, slides.length > 0 ? viewMode === "book" && slides.length > 1 ? /* @__PURE__ */ React19.createElement(R, {
    key: `${lastInteractedSide}-${collapsedSide}`,
    collapsed: collapsedSide !== null,
    collapsibleSide: lastInteractedSide,
    leftPanel: /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        position: "relative",
        overflow: "hidden"
      }
    }, /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: "transparent",
        borderRadius: 0,
        boxShadow: "none",
        overflowY: "auto",
        overflowX: "auto",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    }, /* @__PURE__ */ React19.createElement(IndustryMarkdownSlide, {
      content: slides[leftSlideIndex] || "",
      slideIdPrefix: `${slideIdPrefix}-${leftSlideIndex}`,
      slideIndex: leftSlideIndex,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined,
      repositoryInfo,
      containerWidth: width,
      transparentBackground: true,
      additionalPadding: {
        left: `${theme2.space[4]}px`,
        right: `${theme2.space[2]}px`,
        top: `${theme2.space[3]}px`
      },
      disableScroll: false
    }))),
    rightPanel: rightSlideIndex < slides.length ? /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        position: "relative",
        overflow: "hidden"
      }
    }, /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: "transparent",
        borderRadius: 0,
        boxShadow: "none",
        overflowY: "auto",
        overflowX: "auto",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    }, /* @__PURE__ */ React19.createElement(IndustryMarkdownSlide, {
      content: slides[rightSlideIndex] || "",
      slideIdPrefix: `${slideIdPrefix}-${rightSlideIndex}`,
      slideIndex: rightSlideIndex,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined,
      repositoryInfo,
      containerWidth: width,
      transparentBackground: true,
      additionalPadding: {
        left: `${theme2.space[2]}px`,
        right: `${theme2.space[4]}px`,
        top: `${theme2.space[3]}px`
      },
      disableScroll: false
    }))) : /* @__PURE__ */ React19.createElement("div", {
      style: {
        height: "100%",
        backgroundColor: theme2.colors.background,
        borderRadius: 0,
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.textSecondary || theme2.colors.muted,
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body,
        fontStyle: "italic",
        padding: `0 ${theme2.space[4]}px 0 ${theme2.space[2]}px`
      }
    }, "End of presentation"),
    defaultSize: 50,
    minSize: 30,
    showCollapseButton: false,
    theme: theme2
  }) : /* @__PURE__ */ React19.createElement("div", {
    style: {
      flex: "1 1 0%",
      backgroundColor: "transparent",
      borderRadius: 0,
      boxShadow: "none",
      overflowY: "auto",
      overflowX: "hidden",
      position: "relative",
      width: "100%",
      ...viewMode === "book" && slides.length === 1 ? {
        display: "flex",
        justifyContent: "center"
      } : {}
    }
  }, /* @__PURE__ */ React19.createElement("div", {
    style: {
      ...viewMode === "book" && slides.length === 1 ? {
        width: "50%",
        maxWidth: "800px",
        minWidth: "400px",
        height: "100%"
      } : {
        width: "100%",
        height: "100%"
      }
    }
  }, /* @__PURE__ */ React19.createElement(IndustryMarkdownSlide, {
    content: slides[leftSlideIndex] || "",
    slideIdPrefix: `${slideIdPrefix}-${leftSlideIndex}`,
    slideIndex: leftSlideIndex,
    isVisible: true,
    theme: theme2,
    onCheckboxChange,
    enableHtmlPopout,
    enableKeyboardScrolling,
    autoFocusOnVisible,
    onLinkClick,
    handleRunBashCommand,
    handlePromptCopy,
    fontSizeScale,
    searchQuery: showSearch ? searchQuery : undefined,
    repositoryInfo,
    containerWidth: width,
    transparentBackground: false,
    disableScroll: false
  }))) : /* @__PURE__ */ React19.createElement("div", {
    style: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme2.colors.muted,
      fontSize: theme2.fontSizes[2],
      fontFamily: theme2.fonts.body
    }
  }, "No slides available")), viewMode === "book" && slides.length > 1 && /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement("div", {
    style: {
      position: "absolute",
      bottom: theme2.space[3],
      left: theme2.space[3],
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace
    }
  }, leftSlideIndex + 1), rightSlideIndex < slides.length && /* @__PURE__ */ React19.createElement("div", {
    style: {
      position: "absolute",
      bottom: theme2.space[3],
      right: theme2.space[3],
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace
    }
  }, rightSlideIndex + 1)))), showNavigation && slides.length > 1 && /* @__PURE__ */ React19.createElement("div", {
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "2px",
      backgroundColor: theme2.colors.border,
      opacity: 0.3
    }
  }, /* @__PURE__ */ React19.createElement("div", {
    style: {
      height: "100%",
      width: `${(currentSlide + stepSize) / slides.length * 100}%`,
      backgroundColor: theme2.colors.primary,
      transition: "width 0.3s ease"
    }
  })), /* @__PURE__ */ React19.createElement(SlideSearchBar, {
    showSearch,
    searchQuery,
    setSearchQuery,
    searchResults,
    currentSearchResult,
    searchStartSlide,
    slideTitles,
    theme: theme2,
    onResultClick: (index, slideIndex) => {
      setCurrentSearchResult(index);
      navigateToSlide(slideIndex);
    },
    onClose: closeSearch,
    onClear: clearSearch
  }));
};
// industryMarkdown/components/DocumentView.tsx
import React20, { useRef as useRef12 } from "react";
var DocumentView = ({
  content,
  onCheckboxChange,
  maxWidth = "900px",
  width,
  slideIdPrefix = "document",
  enableHtmlPopout = true,
  enableKeyboardScrolling = true,
  autoFocusOnVisible = true,
  onLinkClick,
  handleRunBashCommand,
  handlePromptCopy,
  repositoryInfo,
  fontSizeScale,
  theme: theme2,
  transparentBackground = false,
  editable = false
}) => {
  const containerRef = useRef12(null);
  const backgroundColor = transparentBackground ? "transparent" : theme2.colors.background;
  return /* @__PURE__ */ React20.createElement("div", {
    ref: containerRef,
    style: {
      height: "100%",
      overflow: "auto",
      backgroundColor
    }
  }, /* @__PURE__ */ React20.createElement("div", {
    style: {
      maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth,
      margin: "0 auto",
      height: "100%"
    }
  }, /* @__PURE__ */ React20.createElement(IndustryMarkdownSlide, {
    content,
    slideIdPrefix,
    slideIndex: 0,
    isVisible: true,
    theme: theme2,
    onCheckboxChange,
    enableHtmlPopout,
    enableKeyboardScrolling,
    autoFocusOnVisible,
    onLinkClick,
    handleRunBashCommand,
    fontSizeScale,
    handlePromptCopy,
    repositoryInfo,
    transparentBackground,
    editable,
    containerWidth: width
  })));
};
// industryMarkdown/components/SkillMarkdown.tsx
import React21 from "react";
var formatRelativeTime = (dateString) => {
  try {
    const date = new Date(dateString);
    const now = new Date;
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays === 0)
      return "Today";
    if (diffDays === 1)
      return "Yesterday";
    if (diffDays < 7)
      return `${diffDays} days ago`;
    if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return `${weeks} ${weeks === 1 ? "week" : "weeks"} ago`;
    }
    if (diffDays < 365) {
      const months = Math.floor(diffDays / 30);
      return `${months} ${months === 1 ? "month" : "months"} ago`;
    }
    const years = Math.floor(diffDays / 365);
    return `${years} ${years === 1 ? "year" : "years"} ago`;
  } catch {
    return dateString;
  }
};
var SkillMetadataSection = ({
  metadata,
  theme: theme2
}) => {
  return /* @__PURE__ */ React21.createElement("div", {
    style: {
      borderBottom: `2px solid ${theme2.colors.border}`,
      paddingBottom: theme2.space[3],
      marginBottom: theme2.space[2]
    }
  }, /* @__PURE__ */ React21.createElement("div", {
    style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: theme2.space[2] }
  }, /* @__PURE__ */ React21.createElement("h1", {
    style: {
      fontSize: theme2.fontSizes[6],
      fontWeight: 700,
      margin: 0,
      color: theme2.colors.text,
      fontFamily: theme2.fonts.heading
    }
  }, metadata.name), (metadata.metadata?.["last-updated"] || metadata.license) && /* @__PURE__ */ React21.createElement("div", {
    style: { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: theme2.space[1], marginLeft: theme2.space[3], marginTop: theme2.space[1] }
  }, metadata.metadata?.["last-updated"] && /* @__PURE__ */ React21.createElement("span", {
    style: {
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace,
      fontWeight: 500,
      whiteSpace: "nowrap"
    }
  }, formatRelativeTime(metadata.metadata["last-updated"])), metadata.license && /* @__PURE__ */ React21.createElement("span", {
    style: {
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace,
      fontWeight: 500,
      whiteSpace: "nowrap"
    }
  }, metadata.license))), /* @__PURE__ */ React21.createElement("p", {
    style: {
      fontSize: theme2.fontSizes[3],
      color: theme2.colors.textSecondary,
      margin: 0,
      lineHeight: 1.5,
      fontFamily: theme2.fonts.body
    }
  }, metadata.description));
};
var SkillMarkdown = ({
  content,
  theme: theme2,
  className = "",
  onParsed,
  onError,
  showRawOnError = false,
  containerWidth
}) => {
  const [parsed, setParsed] = React21.useState(null);
  const [error, setError] = React21.useState(null);
  React21.useEffect(() => {
    try {
      const skill = parseSkillMarkdown(content);
      setParsed(skill);
      setError(null);
      onParsed?.(skill);
    } catch (err) {
      const error2 = err instanceof Error ? err : new Error(String(err));
      setError(error2);
      setParsed(null);
      onError?.(error2);
    }
  }, [content, onParsed, onError]);
  if (!theme2 || !theme2.space) {
    return /* @__PURE__ */ React21.createElement("div", {
      className,
      style: { width: "100%", height: "100%" }
    }, /* @__PURE__ */ React21.createElement("div", {
      style: { padding: "2rem", textAlign: "center", color: "#856404" }
    }, "Error: Theme not available. Wrap component in ThemeProvider."));
  }
  if (error) {
    if (showRawOnError) {
      return /* @__PURE__ */ React21.createElement("div", {
        className,
        style: {
          width: "100%",
          height: "100%",
          overflow: "auto",
          background: theme2.colors.background
        }
      }, /* @__PURE__ */ React21.createElement("div", {
        style: { padding: theme2.space[3] }
      }, /* @__PURE__ */ React21.createElement(IndustryMarkdownSlide, {
        content,
        theme: theme2,
        slideIdPrefix: "skill-fallback",
        slideIndex: 0,
        isVisible: true,
        containerWidth
      })));
    }
    return /* @__PURE__ */ React21.createElement("div", {
      className,
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        padding: theme2.space[4],
        background: theme2.colors.background,
        overflow: "auto"
      }
    }, /* @__PURE__ */ React21.createElement("div", {
      style: {
        background: "#fff3cd",
        border: "1px solid #ffc107",
        borderRadius: "8px",
        padding: theme2.space[4],
        maxWidth: "600px"
      }
    }, /* @__PURE__ */ React21.createElement("h2", {
      style: { color: "#856404", marginTop: 0 }
    }, "Failed to parse SKILL.md"), /* @__PURE__ */ React21.createElement("p", {
      style: {
        fontWeight: 600,
        color: "#856404",
        fontSize: theme2.fontSizes[0],
        textTransform: "uppercase",
        letterSpacing: "0.5px"
      }
    }, error instanceof SkillParseError && "Parse Error", error instanceof SkillValidationError && "Validation Error", !(error instanceof SkillParseError) && !(error instanceof SkillValidationError) && "Error"), /* @__PURE__ */ React21.createElement("p", {
      style: { color: "#856404", margin: `${theme2.space[3]} 0` }
    }, error.message), error instanceof SkillValidationError && error.field && /* @__PURE__ */ React21.createElement("p", {
      style: {
        fontFamily: theme2.fonts.monospace,
        color: "#856404",
        fontSize: theme2.fontSizes[0]
      }
    }, "Field: ", error.field)));
  }
  if (!parsed) {
    return /* @__PURE__ */ React21.createElement("div", {
      className,
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        padding: theme2.space[4],
        color: theme2.colors.textSecondary,
        fontStyle: "italic",
        background: theme2.colors.background
      }
    }, "Loading...");
  }
  return /* @__PURE__ */ React21.createElement("div", {
    className,
    style: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: theme2.colors.background
    }
  }, /* @__PURE__ */ React21.createElement("div", {
    style: { padding: theme2.space[3], paddingBottom: 0 }
  }, /* @__PURE__ */ React21.createElement(SkillMetadataSection, {
    metadata: parsed.metadata,
    theme: theme2
  })), /* @__PURE__ */ React21.createElement("div", {
    style: { flex: 1, overflow: "auto", padding: theme2.space[3], paddingTop: 0 }
  }, /* @__PURE__ */ React21.createElement("div", {
    style: { display: "flex", gap: theme2.space[4], alignItems: "flex-start" }
  }, /* @__PURE__ */ React21.createElement("div", {
    style: { flex: 1, minWidth: 0 }
  }, /* @__PURE__ */ React21.createElement(IndustryMarkdownSlide, {
    content: parsed.body,
    theme: theme2,
    slideIdPrefix: "skill-body",
    slideIndex: 0,
    isVisible: true,
    containerWidth
  })), (parsed.metadata.compatibility || parsed.metadata["allowed-tools"] || parsed.metadata.metadata) && /* @__PURE__ */ React21.createElement("div", {
    style: {
      width: "300px",
      flexShrink: 0,
      padding: theme2.space[3],
      background: theme2.colors.background,
      position: "sticky",
      top: theme2.space[3]
    }
  }, parsed.metadata.compatibility && /* @__PURE__ */ React21.createElement("div", {
    style: { marginBottom: theme2.space[3] }
  }, /* @__PURE__ */ React21.createElement("div", {
    style: {
      fontFamily: theme2.fonts.heading,
      fontWeight: 600,
      fontSize: theme2.fontSizes[0],
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: theme2.colors.textSecondary,
      marginBottom: theme2.space[1]
    }
  }, "Compatibility"), /* @__PURE__ */ React21.createElement("div", {
    style: { fontSize: theme2.fontSizes[1], color: theme2.colors.text, fontFamily: theme2.fonts.body }
  }, parsed.metadata.compatibility)), parsed.metadata["allowed-tools"] && parsed.metadata["allowed-tools"].length > 0 && /* @__PURE__ */ React21.createElement("div", {
    style: { marginBottom: theme2.space[3] }
  }, /* @__PURE__ */ React21.createElement("div", {
    style: {
      fontFamily: theme2.fonts.heading,
      fontWeight: 600,
      fontSize: theme2.fontSizes[0],
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: theme2.colors.textSecondary,
      marginBottom: theme2.space[1]
    }
  }, "Allowed Tools"), /* @__PURE__ */ React21.createElement("div", {
    style: { display: "flex", flexWrap: "wrap", gap: theme2.space[1] }
  }, parsed.metadata["allowed-tools"].map((tool, index) => /* @__PURE__ */ React21.createElement("span", {
    key: index,
    style: {
      display: "inline-block",
      paddingTop: theme2.space[2],
      paddingBottom: theme2.space[2],
      paddingLeft: theme2.space[3],
      paddingRight: theme2.space[3],
      background: theme2.colors.primary,
      color: theme2.colors.background,
      borderRadius: "4px",
      fontSize: theme2.fontSizes[0],
      fontWeight: 500,
      fontFamily: theme2.fonts.monospace
    }
  }, tool)))), parsed.metadata.metadata && Object.keys(parsed.metadata.metadata).length > 0 && /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement("div", {
    style: {
      fontFamily: theme2.fonts.heading,
      fontWeight: 600,
      fontSize: theme2.fontSizes[0],
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: theme2.colors.textSecondary,
      marginBottom: theme2.space[1]
    }
  }, "Metadata"), /* @__PURE__ */ React21.createElement("div", {
    style: { display: "flex", flexDirection: "column", gap: theme2.space[1] }
  }, Object.entries(parsed.metadata.metadata).filter(([key]) => key !== "last-updated").map(([key, value]) => /* @__PURE__ */ React21.createElement("div", {
    key
  }, /* @__PURE__ */ React21.createElement("div", {
    style: {
      fontSize: theme2.fontSizes[0],
      fontWeight: 600,
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.body
    }
  }, key, ":"), /* @__PURE__ */ React21.createElement("div", {
    style: {
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.text,
      fontFamily: theme2.fonts.monospace
    }
  }, value)))))))));
};
// industryMarkdown/utils/presentationUtils.ts
var extractSlideTitle3 = extractSlideTitle;
function parseMarkdownIntoPresentationFromSource(source) {
  let presentation;
  switch (source.type) {
    case MarkdownSourceType.WORKSPACE_FILE:
    case MarkdownSourceType.GITHUB_FILE:
    case MarkdownSourceType.DRAFT:
      presentation = parseMarkdownIntoPresentation2(source.content, source.repositoryInfo);
      break;
    default:
      throw new Error(`Unsupported source type: ${source.type}`);
  }
  presentation.source = source;
  return presentation;
}
function createGithubFileSource(content, repositoryInfo) {
  return {
    type: MarkdownSourceType.GITHUB_FILE,
    content,
    repositoryInfo,
    editable: false,
    deletable: false
  };
}
function parseMarkdownIntoPresentation2(markdownContent, repositoryInfo) {
  return parseMarkdownIntoPresentation(markdownContent, repositoryInfo);
}
function createPresentationWithErrorMessage(errorMessage) {
  const errorMessageMarkdown = `# Error Loading Markdown:

${errorMessage}`;
  return {
    slides: [
      {
        id: "error",
        title: extractSlideTitle3(errorMessageMarkdown),
        location: {
          startLine: 0,
          endLine: 0,
          content: errorMessageMarkdown
        },
        chunks: parseMarkdownChunks(errorMessageMarkdown, "slide-error")
      }
    ],
    originalContent: errorMessageMarkdown
  };
}
function reconstructMarkdownContent(presentation) {
  return presentation.slides.map((slide, index) => {
    if (index === 0 && !slide.location.content.startsWith("##")) {
      return slide.location.content;
    }
    return slide.location.content.startsWith("##") ? slide.location.content : `## ${slide.location.content}`;
  }).join(`

`);
}
function getAllSlideTitles(presentation) {
  return presentation.slides.map((slide) => slide.title);
}
function findSlideByTitle(presentation, title) {
  return presentation.slides.find((slide) => slide.title === title);
}
function findSlideIndexByTitle(presentation, title) {
  return presentation.slides.findIndex((slide) => slide.title === title);
}
function updateSlideTitle(slide, newTitle) {
  return {
    ...slide,
    title: newTitle
  };
}
function serializePresentationToMarkdown(presentation) {
  return reconstructMarkdownContent(presentation);
}
function updateSlideContent(slide, newContent) {
  return {
    ...slide,
    location: {
      ...slide.location,
      content: newContent
    },
    title: extractSlideTitle3(newContent),
    chunks: parseMarkdownChunks(newContent, slide.id.split("-")[1] || "slide")
  };
}
function updatePresentationSlide(presentation, index, newContent) {
  const updatedSlides = [...presentation.slides];
  if (index >= 0 && index < updatedSlides.length) {
    updatedSlides[index] = updateSlideContent(updatedSlides[index], newContent);
  }
  return {
    ...presentation,
    slides: updatedSlides,
    originalContent: reconstructMarkdownContent({
      ...presentation,
      slides: updatedSlides
    })
  };
}
export {
  withTheme,
  useIndustryHtmlModal,
  updateSlideTitle,
  updateSlideContent,
  updatePresentationSlide,
  terminalTheme,
  slateTheme,
  serializePresentationToMarkdown,
  scaleThemeFonts,
  resetFontScale,
  regalTheme,
  reconstructMarkdownContent,
  parseMarkdownIntoPresentationFromSource,
  parseMarkdownIntoPresentation2 as parseMarkdownIntoPresentation,
  parseMarkdownChunks2 as parseMarkdownChunks,
  matrixTheme,
  matrixMinimalTheme,
  increaseFontScale,
  getAllSlideTitles,
  findSlideIndexByTitle,
  findSlideByTitle,
  extractSlideTitle3 as extractSlideTitle,
  theme as defaultTheme,
  decreaseFontScale,
  createPresentationWithErrorMessage,
  createIndustryMarkdownComponents,
  createGithubFileSource,
  ThemeProvider,
  SlideSearchBar,
  SlidePresentationBook,
  SlidePresentation,
  SlideNavigationHeader,
  SkillMarkdown,
  IndustryZoomableMermaidDiagram,
  IndustryPlaceholderModal,
  IndustryMermaidModal,
  IndustryMarkdownSlide,
  IndustryLazyMermaidDiagram,
  IndustryHtmlModal,
  DocumentView
};
